var mo = Object.defineProperty;
var po = (e, t, n) => t in e ? mo(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var vt = (e, t, n) => po(e, typeof t != "symbol" ? t + "" : t, n);
function ee() {
}
function Vt(e, t) {
  for (const n in t) e[n] = t[n];
  return (
    /** @type {T & S} */
    e
  );
}
function Gn(e) {
  return e();
}
function Jt() {
  return /* @__PURE__ */ Object.create(null);
}
function Se(e) {
  e.forEach(Gn);
}
function ie(e) {
  return typeof e == "function";
}
function se(e, t) {
  return e != e ? t == t : e !== t || e && typeof e == "object" || typeof e == "function";
}
function yo(e) {
  return Object.keys(e).length === 0;
}
function jn(e, ...t) {
  if (e == null) {
    for (const o of t)
      o(void 0);
    return ee;
  }
  const n = e.subscribe(...t);
  return n.unsubscribe ? () => n.unsubscribe() : n;
}
function St(e, t, n) {
  e.$$.on_destroy.push(jn(t, n));
}
function _o(e, t, n, o) {
  if (e) {
    const i = Fn(e, t, n, o);
    return e[0](i);
  }
}
function Fn(e, t, n, o) {
  return e[1] && o ? Vt(n.ctx.slice(), e[1](o(t))) : n.ctx;
}
function wo(e, t, n, o) {
  if (e[2] && o) {
    const i = e[2](o(n));
    if (t.dirty === void 0)
      return i;
    if (typeof i == "object") {
      const s = [], r = Math.max(t.dirty.length, i.length);
      for (let l = 0; l < r; l += 1)
        s[l] = t.dirty[l] | i[l];
      return s;
    }
    return t.dirty | i;
  }
  return t.dirty;
}
function bo(e, t, n, o, i, s) {
  if (i) {
    const r = Fn(t, n, o, s);
    e.p(r, i);
  }
}
function Eo(e) {
  if (e.ctx.length > 32) {
    const t = [], n = e.ctx.length / 32;
    for (let o = 0; o < n; o++)
      t[o] = -1;
    return t;
  }
  return -1;
}
function Qt(e) {
  const t = {};
  for (const n in e) n[0] !== "$" && (t[n] = e[n]);
  return t;
}
function ze(e) {
  return e ?? "";
}
function j(e, t) {
  e.appendChild(t);
}
function B(e, t, n) {
  e.insertBefore(t, n || null);
}
function D(e) {
  e.parentNode && e.parentNode.removeChild(e);
}
function Ye(e, t) {
  for (let n = 0; n < e.length; n += 1)
    e[n] && e[n].d(t);
}
function L(e) {
  return document.createElementNS("http://www.w3.org/2000/svg", e);
}
function zn(e) {
  return document.createTextNode(e);
}
function _e() {
  return zn(" ");
}
function Ae() {
  return zn("");
}
function W(e, t, n, o) {
  return e.addEventListener(t, n, o), () => e.removeEventListener(t, n, o);
}
function c(e, t, n) {
  n == null ? e.removeAttribute(t) : e.getAttribute(t) !== n && e.setAttribute(t, n);
}
function vo(e) {
  return Array.from(e.childNodes);
}
function Te(e, t, n) {
  e.classList.toggle(t, !!n);
}
function So(e, t, { bubbles: n = !1, cancelable: o = !1 } = {}) {
  return new CustomEvent(e, { detail: t, bubbles: n, cancelable: o });
}
let $e;
function xe(e) {
  $e = e;
}
function qn() {
  if (!$e) throw new Error("Function called outside component initialization");
  return $e;
}
function Ue(e) {
  qn().$$.on_mount.push(e);
}
function Be() {
  const e = qn();
  return (t, n, { cancelable: o = !1 } = {}) => {
    const i = e.$$.callbacks[t];
    if (i) {
      const s = So(
        /** @type {string} */
        t,
        n,
        { cancelable: o }
      );
      return i.slice().forEach((r) => {
        r.call(e, s);
      }), !s.defaultPrevented;
    }
    return !0;
  };
}
function ue(e, t) {
  const n = e.$$.callbacks[t.type];
  n && n.slice().forEach((o) => o.call(this, t));
}
const je = [], gt = [];
let Ke = [];
const xt = [], Kn = /* @__PURE__ */ Promise.resolve();
let Xt = !1;
function Wn() {
  Xt || (Xt = !0, Kn.then(Jn));
}
function Zn() {
  return Wn(), Kn;
}
function Ht(e) {
  Ke.push(e);
}
const At = /* @__PURE__ */ new Set();
let Xe = 0;
function Jn() {
  if (Xe !== 0)
    return;
  const e = $e;
  do {
    try {
      for (; Xe < je.length; ) {
        const t = je[Xe];
        Xe++, xe(t), Ao(t.$$);
      }
    } catch (t) {
      throw je.length = 0, Xe = 0, t;
    }
    for (xe(null), je.length = 0, Xe = 0; gt.length; ) gt.pop()();
    for (let t = 0; t < Ke.length; t += 1) {
      const n = Ke[t];
      At.has(n) || (At.add(n), n());
    }
    Ke.length = 0;
  } while (je.length);
  for (; xt.length; )
    xt.pop()();
  Xt = !1, At.clear(), xe(e);
}
function Ao(e) {
  if (e.fragment !== null) {
    e.update(), Se(e.before_update);
    const t = e.dirty;
    e.dirty = [-1], e.fragment && e.fragment.p(e.ctx, t), e.after_update.forEach(Ht);
  }
}
function ko(e) {
  const t = [], n = [];
  Ke.forEach((o) => e.indexOf(o) === -1 ? t.push(o) : n.push(o)), n.forEach((o) => o()), Ke = t;
}
const ut = /* @__PURE__ */ new Set();
let Ne;
function we() {
  Ne = {
    r: 0,
    c: [],
    p: Ne
    // parent group
  };
}
function be() {
  Ne.r || Se(Ne.c), Ne = Ne.p;
}
function U(e, t) {
  e && e.i && (ut.delete(e), e.i(t));
}
function H(e, t, n, o) {
  if (e && e.o) {
    if (ut.has(e)) return;
    ut.add(e), Ne.c.push(() => {
      ut.delete(e), o && (n && e.d(1), o());
    }), e.o(t);
  } else o && o();
}
function ve(e) {
  return (e == null ? void 0 : e.length) !== void 0 ? e : Array.from(e);
}
function ae(e) {
  e && e.c();
}
function re(e, t, n) {
  const { fragment: o, after_update: i } = e.$$;
  o && o.m(t, n), Ht(() => {
    const s = e.$$.on_mount.map(Gn).filter(ie);
    e.$$.on_destroy ? e.$$.on_destroy.push(...s) : Se(s), e.$$.on_mount = [];
  }), i.forEach(Ht);
}
function le(e, t) {
  const n = e.$$;
  n.fragment !== null && (ko(n.after_update), Se(n.on_destroy), n.fragment && n.fragment.d(t), n.on_destroy = n.fragment = null, n.ctx = []);
}
function Mo(e, t) {
  e.$$.dirty[0] === -1 && (je.push(e), Wn(), e.$$.dirty.fill(0)), e.$$.dirty[t / 31 | 0] |= 1 << t % 31;
}
function me(e, t, n, o, i, s, r = null, l = [-1]) {
  const a = $e;
  xe(e);
  const u = e.$$ = {
    fragment: null,
    ctx: [],
    // state
    props: s,
    update: ee,
    not_equal: i,
    bound: Jt(),
    // lifecycle
    on_mount: [],
    on_destroy: [],
    on_disconnect: [],
    before_update: [],
    after_update: [],
    context: new Map(t.context || (a ? a.$$.context : [])),
    // everything else
    callbacks: Jt(),
    dirty: l,
    skip_bound: !1,
    root: t.target || a.$$.root
  };
  r && r(u.root);
  let d = !1;
  if (u.ctx = n ? n(e, t.props || {}, (f, h, ...g) => {
    const m = g.length ? g[0] : h;
    return u.ctx && i(u.ctx[f], u.ctx[f] = m) && (!u.skip_bound && u.bound[f] && u.bound[f](m), d && Mo(e, f)), h;
  }) : [], u.update(), d = !0, Se(u.before_update), u.fragment = o ? o(u.ctx) : !1, t.target) {
    if (t.hydrate) {
      const f = vo(t.target);
      u.fragment && u.fragment.l(f), f.forEach(D);
    } else
      u.fragment && u.fragment.c();
    t.intro && U(e.$$.fragment), re(e, t.target, t.anchor), Jn();
  }
  xe(a);
}
class pe {
  constructor() {
    /**
     * ### PRIVATE API
     *
     * Do not use, may change at any time
     *
     * @type {any}
     */
    vt(this, "$$");
    /**
     * ### PRIVATE API
     *
     * Do not use, may change at any time
     *
     * @type {any}
     */
    vt(this, "$$set");
  }
  /** @returns {void} */
  $destroy() {
    le(this, 1), this.$destroy = ee;
  }
  /**
   * @template {Extract<keyof Events, string>} K
   * @param {K} type
   * @param {((e: Events[K]) => void) | null | undefined} callback
   * @returns {() => void}
   */
  $on(t, n) {
    if (!ie(n))
      return ee;
    const o = this.$$.callbacks[t] || (this.$$.callbacks[t] = []);
    return o.push(n), () => {
      const i = o.indexOf(n);
      i !== -1 && o.splice(i, 1);
    };
  }
  /**
   * @param {Partial<Props>} props
   * @returns {void}
   */
  $set(t) {
    this.$$set && !yo(t) && (this.$$.skip_bound = !0, this.$$set(t), this.$$.skip_bound = !1);
  }
}
const To = "4";
typeof window < "u" && (window.__svelte || (window.__svelte = { v: /* @__PURE__ */ new Set() })).v.add(To);
var x = /* @__PURE__ */ ((e) => (e.ELLIPSE = "ELLIPSE", e.MULTIPOLYGON = "MULTIPOLYGON", e.POLYGON = "POLYGON", e.POLYLINE = "POLYLINE", e.RECTANGLE = "RECTANGLE", e.LINE = "LINE", e))(x || {});
function Po(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Qn = { exports: {} };
(function(e) {
  (function() {
    function t(l, a) {
      var u = l.x - a.x, d = l.y - a.y;
      return u * u + d * d;
    }
    function n(l, a, u) {
      var d = a.x, f = a.y, h = u.x - d, g = u.y - f;
      if (h !== 0 || g !== 0) {
        var m = ((l.x - d) * h + (l.y - f) * g) / (h * h + g * g);
        m > 1 ? (d = u.x, f = u.y) : m > 0 && (d += h * m, f += g * m);
      }
      return h = l.x - d, g = l.y - f, h * h + g * g;
    }
    function o(l, a) {
      for (var u = l[0], d = [u], f, h = 1, g = l.length; h < g; h++)
        f = l[h], t(f, u) > a && (d.push(f), u = f);
      return u !== f && d.push(f), d;
    }
    function i(l, a, u, d, f) {
      for (var h = d, g, m = a + 1; m < u; m++) {
        var p = n(l[m], l[a], l[u]);
        p > h && (g = m, h = p);
      }
      h > d && (g - a > 1 && i(l, a, g, d, f), f.push(l[g]), u - g > 1 && i(l, g, u, d, f));
    }
    function s(l, a) {
      var u = l.length - 1, d = [l[0]];
      return i(l, 0, u, a, d), d.push(l[u]), d;
    }
    function r(l, a, u) {
      if (l.length <= 2) return l;
      var d = a !== void 0 ? a * a : 1;
      return l = u ? l : o(l, d), l = s(l, d), l;
    }
    e.exports = r, e.exports.default = r;
  })();
})(Qn);
var Lo = Qn.exports;
const Io = /* @__PURE__ */ Po(Lo), zt = {}, We = (e, t) => zt[e] = t, Gt = (e) => zt[e.type].area(e), Co = (e, t, n, o) => zt[e.type].intersects(e, t, n, o), ge = (e) => {
  let t = 1 / 0, n = 1 / 0, o = -1 / 0, i = -1 / 0;
  return e.forEach(([s, r]) => {
    t = Math.min(t, s), n = Math.min(n, r), o = Math.max(o, s), i = Math.max(i, r);
  }), { minX: t, minY: n, maxX: o, maxY: i };
}, mt = (e) => {
  let t = 0, n = e.length - 1;
  for (let o = 0; o < e.length; o++)
    t += (e[n][0] + e[o][0]) * (e[n][1] - e[o][1]), n = o;
  return Math.abs(0.5 * t);
}, pt = (e, t, n) => {
  let o = !1;
  for (let i = 0, s = e.length - 1; i < e.length; s = i++) {
    const r = e[i][0], l = e[i][1], a = e[s][0], u = e[s][1];
    l > n != u > n && t < (a - r) * (n - l) / (u - l) + r && (o = !o);
  }
  return o;
}, Oo = (e, t = !0) => {
  let n = "M ";
  return e.forEach(([o, i], s) => {
    s === 0 ? n += `${o},${i}` : n += ` L ${o},${i}`;
  }), t && (n += " Z"), n;
}, xn = (e, t = 1) => {
  const n = e.map(([o, i]) => ({ x: o, y: i }));
  return Io(n, t, !0).map((o) => [o.x, o.y]);
}, ft = (e, t) => {
  const n = Math.abs(t[0] - e[0]), o = Math.abs(t[1] - e[1]);
  return Math.sqrt(Math.pow(n, 2) + Math.pow(o, 2));
}, Do = {
  area: (e) => Math.PI * e.geometry.rx * e.geometry.ry,
  intersects: (e, t, n) => {
    const { cx: o, cy: i, rx: s, ry: r } = e.geometry, l = 0, a = Math.cos(l), u = Math.sin(l), d = t - o, f = n - i, h = a * d + u * f, g = u * d - a * f;
    return h * h / (s * s) + g * g / (r * r) <= 1;
  }
};
We(x.ELLIPSE, Do);
const Bo = {
  area: (e) => 0,
  intersects: (e, t, n, o = 2) => {
    const [[i, s], [r, l]] = e.geometry.points, a = Math.abs((l - s) * t - (r - i) * n + r * s - l * i), u = ft([i, s], [r, l]);
    return a / u <= o;
  }
};
We(x.LINE, Bo);
const No = {
  area: (e) => {
    const { polygons: t } = e.geometry;
    return t.reduce((n, o) => {
      const [i, ...s] = o.rings, r = mt(i.points), l = s.reduce((a, u) => a + mt(u.points), 0);
      return n + r - l;
    }, 0);
  },
  intersects: (e, t, n) => {
    const { polygons: o } = e.geometry;
    for (const i of o) {
      const [s, ...r] = i.rings;
      if (pt(s.points, t, n)) {
        let l = !1;
        for (const a of r)
          if (pt(a.points, t, n)) {
            l = !0;
            break;
          }
        if (!l) return !0;
      }
    }
    return !1;
  }
}, dt = (e) => {
  const t = e.reduce((n, o) => [...n, ...o.rings[0].points], []);
  return ge(t);
}, Pe = (e) => e.rings.map((n) => Oo(n.points)).join(" "), Yo = (e) => e.polygons.reduce((t, n) => [
  ...t,
  ...n.rings.reduce((o, i) => [...o, ...i.points], [])
], []), Dr = (e, t = 1) => {
  const n = e.geometry.polygons.map((i) => {
    const s = i.rings.map((l) => {
      const a = xn(l.points, t);
      return {
        ...l,
        points: a
      };
    }), r = ge(s[0].points);
    return {
      ...i,
      rings: s,
      bounds: r
    };
  }), o = dt(n);
  return {
    ...e,
    geometry: {
      ...e.geometry,
      polygons: n,
      bounds: o
    }
  };
};
We(x.MULTIPOLYGON, No);
const Uo = {
  area: (e) => {
    const t = e.geometry.points;
    return mt(t);
  },
  intersects: (e, t, n) => {
    const o = e.geometry.points;
    return pt(o, t, n);
  }
}, Br = (e, t = 1) => {
  const n = xn(e.geometry.points, t), o = ge(n);
  return {
    ...e,
    geometry: {
      ...e.geometry,
      bounds: o,
      points: n
    }
  };
};
We(x.POLYGON, Uo);
const Ro = {
  area: (e) => {
    const t = e.geometry;
    if (!t.closed || t.points.length < 3)
      return 0;
    const n = jt(t.points, t.closed);
    return mt(n);
  },
  intersects: (e, t, n, o = 2) => {
    const i = e.geometry;
    if (i.closed) {
      const s = jt(i.points, i.closed);
      return pt(s, t, n);
    } else
      return Vo(i, [t, n], o);
  }
}, jt = (e, t = !1) => {
  const n = [];
  for (let o = 0; o < e.length; o++) {
    const i = e[o], s = e[(o + 1) % e.length];
    if (n.push(i.point), (o < e.length - 1 || t) && (i.type === "CURVE" || s.type == "CURVE")) {
      const l = $n(
        i.point,
        i.type === "CURVE" && i.outHandle || i.point,
        s.type === "CURVE" && s.inHandle || s.point,
        s.point,
        10
        // number of approximation segments
      );
      n.push(...l.slice(1));
    }
  }
  return n;
}, $n = (e, t, n, o, i = 10) => {
  const s = [];
  for (let r = 0; r <= i; r++) {
    const l = r / i, a = Math.pow(1 - l, 3) * e[0] + 3 * Math.pow(1 - l, 2) * l * t[0] + 3 * (1 - l) * Math.pow(l, 2) * n[0] + Math.pow(l, 3) * o[0], u = Math.pow(1 - l, 3) * e[1] + 3 * Math.pow(1 - l, 2) * l * t[1] + 3 * (1 - l) * Math.pow(l, 2) * n[1] + Math.pow(l, 3) * o[1];
    s.push([a, u]);
  }
  return s;
}, Vo = (e, t, n) => {
  for (let o = 0; o < e.points.length - 1; o++) {
    const i = e.points[o], s = e.points[o + 1];
    if (i.type === "CURVE" || s.type === "CURVE") {
      const l = $n(
        i.point,
        i.type === "CURVE" && i.outHandle || i.point,
        s.type === "CURVE" && s.inHandle || s.point,
        s.point,
        20
        // TODO make configurable? Based on scale factor? Length?
      );
      for (let a = 0; a < l.length - 1; a++)
        if ($t(t, l[a], l[a + 1]) <= n) return !0;
    } else if ($t(t, i.point, s.point) <= n) return !0;
  }
  return !1;
}, $t = (e, t, n) => {
  const [o, i] = e, [s, r] = t, [l, a] = n, u = l - s, d = a - r, f = Math.sqrt(u * u + d * d);
  if (f === 0)
    return Math.sqrt((o - s) * (o - s) + (i - r) * (i - r));
  const h = ((o - s) * u + (i - r) * d) / (f * f);
  return h <= 0 ? Math.sqrt((o - s) * (o - s) + (i - r) * (i - r)) : h >= 1 ? Math.sqrt((o - l) * (o - l) + (i - a) * (i - a)) : Math.abs((a - r) * o - (l - s) * i + l * r - a * s) / f;
}, eo = (e) => {
  if (!e.points || e.points.length === 0)
    return "";
  const t = [], n = e.points[0];
  t.push(`M ${n.point[0]} ${n.point[1]}`);
  for (let o = 1; o < e.points.length; o++) {
    const i = e.points[o], s = e.points[o - 1];
    if (i.type === "CURVE" || s.type === "CURVE") {
      const r = s.type === "CURVE" && s.outHandle || s.point, l = i.type === "CURVE" && i.inHandle || i.point, a = i.point;
      t.push(`C ${r[0]} ${r[1]} ${l[0]} ${l[1]} ${a[0]} ${a[1]}`);
    } else
      t.push(`L ${i.point[0]} ${i.point[1]}`);
  }
  if (e.closed) {
    const o = e.points[e.points.length - 1], i = e.points[0];
    if (o.type === "CURVE" || i.type === "CURVE") {
      const r = o.outHandle || o.point, l = i.inHandle || i.point, a = i.point;
      t.push(`C ${r[0]} ${r[1]} ${l[0]} ${l[1]} ${a[0]} ${a[1]}`);
    }
    t.push("Z");
  }
  return t.join(" ");
};
We(x.POLYLINE, Ro);
const Xo = {
  area: (e) => e.geometry.w * e.geometry.h,
  intersects: (e, t, n) => t >= e.geometry.x && t <= e.geometry.x + e.geometry.w && n >= e.geometry.y && n <= e.geometry.y + e.geometry.h
};
We(x.RECTANGLE, Xo);
const yt = (e) => ht(e.target), ht = (e) => {
  var t, n;
  return (e == null ? void 0 : e.annotation) !== void 0 && ((n = (t = e == null ? void 0 : e.selector) == null ? void 0 : t.geometry) == null ? void 0 : n.bounds) !== void 0;
}, Ho = (e) => (e == null ? void 0 : e.type) === "FragmentSelector" ? !0 : typeof e == "string" ? e.indexOf("#") < 0 ? !1 : /#xywh(?:=(?:pixel:|percent:)?)(.+?),(.+?),(.+?),(.+)$/i.test(e) : !1, Go = (e, t = !1) => {
  const n = typeof e == "string" ? e : e.value, o = /(xywh)=(?:(pixel|percent):)?:?(.+?),(.+?),(.+?),(.+)*/g, i = [...n.matchAll(o)][0];
  if (!i) throw new Error("Not a MediaFragment: " + n);
  const [s, r, l, a, u, d, f] = i;
  if (r !== "xywh") throw new Error("Unsupported MediaFragment: " + n);
  if (l && l !== "pixel") throw new Error(`Unsupported MediaFragment unit: ${l}`);
  const [h, g, m, p] = [a, u, d, f].map(parseFloat);
  return {
    type: x.RECTANGLE,
    geometry: {
      x: h,
      y: g,
      w: m,
      h: p,
      bounds: {
        minX: h,
        minY: t ? g - p : g,
        maxX: h + m,
        maxY: t ? g : g + p
      }
    }
  };
}, jo = (e) => {
  const { x: t, y: n, w: o, h: i } = e;
  return {
    type: "FragmentSelector",
    conformsTo: "http://www.w3.org/TR/media-frags/",
    value: `xywh=pixel:${t},${n},${o},${i}`
  };
}, to = "http://www.w3.org/2000/svg", en = (e) => {
  const t = (o) => {
    Array.from(o.attributes).forEach((i) => {
      i.name.startsWith("on") && o.removeAttribute(i.name);
    });
  }, n = e.getElementsByTagName("script");
  return Array.from(n).reverse().forEach((o) => o.parentNode.removeChild(o)), Array.from(e.querySelectorAll("*")).forEach(t), e;
}, Fo = (e) => {
  const o = new XMLSerializer().serializeToString(e.documentElement).replace("<svg>", `<svg xmlns="${to}">`);
  return new DOMParser().parseFromString(o, "image/svg+xml").documentElement;
}, _t = (e) => {
  const n = new DOMParser().parseFromString(e, "image/svg+xml"), o = n.lookupPrefix(to), i = n.lookupNamespaceURI(null);
  return o || i ? en(n).firstChild : en(Fo(n)).firstChild;
}, zo = (e) => {
  const t = no(e), n = [];
  let o = [], i = [0, 0];
  for (const s of t)
    switch (s.type.toUpperCase()) {
      case "M":
        o.length > 0 && (n.push({ points: o }), o = []), i = [s.args[0], s.args[1]], o.push([...i]);
        break;
      case "L":
        i = [s.args[0], s.args[1]], o.push([...i]);
        break;
      case "H":
        i = [s.args[0], i[1]], o.push([...i]);
        break;
      case "V":
        i = [i[0], s.args[0]], o.push([...i]);
        break;
      case "C":
        i = [s.args[4], s.args[5]], o.push([...i]);
        break;
      case "Z":
        break;
      default:
        console.warn(`Unsupported SVG path command: ${s.type}`);
        break;
    }
  if (o.length > 2 && n.push({ points: o }), n.length > 0) {
    const s = ge(n[0].points);
    return { rings: n, bounds: s };
  }
}, qo = (e) => {
  const { point: t, inHandle: n, outHandle: o } = e;
  if (!n || !o) return !1;
  const i = n[0] - t[0], s = n[1] - t[1], r = o[0] - t[0], l = o[1] - t[1], a = i * l - s * r;
  return Math.abs(a) < 0.01;
}, Ko = (e) => {
  const t = no(e);
  let n = [], o = [0, 0], i = !1;
  for (let r = 0; r < t.length; r++) {
    const l = t[r];
    switch (l.type.toUpperCase()) {
      case "M":
        o = [l.args[0], l.args[1]], n.push({
          type: "CORNER",
          point: [...o]
        });
        break;
      case "L":
        o = [l.args[0], l.args[1]], n.push({
          type: "CORNER",
          point: [...o]
        });
        break;
      case "C":
        const a = [l.args[0], l.args[1]], u = [l.args[2], l.args[3]], d = [l.args[4], l.args[5]];
        if (n.length > 0) {
          const h = n[n.length - 1];
          (a[0] !== h.point[0] || a[1] !== h.point[1]) && (h.type = "CURVE", h.outHandle = a);
        }
        const f = {
          type: u[0] !== d[0] || u[1] !== d[1] ? "CURVE" : "CORNER",
          point: d
        };
        f.type === "CURVE" && (f.inHandle = u), n.push(f), o = d;
        break;
      case "Z":
        i = !0;
        break;
      default:
        console.warn(`Unsupported SVG path command: ${l.type}`);
        break;
    }
  }
  n = n.map((r) => qo(r) ? { ...r, locked: !0 } : r);
  const s = ge(jt(n, i));
  return {
    points: n,
    closed: i,
    bounds: s
  };
}, no = (e) => {
  const t = [], n = e.replace(/,/g, " ").trim(), o = /([MmLlHhVvCcZz])\s*([^MmLlHhVvCcZz]*)/g;
  let i;
  for (; (i = o.exec(n)) !== null; ) {
    const [, s, r] = i, l = r.trim() === "" ? [] : r.trim().split(/\s+/).map(Number).filter((a) => !isNaN(a));
    t.push({
      type: s,
      args: l
    });
  }
  return t;
}, Wo = (e) => {
  const [t, n, o] = e.match(/(<polygon points=["|'])([^("|')]*)/) || [], i = o.split(" ").map((s) => s.split(",").map(parseFloat));
  return {
    type: x.POLYGON,
    geometry: {
      points: i,
      bounds: ge(i)
    }
  };
}, Zo = (e) => {
  const t = _t(e), n = parseFloat(t.getAttribute("cx")), o = parseFloat(t.getAttribute("cy")), i = parseFloat(t.getAttribute("rx")), s = parseFloat(t.getAttribute("ry")), r = {
    minX: n - i,
    minY: o - s,
    maxX: n + i,
    maxY: o + s
  };
  return {
    type: x.ELLIPSE,
    geometry: {
      cx: n,
      cy: o,
      rx: i,
      ry: s,
      bounds: r
    }
  };
}, Jo = (e) => {
  const t = _t(e), n = parseFloat(t.getAttribute("x1")), o = parseFloat(t.getAttribute("x2")), i = parseFloat(t.getAttribute("y1")), s = parseFloat(t.getAttribute("y2")), r = {
    minX: Math.min(n, o),
    minY: Math.min(i, s),
    maxX: Math.max(n, o),
    maxY: Math.max(i, s)
  };
  return {
    type: x.LINE,
    geometry: {
      points: [[n, i], [o, s]],
      bounds: r
    }
  };
}, Qo = (e) => {
  const t = _t(e), n = t.nodeName === "path" ? t : Array.from(t.querySelectorAll("path"))[0], o = n == null ? void 0 : n.getAttribute("d");
  if (!o)
    throw new Error("Could not parse SVG path");
  const i = Ko(o);
  if (!i)
    throw new Error("Could not parse SVG path");
  return {
    type: x.POLYLINE,
    geometry: i
  };
}, xo = (e) => {
  const t = _t(e), i = (t.nodeName === "path" ? [t] : Array.from(t.querySelectorAll("path"))).map((a) => a.getAttribute("d") || "").map((a) => zo(a)).filter(Boolean), s = i.reduce((a, u) => [...a, ...u.rings[0].points], []), r = ge(s);
  return i.length === 1 && i[0].rings.length === 1 ? {
    type: x.POLYGON,
    geometry: {
      points: s,
      bounds: r
    }
  } : {
    type: x.MULTIPOLYGON,
    geometry: {
      polygons: i,
      bounds: r
    }
  };
}, $o = (e) => {
  const t = typeof e == "string" ? e : e.value;
  if (t.includes("<polygon points="))
    return Wo(t);
  if (t.includes("<path ") && (t.includes(" C ") || !t.includes("Z")))
    return Qo(t);
  if (t.includes("<path "))
    return xo(t);
  if (t.includes("<ellipse "))
    return Zo(t);
  if (t.includes("<line "))
    return Jo(t);
  throw "Unsupported SVG shape: " + t;
}, ei = (e) => `<g>${e.polygons.map((n) => `<path fill-rule="evenodd" d="${Pe(n)}" />`).join("")}</g>`, ti = (e) => {
  let t;
  switch (e.type) {
    case x.POLYGON: {
      const n = e.geometry, { points: o } = n;
      t = `<svg><polygon points="${o.map((i) => i.join(",")).join(" ")}" /></svg>`;
      break;
    }
    case x.ELLIPSE: {
      const n = e.geometry;
      t = `<svg><ellipse cx="${n.cx}" cy="${n.cy}" rx="${n.rx}" ry="${n.ry}" /></svg>`;
      break;
    }
    case x.MULTIPOLYGON: {
      const n = e.geometry;
      t = `<svg>${ei(n)}</svg>`;
      break;
    }
    case x.LINE: {
      const n = e.geometry, [[o, i], [s, r]] = n.points;
      t = `<svg><line x1="${o}" y1="${i}" x2="${s}" y2="${r}" /></svg>`;
      break;
    }
    case x.POLYLINE:
      t = `<svg><path d="${eo(e.geometry)}" /></svg>`;
  }
  if (t)
    return { type: "SvgSelector", value: t };
  throw `Unsupported shape type: ${e.type}`;
}, de = [];
for (let e = 0; e < 256; ++e)
  de.push((e + 256).toString(16).slice(1));
function ni(e, t = 0) {
  return (de[e[t + 0]] + de[e[t + 1]] + de[e[t + 2]] + de[e[t + 3]] + "-" + de[e[t + 4]] + de[e[t + 5]] + "-" + de[e[t + 6]] + de[e[t + 7]] + "-" + de[e[t + 8]] + de[e[t + 9]] + "-" + de[e[t + 10]] + de[e[t + 11]] + de[e[t + 12]] + de[e[t + 13]] + de[e[t + 14]] + de[e[t + 15]]).toLowerCase();
}
let kt;
const oi = new Uint8Array(16);
function ii() {
  if (!kt) {
    if (typeof crypto > "u" || !crypto.getRandomValues)
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    kt = crypto.getRandomValues.bind(crypto);
  }
  return kt(oi);
}
const si = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), tn = { randomUUID: si };
function ri(e, t, n) {
  var i;
  e = e || {};
  const o = e.random ?? ((i = e.rng) == null ? void 0 : i.call(e)) ?? ii();
  if (o.length < 16)
    throw new Error("Random bytes length must be >= 16");
  return o[6] = o[6] & 15 | 64, o[8] = o[8] & 63 | 128, ni(o);
}
function oo(e, t, n) {
  return tn.randomUUID && !e ? tn.randomUUID() : ri(e);
}
var nn = Object.prototype.hasOwnProperty;
function De(e, t) {
  var n, o;
  if (e === t) return !0;
  if (e && t && (n = e.constructor) === t.constructor) {
    if (n === Date) return e.getTime() === t.getTime();
    if (n === RegExp) return e.toString() === t.toString();
    if (n === Array) {
      if ((o = e.length) === t.length)
        for (; o-- && De(e[o], t[o]); ) ;
      return o === -1;
    }
    if (!n || typeof e == "object") {
      o = 0;
      for (n in e)
        if (nn.call(e, n) && ++o && !nn.call(t, n) || !(n in t) || !De(e[n], t[n])) return !1;
      return Object.keys(t).length === o;
    }
  }
  return e !== e && t !== t;
}
let li = Symbol("clean"), Me = [], Oe = 0;
const rt = 4, qt = /* @__NO_SIDE_EFFECTS__ */ (e) => {
  let t = [], n = {
    get() {
      return n.lc || n.listen(() => {
      })(), n.value;
    },
    lc: 0,
    listen(o) {
      return n.lc = t.push(o), () => {
        for (let s = Oe + rt; s < Me.length; )
          Me[s] === o ? Me.splice(s, rt) : s += rt;
        let i = t.indexOf(o);
        ~i && (t.splice(i, 1), --n.lc || n.off());
      };
    },
    notify(o, i) {
      let s = !Me.length;
      for (let r of t)
        Me.push(r, n.value, o, i);
      if (s) {
        for (Oe = 0; Oe < Me.length; Oe += rt)
          Me[Oe](
            Me[Oe + 1],
            Me[Oe + 2],
            Me[Oe + 3]
          );
        Me.length = 0;
      }
    },
    /* It will be called on last listener unsubscribing.
       We will redefine it in onMount and onStop. */
    off() {
    },
    set(o) {
      let i = n.value;
      i !== o && (n.value = o, n.notify(i));
    },
    subscribe(o) {
      let i = n.listen(o);
      return o(n.value), i;
    },
    value: e
  };
  return process.env.NODE_ENV !== "production" && (n[li] = () => {
    t = [], n.lc = 0, n.off();
  }), n;
}, ai = (e) => {
  const t = /* @__PURE__ */ qt(null);
  return e.observe(({ changes: n }) => {
    const o = t.get();
    if (o) {
      (n.deleted || []).some((s) => s.id === o) && t.set(null);
      const i = (n.updated || []).find(({ oldValue: s }) => s.id === o);
      i && t.set(i.newValue.id);
    }
  }), {
    get current() {
      return t.get();
    },
    subscribe: t.subscribe.bind(t),
    set: t.set.bind(t)
  };
};
var io = /* @__PURE__ */ ((e) => (e.EDIT = "EDIT", e.SELECT = "SELECT", e.NONE = "NONE", e))(io || {});
const Mt = { selected: [] }, ci = (e, t, n) => {
  const o = /* @__PURE__ */ qt(Mt);
  let i = t;
  const s = () => {
    De(o.get(), Mt) || o.set(Mt);
  }, r = () => {
    var g;
    return ((g = o.get().selected) == null ? void 0 : g.length) === 0;
  }, l = (g) => {
    if (r())
      return !1;
    const m = typeof g == "string" ? g : g.id;
    return o.get().selected.some((p) => p.id === m);
  }, a = (g, m) => {
    let p;
    if (Array.isArray(g)) {
      if (p = g.map((E) => e.getAnnotation(E)).filter(Boolean), p.length < g.length) {
        console.warn("Invalid selection: " + g.filter((E) => !p.some((S) => S.id === E)));
        return;
      }
    } else {
      const E = e.getAnnotation(g);
      if (!E) {
        console.warn("Invalid selection: " + g);
        return;
      }
      p = [E];
    }
    const k = p.reduce((E, S) => {
      const w = h(S);
      return w === "EDIT" ? [...E, { id: S.id, editable: !0 }] : w === "SELECT" ? [...E, { id: S.id }] : E;
    }, []);
    o.set({ selected: k, event: m });
  }, u = (g, m) => {
    const p = Array.isArray(g) ? g : [g], k = p.map((E) => e.getAnnotation(E)).filter((E) => !!E);
    o.set({
      selected: k.map((E) => {
        const S = m === void 0 ? h(E) === "EDIT" : m;
        return { id: E.id, editable: S };
      })
    }), k.length !== p.length && console.warn("Invalid selection", g);
  }, d = (g) => {
    if (r())
      return !1;
    const { selected: m } = o.get();
    m.some(({ id: p }) => g.includes(p)) && o.set({ selected: m.filter(({ id: p }) => !g.includes(p)) });
  }, f = (g) => {
    i = g, u(o.get().selected.map(({ id: m }) => m));
  }, h = (g) => ui(g, i, n);
  return e.observe(
    ({ changes: g }) => d((g.deleted || []).map((m) => m.id))
  ), {
    get event() {
      const g = o.get();
      return g ? g.event : null;
    },
    get selected() {
      const g = o.get();
      return g ? [...g.selected] : null;
    },
    get userSelectAction() {
      return i;
    },
    clear: s,
    evalSelectAction: h,
    isEmpty: r,
    isSelected: l,
    setSelected: u,
    setUserSelectAction: f,
    subscribe: o.subscribe.bind(o),
    userSelect: a
  };
}, ui = (e, t, n) => {
  const o = n ? n.serialize(e) : e;
  return typeof t == "function" ? t(o) : t || "EDIT";
}, he = [];
for (let e = 0; e < 256; ++e)
  he.push((e + 256).toString(16).slice(1));
function fi(e, t = 0) {
  return (he[e[t + 0]] + he[e[t + 1]] + he[e[t + 2]] + he[e[t + 3]] + "-" + he[e[t + 4]] + he[e[t + 5]] + "-" + he[e[t + 6]] + he[e[t + 7]] + "-" + he[e[t + 8]] + he[e[t + 9]] + "-" + he[e[t + 10]] + he[e[t + 11]] + he[e[t + 12]] + he[e[t + 13]] + he[e[t + 14]] + he[e[t + 15]]).toLowerCase();
}
let Tt;
const di = new Uint8Array(16);
function hi() {
  if (!Tt) {
    if (typeof crypto > "u" || !crypto.getRandomValues)
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    Tt = crypto.getRandomValues.bind(crypto);
  }
  return Tt(di);
}
const gi = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), on = { randomUUID: gi };
function mi(e, t, n) {
  var o;
  e = e || {};
  const i = e.random ?? ((o = e.rng) == null ? void 0 : o.call(e)) ?? hi();
  if (i.length < 16)
    throw new Error("Random bytes length must be >= 16");
  return i[6] = i[6] & 15 | 64, i[8] = i[8] & 63 | 128, fi(i);
}
function so(e, t, n) {
  return on.randomUUID && !e ? on.randomUUID() : mi(e);
}
const Pt = (e) => {
  const t = (n) => {
    const o = { ...n };
    return n.created && typeof n.created == "string" && (o.created = new Date(n.created)), n.updated && typeof n.updated == "string" && (o.updated = new Date(n.updated)), o;
  };
  return {
    ...e,
    bodies: (e.bodies || []).map(t),
    target: t(e.target)
  };
}, Nr = (e, t, n, o) => ({
  id: so(),
  annotation: typeof e == "string" ? e : e.id,
  created: n || /* @__PURE__ */ new Date(),
  creator: o,
  ...t
}), pi = (e, t) => {
  const n = new Set(e.bodies.map((o) => o.id));
  return t.bodies.filter((o) => !n.has(o.id));
}, yi = (e, t) => {
  const n = new Set(t.bodies.map((o) => o.id));
  return e.bodies.filter((o) => !n.has(o.id));
}, _i = (e, t) => t.bodies.map((n) => {
  const o = e.bodies.find((i) => i.id === n.id);
  return { newBody: n, oldBody: o && !De(o, n) ? o : void 0 };
}).filter(({ oldBody: n }) => n).map(({ oldBody: n, newBody: o }) => ({ oldBody: n, newBody: o })), wi = (e, t) => !De(e.target, t.target), ro = (e, t) => {
  const n = pi(e, t), o = yi(e, t), i = _i(e, t);
  return {
    oldValue: e,
    newValue: t,
    bodiesCreated: n.length > 0 ? n : void 0,
    bodiesDeleted: o.length > 0 ? o : void 0,
    bodiesUpdated: i.length > 0 ? i : void 0,
    targetUpdated: wi(e, t) ? { oldTarget: e.target, newTarget: t.target } : void 0
  };
};
var ne = /* @__PURE__ */ ((e) => (e.LOCAL = "LOCAL", e.REMOTE = "REMOTE", e.SILENT = "SILENT", e))(ne || {});
const bi = (e, t) => {
  var n, o;
  const { changes: i, origin: s } = t;
  if (!(e.options.origin ? e.options.origin === s : s !== "SILENT"))
    return !1;
  if (e.options.ignore) {
    const { ignore: r } = e.options, l = (a) => a && a.length > 0;
    if (!(l(i.created) || l(i.deleted))) {
      const a = (n = i.updated) == null ? void 0 : n.some((d) => l(d.bodiesCreated) || l(d.bodiesDeleted) || l(d.bodiesUpdated)), u = (o = i.updated) == null ? void 0 : o.some((d) => d.targetUpdated);
      if (r === "BODY_ONLY" && a && !u || r === "TARGET_ONLY" && u && !a)
        return !1;
    }
  }
  if (e.options.annotations) {
    const r = /* @__PURE__ */ new Set([
      ...(i.created || []).map((l) => l.id),
      ...(i.deleted || []).map((l) => l.id),
      ...(i.updated || []).map(({ oldValue: l }) => l.id)
    ]);
    return !!(Array.isArray(e.options.annotations) ? e.options.annotations : [e.options.annotations]).find((l) => r.has(l));
  } else
    return !0;
}, Ei = (e, t) => {
  const n = new Set((e.created || []).map((f) => f.id)), o = new Set((e.updated || []).map(({ newValue: f }) => f.id)), i = new Set((t.created || []).map((f) => f.id)), s = new Set((t.deleted || []).map((f) => f.id)), r = new Set((t.updated || []).map(({ oldValue: f }) => f.id)), l = new Set((t.updated || []).filter(({ oldValue: f }) => n.has(f.id) || o.has(f.id)).map(({ oldValue: f }) => f.id)), a = [
    ...(e.created || []).filter((f) => !s.has(f.id)).map((f) => r.has(f.id) ? t.updated.find(({ oldValue: h }) => h.id === f.id).newValue : f),
    ...t.created || []
  ], u = [
    ...(e.deleted || []).filter((f) => !i.has(f.id)),
    ...(t.deleted || []).filter((f) => !n.has(f.id))
  ], d = [
    ...(e.updated || []).filter(({ newValue: f }) => !s.has(f.id)).map((f) => {
      const { oldValue: h, newValue: g } = f;
      if (r.has(g.id)) {
        const m = t.updated.find((p) => p.oldValue.id === g.id).newValue;
        return ro(h, m);
      } else
        return f;
    }),
    ...(t.updated || []).filter(({ oldValue: f }) => !l.has(f.id))
  ];
  return { created: a, deleted: u, updated: d };
}, lt = (e) => {
  const t = e.id === void 0 ? so() : e.id;
  return {
    ...e,
    id: t,
    bodies: e.bodies === void 0 ? [] : e.bodies.map((n) => ({
      ...n,
      annotation: t
    })),
    target: {
      ...e.target,
      annotation: t
    }
  };
}, vi = (e) => e.id !== void 0, Si = () => {
  const e = /* @__PURE__ */ new Map(), t = /* @__PURE__ */ new Map(), n = [], o = (v, b = {}) => {
    n.push({ onChange: v, options: b });
  }, i = (v) => {
    const b = n.findIndex((y) => y.onChange == v);
    b > -1 && n.splice(b, 1);
  }, s = (v, b) => {
    const y = {
      origin: v,
      changes: {
        created: b.created || [],
        updated: b.updated || [],
        deleted: b.deleted || []
      },
      state: [...e.values()]
    };
    n.forEach((_) => {
      bi(_, y) && _.onChange(y);
    });
  }, r = (v, b = ne.LOCAL) => {
    if (v.id && e.get(v.id))
      throw Error(`Cannot add annotation ${v.id} - exists already`);
    {
      const y = lt(v);
      e.set(y.id, y), y.bodies.forEach((_) => t.set(_.id, y.id)), s(b, { created: [y] });
    }
  }, l = (v, b) => {
    const y = lt(typeof v == "string" ? b : v), _ = typeof v == "string" ? v : v.id, I = _ && e.get(_);
    if (I) {
      const P = ro(I, y);
      return _ === y.id ? e.set(_, y) : (e.delete(_), e.set(y.id, y)), I.bodies.forEach((O) => t.delete(O.id)), y.bodies.forEach((O) => t.set(O.id, y.id)), P;
    } else
      console.warn(`Cannot update annotation ${_} - does not exist`);
  }, a = (v, b = ne.LOCAL, y = ne.LOCAL) => {
    const _ = vi(b) ? y : b, I = l(v, b);
    I && s(_, { updated: [I] });
  }, u = (v, b = ne.LOCAL) => {
    e.get(v.id) ? a(v, b) : r(v, b);
  }, d = (v, b = ne.LOCAL) => {
    const y = v.reduce((_, I) => {
      const P = l(I);
      return P ? [..._, P] : _;
    }, []);
    y.length > 0 && s(b, { updated: y });
  }, f = (v, b = ne.LOCAL) => {
    const y = v.map(lt), { toAdd: _, toUpdate: I } = y.reduce((O, G) => e.get(G.id) ? { ...O, toUpdate: [...O.toUpdate, G] } : { ...O, toAdd: [...O.toAdd, G] }, { toAdd: [], toUpdate: [] }), P = I.map((O) => l(O, b)).filter(Boolean);
    _.forEach((O) => {
      e.set(O.id, O), O.bodies.forEach((G) => t.set(G.id, O.id));
    }), s(b, { created: _, updated: P });
  }, h = (v, b = ne.LOCAL) => {
    const y = e.get(v.annotation);
    if (y) {
      const _ = {
        ...y,
        bodies: [...y.bodies, v]
      };
      e.set(y.id, _), t.set(v.id, _.id), s(b, { updated: [{
        oldValue: y,
        newValue: _,
        bodiesCreated: [v]
      }] });
    } else
      console.warn(`Attempt to add body to missing annotation: ${v.annotation}`);
  }, g = () => [...e.values()], m = (v = ne.LOCAL) => {
    const b = [...e.values()];
    e.clear(), t.clear(), s(v, { deleted: b });
  }, p = (v, b = !0, y = ne.LOCAL) => {
    const _ = v.map(lt);
    if (b) {
      const I = [...e.values()];
      e.clear(), t.clear(), _.forEach((P) => {
        e.set(P.id, P), P.bodies.forEach((O) => t.set(O.id, P.id));
      }), s(y, { created: _, deleted: I });
    } else {
      const I = v.reduce((P, O) => {
        const G = O.id && e.get(O.id);
        return G ? [...P, G] : P;
      }, []);
      if (I.length > 0)
        throw Error(`Bulk insert would overwrite the following annotations: ${I.map((P) => P.id).join(", ")}`);
      _.forEach((P) => {
        e.set(P.id, P), P.bodies.forEach((O) => t.set(O.id, P.id));
      }), s(y, { created: _ });
    }
  }, k = (v) => {
    const b = typeof v == "string" ? v : v.id, y = e.get(b);
    if (y)
      return e.delete(b), y.bodies.forEach((_) => t.delete(_.id)), y;
    console.warn(`Attempt to delete missing annotation: ${b}`);
  }, E = (v, b = ne.LOCAL) => {
    const y = k(v);
    y && s(b, { deleted: [y] });
  }, S = (v, b = ne.LOCAL) => {
    const y = v.reduce((_, I) => {
      const P = k(I);
      return P ? [..._, P] : _;
    }, []);
    y.length > 0 && s(b, { deleted: y });
  }, w = (v) => {
    const b = e.get(v.annotation);
    if (b) {
      const y = b.bodies.find((_) => _.id === v.id);
      if (y) {
        t.delete(y.id);
        const _ = {
          ...b,
          bodies: b.bodies.filter((I) => I.id !== v.id)
        };
        return e.set(b.id, _), {
          oldValue: b,
          newValue: _,
          bodiesDeleted: [y]
        };
      } else
        console.warn(`Attempt to delete missing body ${v.id} from annotation ${v.annotation}`);
    } else
      console.warn(`Attempt to delete body from missing annotation ${v.annotation}`);
  }, A = (v, b = ne.LOCAL) => {
    const y = w(v);
    y && s(b, { updated: [y] });
  }, T = (v, b = ne.LOCAL) => {
    const y = v.map((_) => w(_)).filter(Boolean);
    y.length > 0 && s(b, { updated: y });
  }, C = (v) => {
    const b = e.get(v);
    return b ? { ...b } : void 0;
  }, M = (v) => {
    const b = t.get(v);
    if (b) {
      const y = C(b).bodies.find((_) => _.id === v);
      if (y)
        return y;
      console.error(`Store integrity error: body ${v} in index, but not in annotation`);
    } else
      console.warn(`Attempt to retrieve missing body: ${v}`);
  }, R = (v, b) => {
    if (v.annotation !== b.annotation)
      throw "Annotation integrity violation: annotation ID must be the same when updating bodies";
    const y = e.get(v.annotation);
    if (y) {
      const _ = y.bodies.find((P) => P.id === v.id), I = {
        ...y,
        bodies: y.bodies.map((P) => P.id === _.id ? b : P)
      };
      return e.set(y.id, I), _.id !== b.id && (t.delete(_.id), t.set(b.id, I.id)), {
        oldValue: y,
        newValue: I,
        bodiesUpdated: [{ oldBody: _, newBody: b }]
      };
    } else
      console.warn(`Attempt to add body to missing annotation ${v.annotation}`);
  }, N = (v, b, y = ne.LOCAL) => {
    const _ = R(v, b);
    _ && s(y, { updated: [_] });
  }, q = (v, b = ne.LOCAL) => {
    const y = v.map((_) => R({ id: _.id, annotation: _.annotation }, _)).filter(Boolean);
    s(b, { updated: y });
  }, F = (v) => {
    const b = e.get(v.annotation);
    if (b) {
      const y = {
        ...b,
        target: {
          ...b.target,
          ...v
        }
      };
      return e.set(b.id, y), {
        oldValue: b,
        newValue: y,
        targetUpdated: {
          oldTarget: b.target,
          newTarget: v
        }
      };
    } else
      console.warn(`Attempt to update target on missing annotation: ${v.annotation}`);
  };
  return {
    addAnnotation: r,
    addBody: h,
    all: g,
    bulkAddAnnotations: p,
    bulkDeleteAnnotations: S,
    bulkDeleteBodies: T,
    bulkUpdateAnnotations: d,
    bulkUpdateBodies: q,
    bulkUpdateTargets: (v, b = ne.LOCAL) => {
      const y = v.map((_) => F(_)).filter(Boolean);
      y.length > 0 && s(b, { updated: y });
    },
    bulkUpsertAnnotations: f,
    clear: m,
    deleteAnnotation: E,
    deleteBody: A,
    getAnnotation: C,
    getBody: M,
    observe: o,
    unobserve: i,
    updateAnnotation: a,
    updateBody: N,
    updateTarget: (v, b = ne.LOCAL) => {
      const y = F(v);
      y && s(b, { updated: [y] });
    },
    upsertAnnotation: u
  };
};
let Ai = () => ({
  emit(e, ...t) {
    for (let n = this.events[e] || [], o = 0, i = n.length; o < i; o++)
      n[o](...t);
  },
  events: {},
  on(e, t) {
    var n;
    return ((n = this.events)[e] || (n[e] = [])).push(t), () => {
      var o;
      this.events[e] = (o = this.events[e]) == null ? void 0 : o.filter((i) => t !== i);
    };
  }
});
const ki = 250, Mi = (e, t) => {
  const n = Ai(), o = (t == null ? void 0 : t.changes) || [];
  let i = t ? t.pointer : -1, s = !1, r = 0;
  const l = (m) => {
    if (!s) {
      const { changes: p } = m, k = performance.now();
      if (k - r > ki)
        o.splice(i + 1), o.push(p), i = o.length - 1;
      else {
        const E = o.length - 1;
        o[E] = Ei(o[E], p);
      }
      r = k;
    }
    s = !1;
  };
  e.observe(l, { origin: ne.LOCAL });
  const a = (m) => m && m.length > 0 && e.bulkDeleteAnnotations(m), u = (m) => m && m.length > 0 && e.bulkAddAnnotations(m, !1), d = (m) => m && m.length > 0 && e.bulkUpdateAnnotations(m.map(({ oldValue: p }) => p)), f = (m) => m && m.length > 0 && e.bulkUpdateAnnotations(m.map(({ newValue: p }) => p)), h = (m) => m && m.length > 0 && e.bulkAddAnnotations(m, !1), g = (m) => m && m.length > 0 && e.bulkDeleteAnnotations(m);
  return {
    canRedo: () => o.length - 1 > i,
    canUndo: () => i > -1,
    destroy: () => e.unobserve(l),
    getHistory: () => ({ changes: [...o], pointer: i }),
    on: (m, p) => n.on(m, p),
    redo: () => {
      if (o.length - 1 > i) {
        s = !0;
        const { created: m, updated: p, deleted: k } = o[i + 1];
        u(m), f(p), g(k), n.emit("redo", o[i + 1]), i += 1;
      }
    },
    undo: () => {
      if (i > -1) {
        s = !0;
        const { created: m, updated: p, deleted: k } = o[i];
        a(m), d(p), h(k), n.emit("undo", o[i]), i -= 1;
      }
    }
  };
}, Ti = () => {
  const e = /* @__PURE__ */ qt([]);
  return {
    subscribe: e.subscribe.bind(e),
    set: e.set.bind(e)
  };
}, Pi = (e, t, n, o) => {
  const { hover: i, selection: s, store: r, viewport: l } = e, a = /* @__PURE__ */ new Map();
  let u = [], d, f;
  const h = (E, S) => {
    a.has(E) ? a.get(E).push(S) : a.set(E, [S]);
  }, g = (E, S) => {
    const w = a.get(E);
    if (w) {
      const A = w.indexOf(S);
      A !== -1 && w.splice(A, 1);
    }
  }, m = (E, S, w) => {
    a.has(E) && setTimeout(() => {
      a.get(E).forEach((A) => {
        if (n) {
          const T = Array.isArray(S) ? S.map((M) => n.serialize(M)) : n.serialize(S), C = w ? w instanceof PointerEvent ? w : n.serialize(w) : void 0;
          A(T, C);
        } else
          A(S, w);
      });
    }, 1);
  }, p = () => {
    const { selected: E } = s, S = (E || []).map(({ id: w }) => r.getAnnotation(w));
    S.forEach((w) => {
      const A = u.find((T) => T.id === w.id);
      (!A || !De(A, w)) && m("updateAnnotation", w, A);
    }), u = u.map((w) => S.find(({ id: T }) => T === w.id) || w);
  };
  s.subscribe(({ selected: E }) => {
    if (!(u.length === 0 && E.length === 0)) {
      if (u.length === 0 && E.length > 0)
        u = E.map(({ id: S }) => r.getAnnotation(S));
      else if (u.length > 0 && E.length === 0)
        u.forEach((S) => {
          const w = r.getAnnotation(S.id);
          w && !De(w, S) && m("updateAnnotation", w, S);
        }), u = [];
      else {
        const S = new Set(u.map((A) => A.id)), w = new Set(E.map(({ id: A }) => A));
        u.filter((A) => !w.has(A.id)).forEach((A) => {
          const T = r.getAnnotation(A.id);
          T && !De(T, A) && m("updateAnnotation", T, A);
        }), u = [
          // Remove annotations that were deselected
          ...u.filter((A) => w.has(A.id)),
          // Add editable annotations that were selected
          ...E.filter(({ id: A }) => !S.has(A)).map(({ id: A }) => r.getAnnotation(A))
        ];
      }
      m("selectionChanged", u);
    }
  }), i.subscribe((E) => {
    !d && E ? m("mouseEnterAnnotation", r.getAnnotation(E)) : d && !E ? m("mouseLeaveAnnotation", r.getAnnotation(d)) : d && E && (m("mouseLeaveAnnotation", r.getAnnotation(d)), m("mouseEnterAnnotation", r.getAnnotation(E))), d = E;
  }), l == null || l.subscribe((E) => m("viewportIntersect", E.map((S) => r.getAnnotation(S)))), r.observe((E) => {
    o && (f && clearTimeout(f), f = setTimeout(p, 1e3));
    const { created: S, deleted: w } = E.changes;
    (S || []).forEach((A) => m("createAnnotation", A)), (w || []).forEach((A) => m("deleteAnnotation", A)), (E.changes.updated || []).filter((A) => [
      ...A.bodiesCreated || [],
      ...A.bodiesDeleted || [],
      ...A.bodiesUpdated || []
    ].length > 0).forEach(({ oldValue: A, newValue: T }) => {
      const C = u.find((M) => M.id === A.id) || A;
      u = u.map((M) => M.id === A.id ? T : M), m("updateAnnotation", T, C);
    });
  }, { origin: ne.LOCAL }), r.observe((E) => {
    if (u) {
      const S = new Set(u.map((A) => A.id)), w = (E.changes.updated || []).filter(({ newValue: A }) => S.has(A.id)).map(({ newValue: A }) => A);
      w.length > 0 && (u = u.map((A) => w.find((C) => C.id === A.id) || A));
    }
  }, { origin: ne.REMOTE });
  const k = (E) => (S) => {
    const { updated: w } = S;
    E ? (w || []).forEach((A) => m("updateAnnotation", A.oldValue, A.newValue)) : (w || []).forEach((A) => m("updateAnnotation", A.newValue, A.oldValue));
  };
  return t.on("undo", k(!0)), t.on("redo", k(!1)), { on: h, off: g, emit: m };
}, Li = (e) => (t) => t.reduce((n, o) => {
  const { parsed: i, error: s } = e.parse(o);
  return s ? {
    parsed: n.parsed,
    failed: [...n.failed, o]
  } : i ? {
    parsed: [...n.parsed, i],
    failed: n.failed
  } : {
    ...n
  };
}, { parsed: [], failed: [] }), Ii = (e, t, n) => {
  const { store: o, selection: i } = e, s = (E) => {
    if (n) {
      const { parsed: S, error: w } = n.parse(E);
      S ? o.addAnnotation(S, ne.REMOTE) : console.error(w);
    } else
      o.addAnnotation(Pt(E), ne.REMOTE);
  }, r = () => i.clear(), l = () => o.clear(), a = (E) => {
    const S = o.getAnnotation(E);
    return n && S ? n.serialize(S) : S;
  }, u = () => n ? o.all().map(n.serialize) : o.all(), d = () => {
    var E;
    const S = (((E = i.selected) == null ? void 0 : E.map((w) => w.id)) || []).map((w) => o.getAnnotation(w)).filter(Boolean);
    return n ? S.map(n.serialize) : S;
  }, f = (E, S = !0) => fetch(E).then((w) => w.json()).then((w) => (g(w, S), w)), h = (E) => {
    if (typeof E == "string") {
      const S = o.getAnnotation(E);
      if (o.deleteAnnotation(E), S)
        return n ? n.serialize(S) : S;
    } else {
      const S = n ? n.parse(E).parsed : E;
      if (S)
        return o.deleteAnnotation(S), E;
    }
  }, g = (E, S = !0) => {
    if (n) {
      const w = n.parseAll || Li(n), { parsed: A, failed: T } = w(E);
      T.length > 0 && console.warn(`Discarded ${T.length} invalid annotations`, T), o.bulkAddAnnotations(A, S, ne.REMOTE);
    } else
      o.bulkAddAnnotations(E.map(Pt), S, ne.REMOTE);
  }, m = (E, S) => {
    E ? i.setSelected(E, S) : i.clear();
  }, p = (E) => {
    i.setUserSelectAction(E);
  }, k = (E) => {
    if (n) {
      const S = n.parse(E).parsed, w = n.serialize(o.getAnnotation(S.id));
      return o.updateAnnotation(S), w;
    } else {
      const S = o.getAnnotation(E.id);
      return o.updateAnnotation(Pt(E)), S;
    }
  };
  return {
    addAnnotation: s,
    cancelSelected: r,
    canRedo: t.canRedo,
    canUndo: t.canUndo,
    clearAnnotations: l,
    getAnnotationById: a,
    getAnnotations: u,
    getHistory: t.getHistory,
    getSelected: d,
    loadAnnotations: f,
    redo: t.redo,
    removeAnnotation: h,
    setAnnotations: g,
    setSelected: m,
    setUserSelectAction: p,
    undo: t.undo,
    updateAnnotation: k
  };
}, Yr = (e, t, n) => typeof t == "function" ? t(e, n) : t, Ur = (e, t) => typeof e != "function" && typeof t != "function" ? {
  ...e || {},
  ...t || {}
} : (n, o) => {
  const i = typeof e == "function" ? e(n, o) : e, s = typeof t == "function" ? t(n, o) : t;
  return {
    ...i || {},
    ...s || {}
  };
}, Ci = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";
let Oi = (e) => crypto.getRandomValues(new Uint8Array(e)), Di = (e, t, n) => {
  let o = (2 << Math.log2(e.length - 1)) - 1, i = -~(1.6 * o * t / e.length);
  return (s = t) => {
    let r = "";
    for (; ; ) {
      let l = n(i), a = i | 0;
      for (; a--; )
        if (r += e[l[a] & o] || "", r.length >= s) return r;
    }
  };
}, Bi = (e, t = 21) => Di(e, t | 0, Oi), Ni = (e = 21) => {
  let t = "", n = crypto.getRandomValues(new Uint8Array(e |= 0));
  for (; e--; )
    t += Ci[n[e] & 63];
  return t;
};
const Yi = () => ({ isGuest: !0, id: Bi("1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ_", 20)() }), Ui = (e) => {
  const t = JSON.stringify(e);
  let n = 0;
  for (let o = 0, i = t.length; o < i; o++) {
    let s = t.charCodeAt(o);
    n = (n << 5) - n + s, n |= 0;
  }
  return `${n}`;
}, lo = (e) => e ? typeof e == "object" ? { ...e } : e : void 0, Ri = (e, t) => (Array.isArray(e) ? e : [e]).map((n) => {
  const { id: o, type: i, purpose: s, value: r, created: l, modified: a, creator: u, ...d } = n;
  return {
    id: o || `temp-${Ui(n)}`,
    annotation: t,
    type: i,
    purpose: s,
    value: r,
    creator: lo(u),
    created: l ? new Date(l) : void 0,
    updated: a ? new Date(a) : void 0,
    ...d
  };
}), Vi = (e) => e.map((t) => {
  var n;
  const { annotation: o, created: i, updated: s, ...r } = t, l = {
    ...r,
    created: i == null ? void 0 : i.toISOString(),
    modified: s == null ? void 0 : s.toISOString()
  };
  return (n = l.id) != null && n.startsWith("temp-") && delete l.id, l;
}), Xi = [
  "#ff7c00",
  // orange
  "#1ac938",
  // green
  "#e8000b",
  // red
  "#8b2be2",
  // purple
  "#9f4800",
  // brown
  "#f14cc1",
  // pink
  "#ffc400",
  // khaki
  "#00d7ff",
  // cyan
  "#023eff"
  // blue
], Rr = () => {
  const e = [...Xi];
  return { assignRandomColor: () => {
    const t = Math.floor(Math.random() * e.length), n = e[t];
    return e.splice(t, 1), n;
  }, releaseColor: (t) => e.push(t) };
};
Ni();
const Vr = (e, t = { strict: !0, invertY: !1 }) => ({ parse: (i) => Hi(i, t), serialize: (i) => Gi(i, e, t) }), Hi = (e, t = { strict: !0, invertY: !1 }) => {
  const n = e.id || oo(), {
    creator: o,
    created: i,
    modified: s,
    body: r,
    ...l
  } = e, a = Ri(r || [], n), u = Array.isArray(e.target) ? e.target[0] : e.target, d = typeof u == "string" ? u : Array.isArray(u.selector) ? u.selector[0] : u.selector, f = Ho(d) ? Go(d, t.invertY) : (d == null ? void 0 : d.type) === "SvgSelector" ? $o(d) : void 0, h = Array.isArray(l.target) ? l.target[0] : l.targret;
  return f || !t.strict ? {
    parsed: {
      ...l,
      id: n,
      bodies: a,
      target: {
        created: i ? new Date(i) : void 0,
        creator: lo(o),
        updated: s ? new Date(s) : void 0,
        // Note the target can be a string and we don't want to spread the characters...
        ...typeof h == "string" ? {} : h,
        annotation: n,
        selector: f || d
      }
    }
  } : {
    error: Error(`Invalid selector: ${JSON.stringify(d)}`)
  };
}, Gi = (e, t, n = { strict: !0, invertY: !1 }) => {
  const {
    selector: o,
    creator: i,
    created: s,
    updated: r,
    updatedBy: l,
    // Excluded from serialization
    ...a
  } = e.target;
  let u;
  try {
    u = o.type == x.RECTANGLE ? jo(o.geometry) : ti(o);
  } catch (f) {
    if (n.strict)
      throw f;
    u = o;
  }
  const d = {
    ...e,
    "@context": "http://www.w3.org/ns/anno.jsonld",
    id: e.id,
    type: "Annotation",
    body: Vi(e.bodies),
    created: s == null ? void 0 : s.toISOString(),
    creator: i,
    modified: r == null ? void 0 : r.toISOString(),
    target: {
      ...a,
      source: t,
      type: "SpecificResource",
      selector: u
    }
  };
  return delete d.bodies, typeof d.target != "string" && "annotation" in d.target && delete d.target.annotation, d;
}, He = [];
function ji(e, t = ee) {
  let n;
  const o = /* @__PURE__ */ new Set();
  function i(l) {
    if (se(e, l) && (e = l, n)) {
      const a = !He.length;
      for (const u of o)
        u[1](), He.push(u, e);
      if (a) {
        for (let u = 0; u < He.length; u += 2)
          He[u][0](He[u + 1]);
        He.length = 0;
      }
    }
  }
  function s(l) {
    i(l(e));
  }
  function r(l, a = ee) {
    const u = [l, a];
    return o.add(u), o.size === 1 && (n = t(i, s) || ee), l(e), () => {
      o.delete(u), o.size === 0 && n && (n(), n = null);
    };
  }
  return { set: i, update: s, subscribe: r };
}
const Fi = (e, t) => {
  const { naturalWidth: n, naturalHeight: o } = e;
  if (!n && !o) {
    const { width: i, height: s } = e;
    t.setAttribute("viewBox", `0 0 ${i} ${s}`), e.addEventListener("load", (r) => {
      const l = r.target;
      t.setAttribute("viewBox", `0 0 ${l.naturalWidth} ${l.naturalHeight}`);
    });
  } else
    t.setAttribute("viewBox", `0 0 ${n} ${o}`);
}, zi = (e, t) => {
  Fi(e, t);
  const { subscribe: n, set: o } = ji(1);
  let i;
  return window.ResizeObserver && (i = new ResizeObserver(() => {
    const r = t.getBoundingClientRect(), { width: l, height: a } = t.viewBox.baseVal, u = Math.max(
      r.width / l,
      r.height / a
    );
    o(u);
  }), i.observe(t.parentElement)), { destroy: () => {
    i && i.disconnect();
  }, subscribe: n };
}, Re = (e, t, n) => {
  const o = typeof t == "function" ? t(e, n) : t;
  if (o) {
    const { fill: i, fillOpacity: s, stroke: r, strokeWidth: l, strokeOpacity: a } = o;
    let u = "";
    return i && (u += `fill:${i};`), s || s === 0 ? u += `fill-opacity:${s};` : i && (u += "fill-opacity:0.25;"), r && (u += `stroke:${r};`, u += `stroke-width:${l || "1"};`, u += `stroke-opacity:${a || "1"};`), u;
  }
}, wt = (e, t = 0) => {
  const { minX: n, minY: o, maxX: i, maxY: s } = e;
  return {
    x: n - t,
    y: o - t,
    w: i - n + 2 * t,
    h: s - o + 2 * t
  };
}, Le = typeof window > "u" || typeof navigator > "u" ? !1 : "ontouchstart" in window || navigator.maxTouchPoints > 0 || // @ts-ignore
navigator.msMaxTouchPoints > 0, qi = (e) => ({}), sn = (e) => ({ grab: (
  /*onGrab*/
  e[0]
) });
function Ki(e) {
  let t, n, o, i;
  const s = (
    /*#slots*/
    e[8].default
  ), r = _o(
    s,
    e,
    /*$$scope*/
    e[7],
    sn
  );
  return {
    c() {
      t = L("g"), r && r.c(), c(t, "class", "a9s-annotation selected");
    },
    m(l, a) {
      B(l, t, a), r && r.m(t, null), n = !0, o || (i = [
        W(
          t,
          "pointerup",
          /*onRelease*/
          e[2]
        ),
        W(
          t,
          "pointermove",
          /*onPointerMove*/
          e[1]
        )
      ], o = !0);
    },
    p(l, [a]) {
      r && r.p && (!n || a & /*$$scope*/
      128) && bo(
        r,
        s,
        l,
        /*$$scope*/
        l[7],
        n ? wo(
          s,
          /*$$scope*/
          l[7],
          a,
          qi
        ) : Eo(
          /*$$scope*/
          l[7]
        ),
        sn
      );
    },
    i(l) {
      n || (U(r, l), n = !0);
    },
    o(l) {
      H(r, l), n = !1;
    },
    d(l) {
      l && D(t), r && r.d(l), o = !1, Se(i);
    }
  };
}
function Wi(e, t, n) {
  let { $$slots: o = {}, $$scope: i } = t;
  const s = Be();
  let { shape: r } = t, { editor: l } = t, { transform: a } = t, { svgEl: u } = t, d, f, h;
  const g = (k) => (E) => {
    if (d = k, u) {
      const { left: w, top: A } = u.getBoundingClientRect(), T = E.clientX - w, C = E.clientY - A;
      f = a.elementToImage(T, C);
    } else {
      const { offsetX: w, offsetY: A } = E;
      f = a.elementToImage(w, A);
    }
    h = r, E.target.setPointerCapture(E.pointerId), s("grab", E);
  }, m = (k) => {
    if (d) {
      const [E, S] = a.elementToImage(k.offsetX, k.offsetY), w = [E - f[0], S - f[1]];
      n(3, r = l(h, d, w)), s("change", r);
    }
  }, p = (k) => {
    k.target.releasePointerCapture(k.pointerId), d = void 0, h = r, s("release", k);
  };
  return e.$$set = (k) => {
    "shape" in k && n(3, r = k.shape), "editor" in k && n(4, l = k.editor), "transform" in k && n(5, a = k.transform), "svgEl" in k && n(6, u = k.svgEl), "$$scope" in k && n(7, i = k.$$scope);
  }, [
    g,
    m,
    p,
    r,
    l,
    a,
    u,
    i,
    o
  ];
}
class Kt extends pe {
  constructor(t) {
    super(), me(this, t, Wi, Ki, se, {
      shape: 3,
      editor: 4,
      transform: 5,
      svgEl: 6
    });
  }
}
function Zi(e) {
  let t, n, o, i, s, r, l, a, u = (
    /*selected*/
    e[3] && rn(e)
  );
  return {
    c() {
      t = L("g"), n = L("circle"), u && u.c(), i = L("circle"), c(n, "class", "a9s-handle-buffer svelte-qtyc7s"), c(
        n,
        "cx",
        /*x*/
        e[0]
      ), c(
        n,
        "cy",
        /*y*/
        e[1]
      ), c(n, "r", o = /*handleRadius*/
      e[5] + 6 / /*scale*/
      e[2]), c(n, "role", "button"), c(n, "tabindex", "0"), c(i, "class", s = ze(`a9s-handle-dot${/*selected*/
      e[3] ? " selected" : ""}`) + " svelte-qtyc7s"), c(
        i,
        "cx",
        /*x*/
        e[0]
      ), c(
        i,
        "cy",
        /*y*/
        e[1]
      ), c(
        i,
        "r",
        /*handleRadius*/
        e[5]
      ), c(t, "class", r = `a9s-handle ${/*$$props*/
      e[8].class || ""}`.trim());
    },
    m(d, f) {
      B(d, t, f), j(t, n), u && u.m(t, null), j(t, i), l || (a = [
        W(
          n,
          "dblclick",
          /*dblclick_handler_1*/
          e[12]
        ),
        W(
          n,
          "pointerenter",
          /*pointerenter_handler*/
          e[13]
        ),
        W(
          n,
          "pointerleave",
          /*pointerleave_handler*/
          e[14]
        ),
        W(
          n,
          "pointerdown",
          /*pointerdown_handler_1*/
          e[15]
        ),
        W(
          n,
          "pointerdown",
          /*onPointerDown*/
          e[6]
        ),
        W(
          n,
          "pointerup",
          /*pointerup_handler_1*/
          e[16]
        ),
        W(
          n,
          "pointerup",
          /*onPointerUp*/
          e[7]
        )
      ], l = !0);
    },
    p(d, f) {
      f & /*x*/
      1 && c(
        n,
        "cx",
        /*x*/
        d[0]
      ), f & /*y*/
      2 && c(
        n,
        "cy",
        /*y*/
        d[1]
      ), f & /*handleRadius, scale*/
      36 && o !== (o = /*handleRadius*/
      d[5] + 6 / /*scale*/
      d[2]) && c(n, "r", o), /*selected*/
      d[3] ? u ? u.p(d, f) : (u = rn(d), u.c(), u.m(t, i)) : u && (u.d(1), u = null), f & /*selected*/
      8 && s !== (s = ze(`a9s-handle-dot${/*selected*/
      d[3] ? " selected" : ""}`) + " svelte-qtyc7s") && c(i, "class", s), f & /*x*/
      1 && c(
        i,
        "cx",
        /*x*/
        d[0]
      ), f & /*y*/
      2 && c(
        i,
        "cy",
        /*y*/
        d[1]
      ), f & /*handleRadius*/
      32 && c(
        i,
        "r",
        /*handleRadius*/
        d[5]
      ), f & /*$$props*/
      256 && r !== (r = `a9s-handle ${/*$$props*/
      d[8].class || ""}`.trim()) && c(t, "class", r);
    },
    d(d) {
      d && D(t), u && u.d(), l = !1, Se(a);
    }
  };
}
function Ji(e) {
  let t, n, o, i, s, r, l, a, u;
  return {
    c() {
      t = L("g"), n = L("circle"), i = L("circle"), r = L("circle"), c(
        n,
        "cx",
        /*x*/
        e[0]
      ), c(
        n,
        "cy",
        /*y*/
        e[1]
      ), c(n, "r", o = /*handleRadius*/
      e[5] * 10), c(n, "class", "a9s-touch-halo"), Te(
        n,
        "touched",
        /*touched*/
        e[4]
      ), c(
        i,
        "cx",
        /*x*/
        e[0]
      ), c(
        i,
        "cy",
        /*y*/
        e[1]
      ), c(i, "r", s = /*handleRadius*/
      e[5] + 10 / /*scale*/
      e[2]), c(i, "class", "a9s-handle-buffer svelte-qtyc7s"), c(i, "role", "button"), c(i, "tabindex", "0"), c(r, "class", "a9s-handle-dot"), c(
        r,
        "cx",
        /*x*/
        e[0]
      ), c(
        r,
        "cy",
        /*y*/
        e[1]
      ), c(r, "r", l = /*handleRadius*/
      e[5] + 2 / /*scale*/
      e[2]), c(t, "class", "a9s-touch-handle");
    },
    m(d, f) {
      B(d, t, f), j(t, n), j(t, i), j(t, r), a || (u = [
        W(
          i,
          "dblclick",
          /*dblclick_handler*/
          e[9]
        ),
        W(
          i,
          "pointerdown",
          /*pointerdown_handler*/
          e[10]
        ),
        W(
          i,
          "pointerdown",
          /*onPointerDown*/
          e[6]
        ),
        W(
          i,
          "pointerup",
          /*pointerup_handler*/
          e[11]
        ),
        W(
          i,
          "pointerup",
          /*onPointerUp*/
          e[7]
        )
      ], a = !0);
    },
    p(d, f) {
      f & /*x*/
      1 && c(
        n,
        "cx",
        /*x*/
        d[0]
      ), f & /*y*/
      2 && c(
        n,
        "cy",
        /*y*/
        d[1]
      ), f & /*handleRadius*/
      32 && o !== (o = /*handleRadius*/
      d[5] * 10) && c(n, "r", o), f & /*touched*/
      16 && Te(
        n,
        "touched",
        /*touched*/
        d[4]
      ), f & /*x*/
      1 && c(
        i,
        "cx",
        /*x*/
        d[0]
      ), f & /*y*/
      2 && c(
        i,
        "cy",
        /*y*/
        d[1]
      ), f & /*handleRadius, scale*/
      36 && s !== (s = /*handleRadius*/
      d[5] + 10 / /*scale*/
      d[2]) && c(i, "r", s), f & /*x*/
      1 && c(
        r,
        "cx",
        /*x*/
        d[0]
      ), f & /*y*/
      2 && c(
        r,
        "cy",
        /*y*/
        d[1]
      ), f & /*handleRadius, scale*/
      36 && l !== (l = /*handleRadius*/
      d[5] + 2 / /*scale*/
      d[2]) && c(r, "r", l);
    },
    d(d) {
      d && D(t), a = !1, Se(u);
    }
  };
}
function rn(e) {
  let t, n;
  return {
    c() {
      t = L("circle"), c(t, "class", "a9s-handle-selected"), c(
        t,
        "cx",
        /*x*/
        e[0]
      ), c(
        t,
        "cy",
        /*y*/
        e[1]
      ), c(t, "r", n = /*handleRadius*/
      e[5] + 8 / /*scale*/
      e[2]);
    },
    m(o, i) {
      B(o, t, i);
    },
    p(o, i) {
      i & /*x*/
      1 && c(
        t,
        "cx",
        /*x*/
        o[0]
      ), i & /*y*/
      2 && c(
        t,
        "cy",
        /*y*/
        o[1]
      ), i & /*handleRadius, scale*/
      36 && n !== (n = /*handleRadius*/
      o[5] + 8 / /*scale*/
      o[2]) && c(t, "r", n);
    },
    d(o) {
      o && D(t);
    }
  };
}
function Qi(e) {
  let t;
  function n(s, r) {
    return Le ? Ji : Zi;
  }
  let i = n()(e);
  return {
    c() {
      i.c(), t = Ae();
    },
    m(s, r) {
      i.m(s, r), B(s, t, r);
    },
    p(s, [r]) {
      i.p(s, r);
    },
    i: ee,
    o: ee,
    d(s) {
      s && D(t), i.d(s);
    }
  };
}
function xi(e, t, n) {
  let o, { x: i } = t, { y: s } = t, { scale: r } = t, { selected: l = void 0 } = t, a = !1;
  const u = (w) => {
    w.pointerType === "touch" && n(4, a = !0);
  }, d = () => n(4, a = !1);
  function f(w) {
    ue.call(this, e, w);
  }
  function h(w) {
    ue.call(this, e, w);
  }
  function g(w) {
    ue.call(this, e, w);
  }
  function m(w) {
    ue.call(this, e, w);
  }
  function p(w) {
    ue.call(this, e, w);
  }
  function k(w) {
    ue.call(this, e, w);
  }
  function E(w) {
    ue.call(this, e, w);
  }
  function S(w) {
    ue.call(this, e, w);
  }
  return e.$$set = (w) => {
    n(8, t = Vt(Vt({}, t), Qt(w))), "x" in w && n(0, i = w.x), "y" in w && n(1, s = w.y), "scale" in w && n(2, r = w.scale), "selected" in w && n(3, l = w.selected);
  }, e.$$.update = () => {
    e.$$.dirty & /*scale*/
    4 && n(5, o = 4 / r);
  }, t = Qt(t), [
    i,
    s,
    r,
    l,
    a,
    o,
    u,
    d,
    t,
    f,
    h,
    g,
    m,
    p,
    k,
    E,
    S
  ];
}
class qe extends pe {
  constructor(t) {
    super(), me(this, t, xi, Qi, se, { x: 0, y: 1, scale: 2, selected: 3 });
  }
}
function $i(e) {
  let t, n, o, i, s, r, l;
  return {
    c() {
      t = L("g"), n = L("circle"), i = L("circle"), s = L("circle"), c(n, "class", "a9s-polygon-midpoint-buffer svelte-12ykj76"), c(
        n,
        "cx",
        /*x*/
        e[0]
      ), c(
        n,
        "cy",
        /*y*/
        e[1]
      ), c(n, "r", o = 1.75 * /*handleRadius*/
      e[2]), c(i, "class", "a9s-polygon-midpoint-outer svelte-12ykj76"), c(
        i,
        "cx",
        /*x*/
        e[0]
      ), c(
        i,
        "cy",
        /*y*/
        e[1]
      ), c(
        i,
        "r",
        /*handleRadius*/
        e[2]
      ), c(s, "class", "a9s-polygon-midpoint-inner svelte-12ykj76"), c(
        s,
        "cx",
        /*x*/
        e[0]
      ), c(
        s,
        "cy",
        /*y*/
        e[1]
      ), c(
        s,
        "r",
        /*handleRadius*/
        e[2]
      ), c(t, "class", "a9s-polygon-midpoint svelte-12ykj76");
    },
    m(a, u) {
      B(a, t, u), j(t, n), j(t, i), j(t, s), r || (l = [
        W(
          n,
          "pointerdown",
          /*pointerdown_handler*/
          e[5]
        ),
        W(
          n,
          "pointerdown",
          /*onPointerDown*/
          e[3]
        )
      ], r = !0);
    },
    p(a, u) {
      u & /*x*/
      1 && c(
        n,
        "cx",
        /*x*/
        a[0]
      ), u & /*y*/
      2 && c(
        n,
        "cy",
        /*y*/
        a[1]
      ), u & /*handleRadius*/
      4 && o !== (o = 1.75 * /*handleRadius*/
      a[2]) && c(n, "r", o), u & /*x*/
      1 && c(
        i,
        "cx",
        /*x*/
        a[0]
      ), u & /*y*/
      2 && c(
        i,
        "cy",
        /*y*/
        a[1]
      ), u & /*handleRadius*/
      4 && c(
        i,
        "r",
        /*handleRadius*/
        a[2]
      ), u & /*x*/
      1 && c(
        s,
        "cx",
        /*x*/
        a[0]
      ), u & /*y*/
      2 && c(
        s,
        "cy",
        /*y*/
        a[1]
      ), u & /*handleRadius*/
      4 && c(
        s,
        "r",
        /*handleRadius*/
        a[2]
      );
    },
    d(a) {
      a && D(t), r = !1, Se(l);
    }
  };
}
function es(e) {
  let t;
  return {
    c() {
      t = L("circle"), c(
        t,
        "cx",
        /*x*/
        e[0]
      ), c(
        t,
        "cy",
        /*y*/
        e[1]
      ), c(
        t,
        "r",
        /*handleRadius*/
        e[2]
      );
    },
    m(n, o) {
      B(n, t, o);
    },
    p(n, o) {
      o & /*x*/
      1 && c(
        t,
        "cx",
        /*x*/
        n[0]
      ), o & /*y*/
      2 && c(
        t,
        "cy",
        /*y*/
        n[1]
      ), o & /*handleRadius*/
      4 && c(
        t,
        "r",
        /*handleRadius*/
        n[2]
      );
    },
    d(n) {
      n && D(t);
    }
  };
}
function ts(e) {
  let t;
  function n(s, r) {
    return Le ? es : $i;
  }
  let i = n()(e);
  return {
    c() {
      i.c(), t = Ae();
    },
    m(s, r) {
      i.m(s, r), B(s, t, r);
    },
    p(s, [r]) {
      i.p(s, r);
    },
    i: ee,
    o: ee,
    d(s) {
      s && D(t), i.d(s);
    }
  };
}
function ns(e, t, n) {
  let o, { x: i } = t, { y: s } = t, { scale: r } = t;
  const l = (u) => {
    u.pointerType;
  };
  function a(u) {
    ue.call(this, e, u);
  }
  return e.$$set = (u) => {
    "x" in u && n(0, i = u.x), "y" in u && n(1, s = u.y), "scale" in u && n(4, r = u.scale);
  }, e.$$.update = () => {
    e.$$.dirty & /*scale*/
    16 && n(2, o = 4 / r);
  }, [i, s, o, l, r, a];
}
class ao extends pe {
  constructor(t) {
    super(), me(this, t, ns, ts, se, { x: 0, y: 1, scale: 4 });
  }
}
function Lt(e) {
  const t = e.slice(), n = (
    /*midpoints*/
    t[10][
      /*visibleMidpoint*/
      t[6]
    ]
  );
  return t[28] = n.point, t;
}
function ln(e, t, n) {
  const o = e.slice();
  return o[28] = t[n], o[30] = n, o;
}
function It(e) {
  const t = e.slice(), n = (
    /*midpoints*/
    t[10][
      /*visibleMidpoint*/
      t[6]
    ]
  );
  return t[28] = n.point, t;
}
function Ct(e) {
  const t = e.slice(), n = (
    /*midpoints*/
    t[10][
      /*visibleMidpoint*/
      t[6]
    ]
  );
  return t[28] = n.point, t;
}
function an(e) {
  let t, n, o, i;
  return {
    c() {
      t = L("circle"), c(t, "cx", n = /*point*/
      e[28][0]), c(t, "cy", o = /*point*/
      e[28][1]), c(t, "r", i = et / /*viewportScale*/
      e[3]), c(t, "class", "svelte-1h2slbm");
    },
    m(s, r) {
      B(s, t, r);
    },
    p(s, r) {
      r[0] & /*midpoints, visibleMidpoint*/
      1088 && n !== (n = /*point*/
      s[28][0]) && c(t, "cx", n), r[0] & /*midpoints, visibleMidpoint*/
      1088 && o !== (o = /*point*/
      s[28][1]) && c(t, "cy", o), r[0] & /*viewportScale*/
      8 && i !== (i = et / /*viewportScale*/
      s[3]) && c(t, "r", i);
    },
    d(s) {
      s && D(t);
    }
  };
}
function cn(e) {
  let t, n, o, i, s, r, l, a, u, d;
  return {
    c() {
      t = L("mask"), n = L("rect"), l = L("circle"), c(n, "x", o = /*mask*/
      e[9].x), c(n, "y", i = /*mask*/
      e[9].y), c(n, "width", s = /*mask*/
      e[9].w), c(n, "height", r = /*mask*/
      e[9].h), c(n, "class", "svelte-1h2slbm"), c(l, "cx", a = /*point*/
      e[28][0]), c(l, "cy", u = /*point*/
      e[28][1]), c(l, "r", d = et / /*viewportScale*/
      e[3]), c(l, "class", "svelte-1h2slbm"), c(t, "id", `${/*maskId*/
      e[19]}-inner`), c(t, "class", "a9s-polygon-editor-mask svelte-1h2slbm");
    },
    m(f, h) {
      B(f, t, h), j(t, n), j(t, l);
    },
    p(f, h) {
      h[0] & /*mask*/
      512 && o !== (o = /*mask*/
      f[9].x) && c(n, "x", o), h[0] & /*mask*/
      512 && i !== (i = /*mask*/
      f[9].y) && c(n, "y", i), h[0] & /*mask*/
      512 && s !== (s = /*mask*/
      f[9].w) && c(n, "width", s), h[0] & /*mask*/
      512 && r !== (r = /*mask*/
      f[9].h) && c(n, "height", r), h[0] & /*midpoints, visibleMidpoint*/
      1088 && a !== (a = /*point*/
      f[28][0]) && c(l, "cx", a), h[0] & /*midpoints, visibleMidpoint*/
      1088 && u !== (u = /*point*/
      f[28][1]) && c(l, "cy", u), h[0] & /*viewportScale*/
      8 && d !== (d = et / /*viewportScale*/
      f[3]) && c(l, "r", d);
    },
    d(f) {
      f && D(t);
    }
  };
}
function un(e) {
  let t, n;
  return t = new qe({
    props: {
      class: "a9s-corner-handle",
      x: (
        /*point*/
        e[28][0]
      ),
      y: (
        /*point*/
        e[28][1]
      ),
      scale: (
        /*viewportScale*/
        e[3]
      ),
      selected: (
        /*selectedCorners*/
        e[8].includes(
          /*idx*/
          e[30]
        )
      )
    }
  }), t.$on(
    "pointerenter",
    /*onEnterHandle*/
    e[11]
  ), t.$on(
    "pointerleave",
    /*onLeaveHandle*/
    e[12]
  ), t.$on(
    "pointerdown",
    /*onHandlePointerDown*/
    e[15]
  ), t.$on("pointerdown", function() {
    ie(
      /*grab*/
      e[27](`HANDLE-${/*idx*/
      e[30]}`)
    ) && e[27](`HANDLE-${/*idx*/
    e[30]}`).apply(this, arguments);
  }), t.$on(
    "pointerup",
    /*onHandlePointerUp*/
    e[16](
      /*idx*/
      e[30]
    )
  ), {
    c() {
      ae(t.$$.fragment);
    },
    m(o, i) {
      re(t, o, i), n = !0;
    },
    p(o, i) {
      e = o;
      const s = {};
      i[0] & /*geom*/
      32 && (s.x = /*point*/
      e[28][0]), i[0] & /*geom*/
      32 && (s.y = /*point*/
      e[28][1]), i[0] & /*viewportScale*/
      8 && (s.scale = /*viewportScale*/
      e[3]), i[0] & /*selectedCorners*/
      256 && (s.selected = /*selectedCorners*/
      e[8].includes(
        /*idx*/
        e[30]
      )), t.$set(s);
    },
    i(o) {
      n || (U(t.$$.fragment, o), n = !0);
    },
    o(o) {
      H(t.$$.fragment, o), n = !1;
    },
    d(o) {
      le(t, o);
    }
  };
}
function fn(e) {
  let t, n;
  return t = new ao({
    props: {
      x: (
        /*point*/
        e[28][0]
      ),
      y: (
        /*point*/
        e[28][1]
      ),
      scale: (
        /*viewportScale*/
        e[3]
      )
    }
  }), t.$on("pointerdown", function() {
    ie(
      /*onAddPoint*/
      e[18](
        /*visibleMidpoint*/
        e[6]
      )
    ) && e[18](
      /*visibleMidpoint*/
      e[6]
    ).apply(this, arguments);
  }), {
    c() {
      ae(t.$$.fragment);
    },
    m(o, i) {
      re(t, o, i), n = !0;
    },
    p(o, i) {
      e = o;
      const s = {};
      i[0] & /*midpoints, visibleMidpoint*/
      1088 && (s.x = /*point*/
      e[28][0]), i[0] & /*midpoints, visibleMidpoint*/
      1088 && (s.y = /*point*/
      e[28][1]), i[0] & /*viewportScale*/
      8 && (s.scale = /*viewportScale*/
      e[3]), t.$set(s);
    },
    i(o) {
      n || (U(t.$$.fragment, o), n = !0);
    },
    o(o) {
      H(t.$$.fragment, o), n = !1;
    },
    d(o) {
      le(t, o);
    }
  };
}
function os(e) {
  let t, n, o, i, s, r, l, a, u, d, f, h, g, m, p, k, E, S, w, A, T, C = (
    /*visibleMidpoint*/
    e[6] !== void 0 && !/*isHandleHovered*/
    e[7] && an(Ct(e))
  ), M = (
    /*visibleMidpoint*/
    e[6] !== void 0 && !/*isHandleHovered*/
    e[7] && cn(It(e))
  ), R = ve(
    /*geom*/
    e[5].points
  ), N = [];
  for (let v = 0; v < R.length; v += 1)
    N[v] = un(ln(e, R, v));
  const q = (v) => H(N[v], 1, 1, () => {
    N[v] = null;
  });
  let F = (
    /*visibleMidpoint*/
    e[6] !== void 0 && !/*isHandleHovered*/
    e[7] && fn(Lt(e))
  );
  return {
    c() {
      t = L("defs"), n = L("mask"), o = L("rect"), a = L("polygon"), C && C.c(), M && M.c(), d = _e(), f = L("polygon"), g = _e(), m = L("polygon"), k = _e();
      for (let v = 0; v < N.length; v += 1)
        N[v].c();
      E = _e(), F && F.c(), S = Ae(), c(o, "x", i = /*mask*/
      e[9].x), c(o, "y", s = /*mask*/
      e[9].y), c(o, "width", r = /*mask*/
      e[9].w), c(o, "height", l = /*mask*/
      e[9].h), c(o, "class", "svelte-1h2slbm"), c(a, "points", u = /*geom*/
      e[5].points.map(dn).join(" ")), c(a, "class", "svelte-1h2slbm"), c(n, "id", `${/*maskId*/
      e[19]}-outer`), c(n, "class", "a9s-polygon-editor-mask svelte-1h2slbm"), c(f, "class", "a9s-outer"), c(f, "mask", `url(#${/*maskId*/
      e[19]}-outer)`), c(f, "points", h = /*geom*/
      e[5].points.map(hn).join(" ")), c(m, "class", "a9s-inner a9s-shape-handle"), c(m, "mask", `url(#${/*maskId*/
      e[19]}-inner)`), c(
        m,
        "style",
        /*computedStyle*/
        e[1]
      ), c(m, "points", p = /*geom*/
      e[5].points.map(gn).join(" "));
    },
    m(v, b) {
      B(v, t, b), j(t, n), j(n, o), j(n, a), C && C.m(n, null), M && M.m(t, null), B(v, d, b), B(v, f, b), B(v, g, b), B(v, m, b), B(v, k, b);
      for (let y = 0; y < N.length; y += 1)
        N[y] && N[y].m(v, b);
      B(v, E, b), F && F.m(v, b), B(v, S, b), w = !0, A || (T = [
        W(
          f,
          "pointerup",
          /*onShapePointerUp*/
          e[14]
        ),
        W(f, "pointerdown", function() {
          ie(
            /*grab*/
            e[27]("SHAPE")
          ) && e[27]("SHAPE").apply(this, arguments);
        }),
        W(
          m,
          "pointermove",
          /*onPointerMove*/
          e[13]
        ),
        W(
          m,
          "pointerup",
          /*onShapePointerUp*/
          e[14]
        ),
        W(m, "pointerdown", function() {
          ie(
            /*grab*/
            e[27]("SHAPE")
          ) && e[27]("SHAPE").apply(this, arguments);
        })
      ], A = !0);
    },
    p(v, b) {
      if (e = v, (!w || b[0] & /*mask*/
      512 && i !== (i = /*mask*/
      e[9].x)) && c(o, "x", i), (!w || b[0] & /*mask*/
      512 && s !== (s = /*mask*/
      e[9].y)) && c(o, "y", s), (!w || b[0] & /*mask*/
      512 && r !== (r = /*mask*/
      e[9].w)) && c(o, "width", r), (!w || b[0] & /*mask*/
      512 && l !== (l = /*mask*/
      e[9].h)) && c(o, "height", l), (!w || b[0] & /*geom*/
      32 && u !== (u = /*geom*/
      e[5].points.map(dn).join(" "))) && c(a, "points", u), /*visibleMidpoint*/
      e[6] !== void 0 && !/*isHandleHovered*/
      e[7] ? C ? C.p(Ct(e), b) : (C = an(Ct(e)), C.c(), C.m(n, null)) : C && (C.d(1), C = null), /*visibleMidpoint*/
      e[6] !== void 0 && !/*isHandleHovered*/
      e[7] ? M ? M.p(It(e), b) : (M = cn(It(e)), M.c(), M.m(t, null)) : M && (M.d(1), M = null), (!w || b[0] & /*geom*/
      32 && h !== (h = /*geom*/
      e[5].points.map(hn).join(" "))) && c(f, "points", h), (!w || b[0] & /*computedStyle*/
      2) && c(
        m,
        "style",
        /*computedStyle*/
        e[1]
      ), (!w || b[0] & /*geom*/
      32 && p !== (p = /*geom*/
      e[5].points.map(gn).join(" "))) && c(m, "points", p), b[0] & /*geom, viewportScale, selectedCorners, onEnterHandle, onLeaveHandle, onHandlePointerDown, grab, onHandlePointerUp*/
      134322472) {
        R = ve(
          /*geom*/
          e[5].points
        );
        let y;
        for (y = 0; y < R.length; y += 1) {
          const _ = ln(e, R, y);
          N[y] ? (N[y].p(_, b), U(N[y], 1)) : (N[y] = un(_), N[y].c(), U(N[y], 1), N[y].m(E.parentNode, E));
        }
        for (we(), y = R.length; y < N.length; y += 1)
          q(y);
        be();
      }
      /*visibleMidpoint*/
      e[6] !== void 0 && !/*isHandleHovered*/
      e[7] ? F ? (F.p(Lt(e), b), b[0] & /*visibleMidpoint, isHandleHovered*/
      192 && U(F, 1)) : (F = fn(Lt(e)), F.c(), U(F, 1), F.m(S.parentNode, S)) : F && (we(), H(F, 1, 1, () => {
        F = null;
      }), be());
    },
    i(v) {
      if (!w) {
        for (let b = 0; b < R.length; b += 1)
          U(N[b]);
        U(F), w = !0;
      }
    },
    o(v) {
      N = N.filter(Boolean);
      for (let b = 0; b < N.length; b += 1)
        H(N[b]);
      H(F), w = !1;
    },
    d(v) {
      v && (D(t), D(d), D(f), D(g), D(m), D(k), D(E), D(S)), C && C.d(), M && M.d(), Ye(N, v), F && F.d(v), A = !1, Se(T);
    }
  };
}
function is(e) {
  let t, n;
  return t = new Kt({
    props: {
      shape: (
        /*shape*/
        e[0]
      ),
      transform: (
        /*transform*/
        e[2]
      ),
      editor: (
        /*editor*/
        e[17]
      ),
      svgEl: (
        /*svgEl*/
        e[4]
      ),
      $$slots: {
        default: [
          os,
          ({ grab: o }) => ({ 27: o }),
          ({ grab: o }) => [o ? 134217728 : 0]
        ]
      },
      $$scope: { ctx: e }
    }
  }), t.$on(
    "change",
    /*change_handler*/
    e[20]
  ), t.$on(
    "grab",
    /*grab_handler*/
    e[21]
  ), t.$on(
    "release",
    /*release_handler*/
    e[22]
  ), {
    c() {
      ae(t.$$.fragment);
    },
    m(o, i) {
      re(t, o, i), n = !0;
    },
    p(o, i) {
      const s = {};
      i[0] & /*shape*/
      1 && (s.shape = /*shape*/
      o[0]), i[0] & /*transform*/
      4 && (s.transform = /*transform*/
      o[2]), i[0] & /*svgEl*/
      16 && (s.svgEl = /*svgEl*/
      o[4]), i[0] & /*midpoints, visibleMidpoint, viewportScale, isHandleHovered, geom, selectedCorners, grab, computedStyle, mask*/
      134219754 | i[1] & /*$$scope*/
      1 && (s.$$scope = { dirty: i, ctx: o }), t.$set(s);
    },
    i(o) {
      n || (U(t.$$.fragment, o), n = !0);
    },
    o(o) {
      H(t.$$.fragment, o), n = !1;
    },
    d(o) {
      le(t, o);
    }
  };
}
const ss = 250, rs = 1e3, ls = 12, et = 4.5, dn = (e) => e.join(","), hn = (e) => e.join(","), gn = (e) => e.join(",");
function as(e, t, n) {
  let o, i, s;
  const r = Be();
  let { shape: l } = t, { computedStyle: a } = t, { transform: u } = t, { viewportScale: d = 1 } = t, { svgEl: f } = t, h, g = !1, m, p = [];
  const k = () => n(7, g = !0), E = () => n(7, g = !1), S = (y) => {
    if (p.length > 0 || !i.some((K) => K.visible)) {
      n(6, h = void 0);
      return;
    }
    const [_, I] = u.elementToImage(y.offsetX, y.offsetY), P = (K) => Math.pow(K[0] - _, 2) + Math.pow(K[1] - I, 2), O = o.points.reduce((K, J) => P(J) < P(K) ? J : K), G = i.filter((K) => K.visible).reduce((K, J) => P(J.point) < P(K.point) ? J : K), X = Math.pow(rs / d, 2);
    P(O) < X || P(G.point) < X ? n(6, h = i.indexOf(G)) : n(6, h = void 0);
  }, w = () => {
    document.activeElement !== f && f.focus();
  }, A = () => {
    n(8, p = []), w();
  }, T = (y) => {
    n(7, g = !0), y.preventDefault(), y.stopPropagation(), m = performance.now();
  }, C = (y) => (_) => {
    if (!m || Le || performance.now() - m > ss) return;
    const I = p.includes(y);
    _.metaKey || _.ctrlKey || _.shiftKey ? I ? n(8, p = p.filter((P) => P !== y)) : n(8, p = [...p, y]) : I && p.length > 1 ? n(8, p = [y]) : I ? n(8, p = []) : n(8, p = [y]), w();
  }, M = (y, _, I) => {
    w();
    let P;
    const O = y.geometry;
    p.length > 1 ? P = O.points.map(([X, Z], K) => p.includes(K) ? [X + I[0], Z + I[1]] : [X, Z]) : _ === "SHAPE" ? P = O.points.map(([X, Z]) => [X + I[0], Z + I[1]]) : P = O.points.map(([X, Z], K) => _ === `HANDLE-${K}` ? [X + I[0], Z + I[1]] : [X, Z]);
    const G = ge(P);
    return { ...y, geometry: { points: P, bounds: G } };
  }, R = (y) => async (_) => {
    _.stopPropagation();
    const I = [
      ...o.points.slice(0, y + 1),
      i[y].point,
      ...o.points.slice(y + 1)
    ], P = ge(I);
    r("change", { ...l, geometry: { points: I, bounds: P } }), await Zn();
    const O = [...document.querySelectorAll(".a9s-handle")][y + 1];
    if (O != null && O.firstChild) {
      const G = new PointerEvent(
        "pointerdown",
        {
          bubbles: !0,
          cancelable: !0,
          clientX: _.clientX,
          clientY: _.clientY,
          pointerId: _.pointerId,
          pointerType: _.pointerType,
          isPrimary: _.isPrimary,
          buttons: _.buttons
        }
      );
      O.firstChild.dispatchEvent(G);
    }
  }, N = () => {
    if (o.points.length - p.length < 3) return;
    const y = o.points.filter((I, P) => !p.includes(P)), _ = ge(y);
    r("change", { ...l, geometry: { points: y, bounds: _ } }), n(8, p = []);
  };
  Ue(() => {
    if (Le) return;
    const y = (_) => {
      (_.key === "Delete" || _.key === "Backspace") && (_.preventDefault(), N());
    };
    return f.addEventListener("pointermove", S), f.addEventListener("keydown", y), () => {
      f.removeEventListener("pointermove", S), f.removeEventListener("keydown", y);
    };
  });
  const q = `polygon-mask-${Math.random().toString(36).substring(2, 12)}`;
  function F(y) {
    ue.call(this, e, y);
  }
  function v(y) {
    ue.call(this, e, y);
  }
  function b(y) {
    ue.call(this, e, y);
  }
  return e.$$set = (y) => {
    "shape" in y && n(0, l = y.shape), "computedStyle" in y && n(1, a = y.computedStyle), "transform" in y && n(2, u = y.transform), "viewportScale" in y && n(3, d = y.viewportScale), "svgEl" in y && n(4, f = y.svgEl);
  }, e.$$.update = () => {
    e.$$.dirty[0] & /*shape*/
    1 && n(5, o = l.geometry), e.$$.dirty[0] & /*geom, viewportScale*/
    40 && n(10, i = Le ? [] : o.points.map((y, _) => {
      const I = _ === o.points.length - 1 ? o.points[0] : o.points[_ + 1], P = (y[0] + I[0]) / 2, O = (y[1] + I[1]) / 2, X = Math.sqrt(Math.pow(I[0] - P, 2) + Math.pow(I[1] - O, 2)) > ls / d;
      return { point: [P, O], visible: X };
    })), e.$$.dirty[0] & /*geom, viewportScale*/
    40 && n(9, s = wt(o.bounds, et / d));
  }, [
    l,
    a,
    u,
    d,
    f,
    o,
    h,
    g,
    p,
    s,
    i,
    k,
    E,
    S,
    A,
    T,
    C,
    M,
    R,
    q,
    F,
    v,
    b
  ];
}
class cs extends pe {
  constructor(t) {
    super(), me(
      this,
      t,
      as,
      is,
      se,
      {
        shape: 0,
        computedStyle: 1,
        transform: 2,
        viewportScale: 3,
        svgEl: 4
      },
      null,
      [-1, -1]
    );
  }
}
function us(e) {
  let t, n, o, i, s, r, l, a, u, d, f, h, g, m, p, k, E, S, w, A, T, C, M, R, N, q, F, v, b, y, _, I, P, O, G, X, Z, K, J, te, oe, Ee, ke, V, ce, $, fe, ye, Ve, Ie, bt, Ce, Q, Et, Zt;
  return $ = new qe({
    props: {
      class: "a9s-corner-handle-topleft",
      x: (
        /*geom*/
        e[5].x
      ),
      y: (
        /*geom*/
        e[5].y
      ),
      scale: (
        /*viewportScale*/
        e[3]
      )
    }
  }), $.$on("pointerdown", function() {
    ie(
      /*grab*/
      e[12]("TOP_LEFT")
    ) && e[12]("TOP_LEFT").apply(this, arguments);
  }), ye = new qe({
    props: {
      class: "a9s-corner-handle-topright",
      x: (
        /*geom*/
        e[5].x + /*geom*/
        e[5].w
      ),
      y: (
        /*geom*/
        e[5].y
      ),
      scale: (
        /*viewportScale*/
        e[3]
      )
    }
  }), ye.$on("pointerdown", function() {
    ie(
      /*grab*/
      e[12]("TOP_RIGHT")
    ) && e[12]("TOP_RIGHT").apply(this, arguments);
  }), Ie = new qe({
    props: {
      class: "a9s-corner-handle-bottomright",
      x: (
        /*geom*/
        e[5].x + /*geom*/
        e[5].w
      ),
      y: (
        /*geom*/
        e[5].y + /*geom*/
        e[5].h
      ),
      scale: (
        /*viewportScale*/
        e[3]
      )
    }
  }), Ie.$on("pointerdown", function() {
    ie(
      /*grab*/
      e[12]("BOTTOM_RIGHT")
    ) && e[12]("BOTTOM_RIGHT").apply(this, arguments);
  }), Ce = new qe({
    props: {
      class: "a9s-corner-handle-bottomleft",
      x: (
        /*geom*/
        e[5].x
      ),
      y: (
        /*geom*/
        e[5].y + /*geom*/
        e[5].h
      ),
      scale: (
        /*viewportScale*/
        e[3]
      )
    }
  }), Ce.$on("pointerdown", function() {
    ie(
      /*grab*/
      e[12]("BOTTOM_LEFT")
    ) && e[12]("BOTTOM_LEFT").apply(this, arguments);
  }), {
    c() {
      t = L("defs"), n = L("mask"), o = L("rect"), a = L("rect"), g = _e(), m = L("rect"), w = _e(), A = L("rect"), N = _e(), q = L("rect"), y = _e(), _ = L("rect"), G = _e(), X = L("rect"), te = _e(), oe = L("rect"), ce = _e(), ae($.$$.fragment), fe = _e(), ae(ye.$$.fragment), Ve = _e(), ae(Ie.$$.fragment), bt = _e(), ae(Ce.$$.fragment), c(o, "class", "rect-mask-bg svelte-1njczvj"), c(o, "x", i = /*mask*/
      e[6].x), c(o, "y", s = /*mask*/
      e[6].y), c(o, "width", r = /*mask*/
      e[6].w), c(o, "height", l = /*mask*/
      e[6].h), c(a, "class", "rect-mask-fg svelte-1njczvj"), c(a, "x", u = /*geom*/
      e[5].x), c(a, "y", d = /*geom*/
      e[5].y), c(a, "width", f = /*geom*/
      e[5].w), c(a, "height", h = /*geom*/
      e[5].h), c(
        n,
        "id",
        /*maskId*/
        e[8]
      ), c(n, "class", "a9s-rectangle-editor-mask svelte-1njczvj"), c(m, "class", "a9s-outer"), c(m, "mask", `url(#${/*maskId*/
      e[8]})`), c(m, "x", p = /*geom*/
      e[5].x), c(m, "y", k = /*geom*/
      e[5].y), c(m, "width", E = /*geom*/
      e[5].w), c(m, "height", S = /*geom*/
      e[5].h), c(A, "class", "a9s-inner a9s-shape-handle"), c(
        A,
        "style",
        /*computedStyle*/
        e[1]
      ), c(A, "x", T = /*geom*/
      e[5].x), c(A, "y", C = /*geom*/
      e[5].y), c(A, "width", M = /*geom*/
      e[5].w), c(A, "height", R = /*geom*/
      e[5].h), c(q, "class", "a9s-edge-handle a9s-edge-handle-top"), c(q, "x", F = /*geom*/
      e[5].x), c(q, "y", v = /*geom*/
      e[5].y), c(q, "height", 1), c(q, "width", b = /*geom*/
      e[5].w), c(_, "class", "a9s-edge-handle a9s-edge-handle-right"), c(_, "x", I = /*geom*/
      e[5].x + /*geom*/
      e[5].w), c(_, "y", P = /*geom*/
      e[5].y), c(_, "height", O = /*geom*/
      e[5].h), c(_, "width", 1), c(X, "class", "a9s-edge-handle a9s-edge-handle-bottom"), c(X, "x", Z = /*geom*/
      e[5].x), c(X, "y", K = /*geom*/
      e[5].y + /*geom*/
      e[5].h), c(X, "height", 1), c(X, "width", J = /*geom*/
      e[5].w), c(oe, "class", "a9s-edge-handle a9s-edge-handle-left"), c(oe, "x", Ee = /*geom*/
      e[5].x), c(oe, "y", ke = /*geom*/
      e[5].y), c(oe, "height", V = /*geom*/
      e[5].h), c(oe, "width", 1);
    },
    m(z, Y) {
      B(z, t, Y), j(t, n), j(n, o), j(n, a), B(z, g, Y), B(z, m, Y), B(z, w, Y), B(z, A, Y), B(z, N, Y), B(z, q, Y), B(z, y, Y), B(z, _, Y), B(z, G, Y), B(z, X, Y), B(z, te, Y), B(z, oe, Y), B(z, ce, Y), re($, z, Y), B(z, fe, Y), re(ye, z, Y), B(z, Ve, Y), re(Ie, z, Y), B(z, bt, Y), re(Ce, z, Y), Q = !0, Et || (Zt = [
        W(m, "pointerdown", function() {
          ie(
            /*grab*/
            e[12]("SHAPE")
          ) && e[12]("SHAPE").apply(this, arguments);
        }),
        W(A, "pointerdown", function() {
          ie(
            /*grab*/
            e[12]("SHAPE")
          ) && e[12]("SHAPE").apply(this, arguments);
        }),
        W(q, "pointerdown", function() {
          ie(
            /*grab*/
            e[12]("TOP")
          ) && e[12]("TOP").apply(this, arguments);
        }),
        W(_, "pointerdown", function() {
          ie(
            /*grab*/
            e[12]("RIGHT")
          ) && e[12]("RIGHT").apply(this, arguments);
        }),
        W(X, "pointerdown", function() {
          ie(
            /*grab*/
            e[12]("BOTTOM")
          ) && e[12]("BOTTOM").apply(this, arguments);
        }),
        W(oe, "pointerdown", function() {
          ie(
            /*grab*/
            e[12]("LEFT")
          ) && e[12]("LEFT").apply(this, arguments);
        })
      ], Et = !0);
    },
    p(z, Y) {
      e = z, (!Q || Y & /*mask*/
      64 && i !== (i = /*mask*/
      e[6].x)) && c(o, "x", i), (!Q || Y & /*mask*/
      64 && s !== (s = /*mask*/
      e[6].y)) && c(o, "y", s), (!Q || Y & /*mask*/
      64 && r !== (r = /*mask*/
      e[6].w)) && c(o, "width", r), (!Q || Y & /*mask*/
      64 && l !== (l = /*mask*/
      e[6].h)) && c(o, "height", l), (!Q || Y & /*geom*/
      32 && u !== (u = /*geom*/
      e[5].x)) && c(a, "x", u), (!Q || Y & /*geom*/
      32 && d !== (d = /*geom*/
      e[5].y)) && c(a, "y", d), (!Q || Y & /*geom*/
      32 && f !== (f = /*geom*/
      e[5].w)) && c(a, "width", f), (!Q || Y & /*geom*/
      32 && h !== (h = /*geom*/
      e[5].h)) && c(a, "height", h), (!Q || Y & /*geom*/
      32 && p !== (p = /*geom*/
      e[5].x)) && c(m, "x", p), (!Q || Y & /*geom*/
      32 && k !== (k = /*geom*/
      e[5].y)) && c(m, "y", k), (!Q || Y & /*geom*/
      32 && E !== (E = /*geom*/
      e[5].w)) && c(m, "width", E), (!Q || Y & /*geom*/
      32 && S !== (S = /*geom*/
      e[5].h)) && c(m, "height", S), (!Q || Y & /*computedStyle*/
      2) && c(
        A,
        "style",
        /*computedStyle*/
        e[1]
      ), (!Q || Y & /*geom*/
      32 && T !== (T = /*geom*/
      e[5].x)) && c(A, "x", T), (!Q || Y & /*geom*/
      32 && C !== (C = /*geom*/
      e[5].y)) && c(A, "y", C), (!Q || Y & /*geom*/
      32 && M !== (M = /*geom*/
      e[5].w)) && c(A, "width", M), (!Q || Y & /*geom*/
      32 && R !== (R = /*geom*/
      e[5].h)) && c(A, "height", R), (!Q || Y & /*geom*/
      32 && F !== (F = /*geom*/
      e[5].x)) && c(q, "x", F), (!Q || Y & /*geom*/
      32 && v !== (v = /*geom*/
      e[5].y)) && c(q, "y", v), (!Q || Y & /*geom*/
      32 && b !== (b = /*geom*/
      e[5].w)) && c(q, "width", b), (!Q || Y & /*geom*/
      32 && I !== (I = /*geom*/
      e[5].x + /*geom*/
      e[5].w)) && c(_, "x", I), (!Q || Y & /*geom*/
      32 && P !== (P = /*geom*/
      e[5].y)) && c(_, "y", P), (!Q || Y & /*geom*/
      32 && O !== (O = /*geom*/
      e[5].h)) && c(_, "height", O), (!Q || Y & /*geom*/
      32 && Z !== (Z = /*geom*/
      e[5].x)) && c(X, "x", Z), (!Q || Y & /*geom*/
      32 && K !== (K = /*geom*/
      e[5].y + /*geom*/
      e[5].h)) && c(X, "y", K), (!Q || Y & /*geom*/
      32 && J !== (J = /*geom*/
      e[5].w)) && c(X, "width", J), (!Q || Y & /*geom*/
      32 && Ee !== (Ee = /*geom*/
      e[5].x)) && c(oe, "x", Ee), (!Q || Y & /*geom*/
      32 && ke !== (ke = /*geom*/
      e[5].y)) && c(oe, "y", ke), (!Q || Y & /*geom*/
      32 && V !== (V = /*geom*/
      e[5].h)) && c(oe, "height", V);
      const nt = {};
      Y & /*geom*/
      32 && (nt.x = /*geom*/
      e[5].x), Y & /*geom*/
      32 && (nt.y = /*geom*/
      e[5].y), Y & /*viewportScale*/
      8 && (nt.scale = /*viewportScale*/
      e[3]), $.$set(nt);
      const ot = {};
      Y & /*geom*/
      32 && (ot.x = /*geom*/
      e[5].x + /*geom*/
      e[5].w), Y & /*geom*/
      32 && (ot.y = /*geom*/
      e[5].y), Y & /*viewportScale*/
      8 && (ot.scale = /*viewportScale*/
      e[3]), ye.$set(ot);
      const it = {};
      Y & /*geom*/
      32 && (it.x = /*geom*/
      e[5].x + /*geom*/
      e[5].w), Y & /*geom*/
      32 && (it.y = /*geom*/
      e[5].y + /*geom*/
      e[5].h), Y & /*viewportScale*/
      8 && (it.scale = /*viewportScale*/
      e[3]), Ie.$set(it);
      const st = {};
      Y & /*geom*/
      32 && (st.x = /*geom*/
      e[5].x), Y & /*geom*/
      32 && (st.y = /*geom*/
      e[5].y + /*geom*/
      e[5].h), Y & /*viewportScale*/
      8 && (st.scale = /*viewportScale*/
      e[3]), Ce.$set(st);
    },
    i(z) {
      Q || (U($.$$.fragment, z), U(ye.$$.fragment, z), U(Ie.$$.fragment, z), U(Ce.$$.fragment, z), Q = !0);
    },
    o(z) {
      H($.$$.fragment, z), H(ye.$$.fragment, z), H(Ie.$$.fragment, z), H(Ce.$$.fragment, z), Q = !1;
    },
    d(z) {
      z && (D(t), D(g), D(m), D(w), D(A), D(N), D(q), D(y), D(_), D(G), D(X), D(te), D(oe), D(ce), D(fe), D(Ve), D(bt)), le($, z), le(ye, z), le(Ie, z), le(Ce, z), Et = !1, Se(Zt);
    }
  };
}
function fs(e) {
  let t, n;
  return t = new Kt({
    props: {
      shape: (
        /*shape*/
        e[0]
      ),
      transform: (
        /*transform*/
        e[2]
      ),
      editor: (
        /*editor*/
        e[7]
      ),
      svgEl: (
        /*svgEl*/
        e[4]
      ),
      $$slots: {
        default: [
          us,
          ({ grab: o }) => ({ 12: o }),
          ({ grab: o }) => o ? 4096 : 0
        ]
      },
      $$scope: { ctx: e }
    }
  }), t.$on(
    "grab",
    /*grab_handler*/
    e[9]
  ), t.$on(
    "change",
    /*change_handler*/
    e[10]
  ), t.$on(
    "release",
    /*release_handler*/
    e[11]
  ), {
    c() {
      ae(t.$$.fragment);
    },
    m(o, i) {
      re(t, o, i), n = !0;
    },
    p(o, [i]) {
      const s = {};
      i & /*shape*/
      1 && (s.shape = /*shape*/
      o[0]), i & /*transform*/
      4 && (s.transform = /*transform*/
      o[2]), i & /*svgEl*/
      16 && (s.svgEl = /*svgEl*/
      o[4]), i & /*$$scope, geom, viewportScale, grab, computedStyle, mask*/
      12394 && (s.$$scope = { dirty: i, ctx: o }), t.$set(s);
    },
    i(o) {
      n || (U(t.$$.fragment, o), n = !0);
    },
    o(o) {
      H(t.$$.fragment, o), n = !1;
    },
    d(o) {
      le(t, o);
    }
  };
}
function ds(e, t, n) {
  let o, i, { shape: s } = t, { computedStyle: r } = t, { transform: l } = t, { viewportScale: a = 1 } = t, { svgEl: u } = t;
  const d = (p, k, E) => {
    const S = p.geometry.bounds;
    let [w, A] = [S.minX, S.minY], [T, C] = [S.maxX, S.maxY];
    const [M, R] = E;
    if (k === "SHAPE")
      w += M, T += M, A += R, C += R;
    else {
      switch (k) {
        case "TOP":
        case "TOP_LEFT":
        case "TOP_RIGHT": {
          A += R;
          break;
        }
        case "BOTTOM":
        case "BOTTOM_LEFT":
        case "BOTTOM_RIGHT": {
          C += R;
          break;
        }
      }
      switch (k) {
        case "LEFT":
        case "TOP_LEFT":
        case "BOTTOM_LEFT": {
          w += M;
          break;
        }
        case "RIGHT":
        case "TOP_RIGHT":
        case "BOTTOM_RIGHT": {
          T += M;
          break;
        }
      }
    }
    const N = Math.min(w, T), q = Math.min(A, C), F = Math.abs(T - w), v = Math.abs(C - A);
    return {
      ...p,
      geometry: {
        x: N,
        y: q,
        w: F,
        h: v,
        bounds: {
          minX: N,
          minY: q,
          maxX: N + F,
          maxY: q + v
        }
      }
    };
  }, f = `rect-mask-${Math.random().toString(36).substring(2, 12)}`;
  function h(p) {
    ue.call(this, e, p);
  }
  function g(p) {
    ue.call(this, e, p);
  }
  function m(p) {
    ue.call(this, e, p);
  }
  return e.$$set = (p) => {
    "shape" in p && n(0, s = p.shape), "computedStyle" in p && n(1, r = p.computedStyle), "transform" in p && n(2, l = p.transform), "viewportScale" in p && n(3, a = p.viewportScale), "svgEl" in p && n(4, u = p.svgEl);
  }, e.$$.update = () => {
    e.$$.dirty & /*shape*/
    1 && n(5, o = s.geometry), e.$$.dirty & /*geom, viewportScale*/
    40 && n(6, i = wt(o.bounds, 2 / a));
  }, [
    s,
    r,
    l,
    a,
    u,
    o,
    i,
    d,
    f,
    h,
    g,
    m
  ];
}
class hs extends pe {
  constructor(t) {
    super(), me(this, t, ds, fs, se, {
      shape: 0,
      computedStyle: 1,
      transform: 2,
      viewportScale: 3,
      svgEl: 4
    });
  }
}
var mn = Object.prototype.hasOwnProperty;
function Ft(e, t) {
  var n, o;
  if (e === t) return !0;
  if (e && t && (n = e.constructor) === t.constructor) {
    if (n === Date) return e.getTime() === t.getTime();
    if (n === RegExp) return e.toString() === t.toString();
    if (n === Array) {
      if ((o = e.length) === t.length)
        for (; o-- && Ft(e[o], t[o]); ) ;
      return o === -1;
    }
    if (!n || typeof e == "object") {
      o = 0;
      for (n in e)
        if (mn.call(e, n) && ++o && !mn.call(t, n) || !(n in t) || !Ft(e[n], t[n])) return !1;
      return Object.keys(t).length === o;
    }
  }
  return e !== e && t !== t;
}
const gs = 12, ms = (e, t) => e.polygons.reduce((n, o, i) => {
  const s = o.rings.reduce((r, l, a) => {
    const u = l.points.map((d, f) => {
      const h = f === l.points.length - 1 ? l.points[0] : l.points[f + 1], g = (d[0] + h[0]) / 2, m = (d[1] + h[1]) / 2, k = Math.sqrt(
        Math.pow(h[0] - g, 2) + Math.pow(h[1] - m, 2)
      ) > gs / t;
      return { point: [g, m], visible: k, elementIdx: i, ringIdx: a, pointIdx: f };
    });
    return [...r, ...u];
  }, []);
  return [...n, ...s];
}, []);
function Ot(e) {
  const t = e.slice(), n = (
    /*midpoints*/
    t[10][
      /*visibleMidpoint*/
      t[6]
    ]
  );
  return t[29] = n.point, t;
}
function pn(e, t, n) {
  const o = e.slice();
  return o[30] = t[n], o[32] = n, o;
}
function yn(e, t, n) {
  const o = e.slice();
  return o[33] = t[n], o[35] = n, o;
}
function _n(e, t, n) {
  const o = e.slice();
  return o[29] = t[n], o[37] = n, o;
}
function Dt(e) {
  const t = e.slice(), n = (
    /*midpoints*/
    t[10][
      /*visibleMidpoint*/
      t[6]
    ]
  );
  return t[29] = n.point, t;
}
function Bt(e) {
  const t = e.slice(), n = (
    /*midpoints*/
    t[10][
      /*visibleMidpoint*/
      t[6]
    ]
  );
  return t[29] = n.point, t;
}
function wn(e) {
  let t, n, o, i;
  return {
    c() {
      t = L("circle"), c(t, "cx", n = /*point*/
      e[29][0]), c(t, "cy", o = /*point*/
      e[29][1]), c(t, "r", i = tt / /*viewportScale*/
      e[3]), c(t, "class", "svelte-1vxo6dc");
    },
    m(s, r) {
      B(s, t, r);
    },
    p(s, r) {
      r[0] & /*midpoints, visibleMidpoint*/
      1088 && n !== (n = /*point*/
      s[29][0]) && c(t, "cx", n), r[0] & /*midpoints, visibleMidpoint*/
      1088 && o !== (o = /*point*/
      s[29][1]) && c(t, "cy", o), r[0] & /*viewportScale*/
      8 && i !== (i = tt / /*viewportScale*/
      s[3]) && c(t, "r", i);
    },
    d(s) {
      s && D(t);
    }
  };
}
function bn(e) {
  let t, n, o, i, s, r, l, a, u, d;
  return {
    c() {
      t = L("mask"), n = L("rect"), l = L("circle"), c(n, "x", o = /*mask*/
      e[9].x), c(n, "y", i = /*mask*/
      e[9].y), c(n, "width", s = /*mask*/
      e[9].w), c(n, "height", r = /*mask*/
      e[9].h), c(n, "class", "svelte-1vxo6dc"), c(l, "cx", a = /*point*/
      e[29][0]), c(l, "cy", u = /*point*/
      e[29][1]), c(l, "r", d = tt / /*viewportScale*/
      e[3]), c(l, "class", "svelte-1vxo6dc"), c(t, "id", `${/*maskId*/
      e[18]}-${/*elementIdx*/
      e[32]}-inner`), c(t, "class", "a9s-multipolygon-editor-mask svelte-1vxo6dc");
    },
    m(f, h) {
      B(f, t, h), j(t, n), j(t, l);
    },
    p(f, h) {
      h[0] & /*mask*/
      512 && o !== (o = /*mask*/
      f[9].x) && c(n, "x", o), h[0] & /*mask*/
      512 && i !== (i = /*mask*/
      f[9].y) && c(n, "y", i), h[0] & /*mask*/
      512 && s !== (s = /*mask*/
      f[9].w) && c(n, "width", s), h[0] & /*mask*/
      512 && r !== (r = /*mask*/
      f[9].h) && c(n, "height", r), h[0] & /*midpoints, visibleMidpoint*/
      1088 && a !== (a = /*point*/
      f[29][0]) && c(l, "cx", a), h[0] & /*midpoints, visibleMidpoint*/
      1088 && u !== (u = /*point*/
      f[29][1]) && c(l, "cy", u), h[0] & /*viewportScale*/
      8 && d !== (d = tt / /*viewportScale*/
      f[3]) && c(l, "r", d);
    },
    d(f) {
      f && D(t);
    }
  };
}
function En(e) {
  let t, n;
  function o(...i) {
    return (
      /*func*/
      e[19](
        /*elementIdx*/
        e[32],
        /*ringIdx*/
        e[35],
        /*pointIdx*/
        e[37],
        ...i
      )
    );
  }
  return t = new qe({
    props: {
      class: "a9s-corner-handle",
      x: (
        /*point*/
        e[29][0]
      ),
      y: (
        /*point*/
        e[29][1]
      ),
      scale: (
        /*viewportScale*/
        e[3]
      ),
      selected: (
        /*selectedCorners*/
        e[8].some(o)
      )
    }
  }), t.$on(
    "pointerenter",
    /*onEnterHandle*/
    e[11]
  ), t.$on(
    "pointerleave",
    /*onLeaveHandle*/
    e[12]
  ), t.$on(
    "pointerdown",
    /*onHandlePointerDown*/
    e[14]
  ), t.$on("pointerdown", function() {
    ie(
      /*grab*/
      e[28](`HANDLE-${/*elementIdx*/
      e[32]}-${/*ringIdx*/
      e[35]}-${/*pointIdx*/
      e[37]}`)
    ) && e[28](`HANDLE-${/*elementIdx*/
    e[32]}-${/*ringIdx*/
    e[35]}-${/*pointIdx*/
    e[37]}`).apply(this, arguments);
  }), t.$on(
    "pointerup",
    /*onHandlePointerUp*/
    e[15](
      /*elementIdx*/
      e[32],
      /*ringIdx*/
      e[35],
      /*pointIdx*/
      e[37]
    )
  ), {
    c() {
      ae(t.$$.fragment);
    },
    m(i, s) {
      re(t, i, s), n = !0;
    },
    p(i, s) {
      e = i;
      const r = {};
      s[0] & /*geom*/
      32 && (r.x = /*point*/
      e[29][0]), s[0] & /*geom*/
      32 && (r.y = /*point*/
      e[29][1]), s[0] & /*viewportScale*/
      8 && (r.scale = /*viewportScale*/
      e[3]), s[0] & /*selectedCorners*/
      256 && (r.selected = /*selectedCorners*/
      e[8].some(o)), t.$set(r);
    },
    i(i) {
      n || (U(t.$$.fragment, i), n = !0);
    },
    o(i) {
      H(t.$$.fragment, i), n = !1;
    },
    d(i) {
      le(t, i);
    }
  };
}
function vn(e) {
  let t, n, o = ve(
    /*ring*/
    e[33].points
  ), i = [];
  for (let r = 0; r < o.length; r += 1)
    i[r] = En(_n(e, o, r));
  const s = (r) => H(i[r], 1, 1, () => {
    i[r] = null;
  });
  return {
    c() {
      for (let r = 0; r < i.length; r += 1)
        i[r].c();
      t = Ae();
    },
    m(r, l) {
      for (let a = 0; a < i.length; a += 1)
        i[a] && i[a].m(r, l);
      B(r, t, l), n = !0;
    },
    p(r, l) {
      if (l[0] & /*geom, viewportScale, selectedCorners, onEnterHandle, onLeaveHandle, onHandlePointerDown, grab, onHandlePointerUp*/
      268491048) {
        o = ve(
          /*ring*/
          r[33].points
        );
        let a;
        for (a = 0; a < o.length; a += 1) {
          const u = _n(r, o, a);
          i[a] ? (i[a].p(u, l), U(i[a], 1)) : (i[a] = En(u), i[a].c(), U(i[a], 1), i[a].m(t.parentNode, t));
        }
        for (we(), a = o.length; a < i.length; a += 1)
          s(a);
        be();
      }
    },
    i(r) {
      if (!n) {
        for (let l = 0; l < o.length; l += 1)
          U(i[l]);
        n = !0;
      }
    },
    o(r) {
      i = i.filter(Boolean);
      for (let l = 0; l < i.length; l += 1)
        H(i[l]);
      n = !1;
    },
    d(r) {
      r && D(t), Ye(i, r);
    }
  };
}
function Sn(e) {
  let t, n, o, i, s, r, l, a, u, d, f, h, g, m, p, k, E, S = (
    /*visibleMidpoint*/
    e[6] !== void 0 && !/*isHandleHovered*/
    e[7] && wn(Bt(e))
  ), w = (
    /*visibleMidpoint*/
    e[6] !== void 0 && !/*isHandleHovered*/
    e[7] && bn(Dt(e))
  ), A = ve(
    /*element*/
    e[30].rings
  ), T = [];
  for (let M = 0; M < A.length; M += 1)
    T[M] = vn(yn(e, A, M));
  const C = (M) => H(T[M], 1, 1, () => {
    T[M] = null;
  });
  return {
    c() {
      t = L("g"), n = L("defs"), o = L("mask"), i = L("rect"), u = L("path"), S && S.c(), w && w.c(), f = L("path"), g = L("path");
      for (let M = 0; M < T.length; M += 1)
        T[M].c();
      c(i, "x", s = /*mask*/
      e[9].x), c(i, "y", r = /*mask*/
      e[9].y), c(i, "width", l = /*mask*/
      e[9].w), c(i, "height", a = /*mask*/
      e[9].h), c(i, "class", "svelte-1vxo6dc"), c(u, "d", d = Pe(
        /*element*/
        e[30]
      )), c(u, "class", "svelte-1vxo6dc"), c(o, "id", `${/*maskId*/
      e[18]}-${/*elementIdx*/
      e[32]}-outer`), c(o, "class", "a9s-multipolygon-editor-mask svelte-1vxo6dc"), c(f, "class", "a9s-outer"), c(f, "mask", `url(#${/*maskId*/
      e[18]}-${/*elementIdx*/
      e[32]}-outer)`), c(f, "fill-rule", "evenodd"), c(f, "d", h = Pe(
        /*element*/
        e[30]
      )), c(g, "class", "a9s-inner"), c(g, "mask", `url(#${/*maskId*/
      e[18]}-${/*elementIdx*/
      e[32]}-inner)`), c(
        g,
        "style",
        /*computedStyle*/
        e[1]
      ), c(g, "fill-rule", "evenodd"), c(g, "d", m = Pe(
        /*element*/
        e[30]
      ));
    },
    m(M, R) {
      B(M, t, R), j(t, n), j(n, o), j(o, i), j(o, u), S && S.m(o, null), w && w.m(n, null), j(t, f), j(t, g);
      for (let N = 0; N < T.length; N += 1)
        T[N] && T[N].m(t, null);
      p = !0, k || (E = [
        W(
          f,
          "pointerup",
          /*onShapePointerUp*/
          e[13]
        ),
        W(f, "pointerdown", function() {
          ie(
            /*grab*/
            e[28]("SHAPE")
          ) && e[28]("SHAPE").apply(this, arguments);
        }),
        W(
          g,
          "pointerup",
          /*onShapePointerUp*/
          e[13]
        ),
        W(g, "pointerdown", function() {
          ie(
            /*grab*/
            e[28]("SHAPE")
          ) && e[28]("SHAPE").apply(this, arguments);
        })
      ], k = !0);
    },
    p(M, R) {
      if (e = M, (!p || R[0] & /*mask*/
      512 && s !== (s = /*mask*/
      e[9].x)) && c(i, "x", s), (!p || R[0] & /*mask*/
      512 && r !== (r = /*mask*/
      e[9].y)) && c(i, "y", r), (!p || R[0] & /*mask*/
      512 && l !== (l = /*mask*/
      e[9].w)) && c(i, "width", l), (!p || R[0] & /*mask*/
      512 && a !== (a = /*mask*/
      e[9].h)) && c(i, "height", a), (!p || R[0] & /*geom*/
      32 && d !== (d = Pe(
        /*element*/
        e[30]
      ))) && c(u, "d", d), /*visibleMidpoint*/
      e[6] !== void 0 && !/*isHandleHovered*/
      e[7] ? S ? S.p(Bt(e), R) : (S = wn(Bt(e)), S.c(), S.m(o, null)) : S && (S.d(1), S = null), /*visibleMidpoint*/
      e[6] !== void 0 && !/*isHandleHovered*/
      e[7] ? w ? w.p(Dt(e), R) : (w = bn(Dt(e)), w.c(), w.m(n, null)) : w && (w.d(1), w = null), (!p || R[0] & /*geom*/
      32 && h !== (h = Pe(
        /*element*/
        e[30]
      ))) && c(f, "d", h), (!p || R[0] & /*computedStyle*/
      2) && c(
        g,
        "style",
        /*computedStyle*/
        e[1]
      ), (!p || R[0] & /*geom*/
      32 && m !== (m = Pe(
        /*element*/
        e[30]
      ))) && c(g, "d", m), R[0] & /*geom, viewportScale, selectedCorners, onEnterHandle, onLeaveHandle, onHandlePointerDown, grab, onHandlePointerUp*/
      268491048) {
        A = ve(
          /*element*/
          e[30].rings
        );
        let N;
        for (N = 0; N < A.length; N += 1) {
          const q = yn(e, A, N);
          T[N] ? (T[N].p(q, R), U(T[N], 1)) : (T[N] = vn(q), T[N].c(), U(T[N], 1), T[N].m(t, null));
        }
        for (we(), N = A.length; N < T.length; N += 1)
          C(N);
        be();
      }
    },
    i(M) {
      if (!p) {
        for (let R = 0; R < A.length; R += 1)
          U(T[R]);
        p = !0;
      }
    },
    o(M) {
      T = T.filter(Boolean);
      for (let R = 0; R < T.length; R += 1)
        H(T[R]);
      p = !1;
    },
    d(M) {
      M && D(t), S && S.d(), w && w.d(), Ye(T, M), k = !1, Se(E);
    }
  };
}
function An(e) {
  let t, n;
  return t = new ao({
    props: {
      x: (
        /*point*/
        e[29][0]
      ),
      y: (
        /*point*/
        e[29][1]
      ),
      scale: (
        /*viewportScale*/
        e[3]
      )
    }
  }), t.$on("pointerdown", function() {
    ie(
      /*onAddPoint*/
      e[17](
        /*visibleMidpoint*/
        e[6]
      )
    ) && e[17](
      /*visibleMidpoint*/
      e[6]
    ).apply(this, arguments);
  }), {
    c() {
      ae(t.$$.fragment);
    },
    m(o, i) {
      re(t, o, i), n = !0;
    },
    p(o, i) {
      e = o;
      const s = {};
      i[0] & /*midpoints, visibleMidpoint*/
      1088 && (s.x = /*point*/
      e[29][0]), i[0] & /*midpoints, visibleMidpoint*/
      1088 && (s.y = /*point*/
      e[29][1]), i[0] & /*viewportScale*/
      8 && (s.scale = /*viewportScale*/
      e[3]), t.$set(s);
    },
    i(o) {
      n || (U(t.$$.fragment, o), n = !0);
    },
    o(o) {
      H(t.$$.fragment, o), n = !1;
    },
    d(o) {
      le(t, o);
    }
  };
}
function ps(e) {
  let t, n, o, i = ve(
    /*geom*/
    e[5].polygons
  ), s = [];
  for (let a = 0; a < i.length; a += 1)
    s[a] = Sn(pn(e, i, a));
  const r = (a) => H(s[a], 1, 1, () => {
    s[a] = null;
  });
  let l = (
    /*visibleMidpoint*/
    e[6] !== void 0 && !/*isHandleHovered*/
    e[7] && An(Ot(e))
  );
  return {
    c() {
      for (let a = 0; a < s.length; a += 1)
        s[a].c();
      t = _e(), l && l.c(), n = Ae();
    },
    m(a, u) {
      for (let d = 0; d < s.length; d += 1)
        s[d] && s[d].m(a, u);
      B(a, t, u), l && l.m(a, u), B(a, n, u), o = !0;
    },
    p(a, u) {
      if (u[0] & /*geom, viewportScale, selectedCorners, onEnterHandle, onLeaveHandle, onHandlePointerDown, grab, onHandlePointerUp, maskId, computedStyle, onShapePointerUp, midpoints, visibleMidpoint, mask, isHandleHovered*/
      268763114) {
        i = ve(
          /*geom*/
          a[5].polygons
        );
        let d;
        for (d = 0; d < i.length; d += 1) {
          const f = pn(a, i, d);
          s[d] ? (s[d].p(f, u), U(s[d], 1)) : (s[d] = Sn(f), s[d].c(), U(s[d], 1), s[d].m(t.parentNode, t));
        }
        for (we(), d = i.length; d < s.length; d += 1)
          r(d);
        be();
      }
      /*visibleMidpoint*/
      a[6] !== void 0 && !/*isHandleHovered*/
      a[7] ? l ? (l.p(Ot(a), u), u[0] & /*visibleMidpoint, isHandleHovered*/
      192 && U(l, 1)) : (l = An(Ot(a)), l.c(), U(l, 1), l.m(n.parentNode, n)) : l && (we(), H(l, 1, 1, () => {
        l = null;
      }), be());
    },
    i(a) {
      if (!o) {
        for (let u = 0; u < i.length; u += 1)
          U(s[u]);
        U(l), o = !0;
      }
    },
    o(a) {
      s = s.filter(Boolean);
      for (let u = 0; u < s.length; u += 1)
        H(s[u]);
      H(l), o = !1;
    },
    d(a) {
      a && (D(t), D(n)), Ye(s, a), l && l.d(a);
    }
  };
}
function ys(e) {
  let t, n;
  return t = new Kt({
    props: {
      shape: (
        /*shape*/
        e[0]
      ),
      transform: (
        /*transform*/
        e[2]
      ),
      editor: (
        /*editor*/
        e[16]
      ),
      svgEl: (
        /*svgEl*/
        e[4]
      ),
      $$slots: {
        default: [
          ps,
          ({ grab: o }) => ({ 28: o }),
          ({ grab: o }) => [o ? 268435456 : 0]
        ]
      },
      $$scope: { ctx: e }
    }
  }), t.$on(
    "change",
    /*change_handler*/
    e[20]
  ), t.$on(
    "grab",
    /*grab_handler*/
    e[21]
  ), t.$on(
    "release",
    /*release_handler*/
    e[22]
  ), {
    c() {
      ae(t.$$.fragment);
    },
    m(o, i) {
      re(t, o, i), n = !0;
    },
    p(o, i) {
      const s = {};
      i[0] & /*shape*/
      1 && (s.shape = /*shape*/
      o[0]), i[0] & /*transform*/
      4 && (s.transform = /*transform*/
      o[2]), i[0] & /*svgEl*/
      16 && (s.svgEl = /*svgEl*/
      o[4]), i[0] & /*midpoints, visibleMidpoint, viewportScale, isHandleHovered, geom, selectedCorners, grab, computedStyle, mask*/
      268437482 | i[1] & /*$$scope*/
      128 && (s.$$scope = { dirty: i, ctx: o }), t.$set(s);
    },
    i(o) {
      n || (U(t.$$.fragment, o), n = !0);
    },
    o(o) {
      H(t.$$.fragment, o), n = !1;
    },
    d(o) {
      le(t, o);
    }
  };
}
const _s = 250, ws = 1e3, tt = 4.5;
function bs(e, t, n) {
  let o, i, s;
  const r = Be();
  let { shape: l } = t, { computedStyle: a } = t, { transform: u } = t, { viewportScale: d = 1 } = t, { svgEl: f } = t, h, g = !1, m, p = [];
  const k = () => n(7, g = !0), E = () => n(7, g = !1), S = (_) => {
    if (p.length > 0 || !i.some((J) => J.visible)) {
      n(6, h = void 0);
      return;
    }
    const [I, P] = u.elementToImage(_.offsetX, _.offsetY), O = (J) => Math.pow(J[0] - I, 2) + Math.pow(J[1] - P, 2), G = Yo(o).reduce((J, te) => O(te) < O(J) ? te : J), X = i.filter((J) => J.visible).reduce((J, te) => O(te.point) < O(J.point) ? te : J), Z = Math.pow(ws / d, 2);
    O(G) < Z || O(X.point) < Z ? n(6, h = i.indexOf(X)) : n(6, h = void 0);
  }, w = () => {
    document.activeElement !== f && f.focus();
  }, A = () => {
    n(8, p = []), w();
  }, T = (_) => {
    n(7, g = !0), _.preventDefault(), _.stopPropagation(), m = performance.now();
  }, C = (_, I, P) => (O) => {
    if (!m || Le || performance.now() - m > _s) return;
    const G = (Z) => Z.polygon === _ && Z.ring === I && Z.point === P, X = p.some(G);
    O.metaKey || O.ctrlKey || O.shiftKey ? X ? n(8, p = p.filter((Z) => !G(Z))) : n(8, p = [...p, { polygon: _, ring: I, point: P }]) : X && p.length > 1 ? n(8, p = [{ polygon: _, ring: I, point: P }]) : X ? n(8, p = []) : n(8, p = [{ polygon: _, ring: I, point: P }]), w();
  }, M = (_, I, P) => {
    w();
    const O = _.geometry.polygons;
    let G;
    if (I === "SHAPE")
      G = O.map((X) => {
        const Z = X.rings.map((J, te) => ({ points: J.points.map((Ee, ke) => [Ee[0] + P[0], Ee[1] + P[1]]) })), K = ge(Z[0].points);
        return { rings: Z, bounds: K };
      });
    else {
      const [X, Z, K, J] = I.split("-").map((te) => parseInt(te));
      G = O.map((te, oe) => {
        if (oe === Z) {
          const Ee = te.rings.map((V, ce) => ce === K ? { points: V.points.map((fe, ye) => ye === J ? [fe[0] + P[0], fe[1] + P[1]] : fe) } : V), ke = ge(Ee[0].points);
          return { rings: Ee, bounds: ke };
        } else
          return te;
      });
    }
    return {
      ..._,
      geometry: {
        polygons: G,
        bounds: dt(G)
      }
    };
  }, R = (_) => async (I) => {
    I.stopPropagation();
    const P = i[_], O = o.polygons.map((X, Z) => {
      if (Z === P.elementIdx) {
        const K = X.rings.map((te, oe) => oe === P.ringIdx ? { points: [
          ...te.points.slice(0, P.pointIdx + 1),
          P.point,
          ...te.points.slice(P.pointIdx + 1)
        ] } : te), J = ge(K[0].points);
        return { rings: K, bounds: J };
      } else
        return X;
    });
    r("change", {
      ...l,
      geometry: {
        polygons: O,
        bounds: dt(O)
      }
    }), await Zn();
    const G = [...document.querySelectorAll(".a9s-handle")][_ + 1];
    if (G != null && G.firstChild) {
      const X = new PointerEvent(
        "pointerdown",
        {
          bubbles: !0,
          cancelable: !0,
          clientX: I.clientX,
          clientY: I.clientY,
          pointerId: I.pointerId,
          pointerType: I.pointerType,
          isPrimary: I.isPrimary,
          buttons: I.buttons
        }
      );
      G.firstChild.dispatchEvent(X);
    }
  }, N = () => {
    const _ = o.polygons.map((P, O) => {
      if (p.some((X) => X.polygon === O)) {
        const X = P.rings.map((K, J) => {
          const te = p.filter((oe) => oe.polygon === O && oe.ring === J);
          return te.length && K.points.length - te.length >= 3 ? { points: K.points.filter((Ee, ke) => !te.some((V) => V.point === ke)) } : K;
        }), Z = ge(X[0].points);
        return { rings: X, bounds: Z };
      } else
        return P;
    });
    !Ft(o.polygons, _) && (r("change", {
      ...l,
      geometry: {
        polygons: _,
        bounds: dt(_)
      }
    }), n(8, p = []));
  };
  Ue(() => {
    if (Le) return;
    const _ = (I) => {
      (I.key === "Delete" || I.key === "Backspace") && (I.preventDefault(), N());
    };
    return f.addEventListener("pointermove", S), f.addEventListener("keydown", _), () => {
      f.removeEventListener("pointermove", S), f.removeEventListener("keydown", _);
    };
  });
  const q = `polygon-mask-${Math.random().toString(36).substring(2, 12)}`, F = (_, I, P, { polygon: O, ring: G, point: X }) => O === _ && G === I && X === P;
  function v(_) {
    ue.call(this, e, _);
  }
  function b(_) {
    ue.call(this, e, _);
  }
  function y(_) {
    ue.call(this, e, _);
  }
  return e.$$set = (_) => {
    "shape" in _ && n(0, l = _.shape), "computedStyle" in _ && n(1, a = _.computedStyle), "transform" in _ && n(2, u = _.transform), "viewportScale" in _ && n(3, d = _.viewportScale), "svgEl" in _ && n(4, f = _.svgEl);
  }, e.$$.update = () => {
    e.$$.dirty[0] & /*shape*/
    1 && n(5, o = l.geometry), e.$$.dirty[0] & /*geom, viewportScale*/
    40 && n(10, i = Le ? [] : ms(o, d)), e.$$.dirty[0] & /*geom, viewportScale*/
    40 && n(9, s = wt(o.bounds, tt / d));
  }, [
    l,
    a,
    u,
    d,
    f,
    o,
    h,
    g,
    p,
    s,
    i,
    k,
    E,
    A,
    T,
    C,
    M,
    R,
    q,
    F,
    v,
    b,
    y
  ];
}
class Es extends pe {
  constructor(t) {
    super(), me(
      this,
      t,
      bs,
      ys,
      se,
      {
        shape: 0,
        computedStyle: 1,
        transform: 2,
        viewportScale: 3,
        svgEl: 4
      },
      null,
      [-1, -1]
    );
  }
}
const co = /* @__PURE__ */ new Map([
  [x.RECTANGLE, hs],
  [x.POLYGON, cs],
  [x.MULTIPOLYGON, Es]
]), vs = (e) => co.get(e.type), Ss = (e, t) => co.set(e, t);
function As(e, t, n) {
  let o;
  const i = Be();
  let { annotation: s } = t, { editor: r } = t, { style: l } = t, { target: a } = t, { transform: u } = t, { viewportScale: d } = t, f;
  return Ue(() => (n(6, f = new r({
    target: a,
    props: {
      shape: s.target.selector,
      computedStyle: o,
      transform: u,
      viewportScale: d,
      svgEl: a.closest("svg")
    }
  })), f.$on("change", (h) => {
    f.$$set({ shape: h.detail }), i("change", h.detail);
  }), f.$on("grab", (h) => i("grab", h.detail)), f.$on("release", (h) => i("release", h.detail)), () => {
    f.$destroy();
  })), e.$$set = (h) => {
    "annotation" in h && n(0, s = h.annotation), "editor" in h && n(1, r = h.editor), "style" in h && n(2, l = h.style), "target" in h && n(3, a = h.target), "transform" in h && n(4, u = h.transform), "viewportScale" in h && n(5, d = h.viewportScale);
  }, e.$$.update = () => {
    e.$$.dirty & /*annotation, style*/
    5 && n(7, o = Re(s, l, { selected: !0, hovered: !0 })), e.$$.dirty & /*annotation, editorComponent*/
    65 && s && (f == null || f.$set({ shape: s.target.selector })), e.$$.dirty & /*editorComponent, transform*/
    80 && f && f.$set({ transform: u }), e.$$.dirty & /*editorComponent, viewportScale*/
    96 && f && f.$set({ viewportScale: d }), e.$$.dirty & /*editorComponent, computedStyle*/
    192 && f && o && f.$set({ computedStyle: o });
  }, [
    s,
    r,
    l,
    a,
    u,
    d,
    f,
    o
  ];
}
class ks extends pe {
  constructor(t) {
    super(), me(this, t, As, null, se, {
      annotation: 0,
      editor: 1,
      style: 2,
      target: 3,
      transform: 4,
      viewportScale: 5
    });
  }
}
function Ms(e, t, n) {
  const o = Be();
  let { drawingMode: i } = t, { target: s } = t, { tool: r } = t, { transform: l } = t, { viewportScale: a } = t, u;
  return Ue(() => {
    const d = s.closest("svg"), f = [], h = (g, m, p) => {
      d == null || d.addEventListener(g, m, p), f.push(() => d == null ? void 0 : d.removeEventListener(g, m, p));
    };
    return n(5, u = new r({
      target: s,
      props: {
        addEventListener: h,
        drawingMode: i,
        transform: l,
        viewportScale: a
      }
    })), u.$on("create", (g) => o("create", g.detail)), () => {
      f.forEach((g) => g()), u.$destroy();
    };
  }), e.$$set = (d) => {
    "drawingMode" in d && n(0, i = d.drawingMode), "target" in d && n(1, s = d.target), "tool" in d && n(2, r = d.tool), "transform" in d && n(3, l = d.transform), "viewportScale" in d && n(4, a = d.viewportScale);
  }, e.$$.update = () => {
    e.$$.dirty & /*toolComponent, transform*/
    40 && u && u.$set({ transform: l }), e.$$.dirty & /*toolComponent, viewportScale*/
    48 && u && u.$set({ viewportScale: a });
  }, [i, s, r, l, a, u];
}
class Ts extends pe {
  constructor(t) {
    super(), me(this, t, Ms, null, se, {
      drawingMode: 0,
      target: 1,
      tool: 2,
      transform: 3,
      viewportScale: 4
    });
  }
}
function kn(e) {
  let t, n, o, i, s, r, l, a, u, d;
  return {
    c() {
      t = L("defs"), n = L("mask"), o = L("rect"), a = L("rect"), u = L("rect"), d = L("rect"), c(o, "class", "rect-mask-bg svelte-1a76qe7"), c(o, "x", i = /*x*/
      e[1] - /*buffer*/
      e[5]), c(o, "y", s = /*y*/
      e[2] - /*buffer*/
      e[5]), c(o, "width", r = /*w*/
      e[3] + 2 * /*buffer*/
      e[5]), c(o, "height", l = /*h*/
      e[4] + 2 * /*buffer*/
      e[5]), c(a, "class", "rect-mask-fg svelte-1a76qe7"), c(
        a,
        "x",
        /*x*/
        e[1]
      ), c(
        a,
        "y",
        /*y*/
        e[2]
      ), c(
        a,
        "width",
        /*w*/
        e[3]
      ), c(
        a,
        "height",
        /*h*/
        e[4]
      ), c(
        n,
        "id",
        /*maskId*/
        e[6]
      ), c(n, "class", "a9s-rubberband-rectangle-mask svelte-1a76qe7"), c(u, "class", "a9s-outer"), c(u, "mask", `url(#${/*maskId*/
      e[6]})`), c(
        u,
        "x",
        /*x*/
        e[1]
      ), c(
        u,
        "y",
        /*y*/
        e[2]
      ), c(
        u,
        "width",
        /*w*/
        e[3]
      ), c(
        u,
        "height",
        /*h*/
        e[4]
      ), c(d, "class", "a9s-inner"), c(
        d,
        "x",
        /*x*/
        e[1]
      ), c(
        d,
        "y",
        /*y*/
        e[2]
      ), c(
        d,
        "width",
        /*w*/
        e[3]
      ), c(
        d,
        "height",
        /*h*/
        e[4]
      );
    },
    m(f, h) {
      B(f, t, h), j(t, n), j(n, o), j(n, a), B(f, u, h), B(f, d, h);
    },
    p(f, h) {
      h & /*x, buffer*/
      34 && i !== (i = /*x*/
      f[1] - /*buffer*/
      f[5]) && c(o, "x", i), h & /*y, buffer*/
      36 && s !== (s = /*y*/
      f[2] - /*buffer*/
      f[5]) && c(o, "y", s), h & /*w, buffer*/
      40 && r !== (r = /*w*/
      f[3] + 2 * /*buffer*/
      f[5]) && c(o, "width", r), h & /*h, buffer*/
      48 && l !== (l = /*h*/
      f[4] + 2 * /*buffer*/
      f[5]) && c(o, "height", l), h & /*x*/
      2 && c(
        a,
        "x",
        /*x*/
        f[1]
      ), h & /*y*/
      4 && c(
        a,
        "y",
        /*y*/
        f[2]
      ), h & /*w*/
      8 && c(
        a,
        "width",
        /*w*/
        f[3]
      ), h & /*h*/
      16 && c(
        a,
        "height",
        /*h*/
        f[4]
      ), h & /*x*/
      2 && c(
        u,
        "x",
        /*x*/
        f[1]
      ), h & /*y*/
      4 && c(
        u,
        "y",
        /*y*/
        f[2]
      ), h & /*w*/
      8 && c(
        u,
        "width",
        /*w*/
        f[3]
      ), h & /*h*/
      16 && c(
        u,
        "height",
        /*h*/
        f[4]
      ), h & /*x*/
      2 && c(
        d,
        "x",
        /*x*/
        f[1]
      ), h & /*y*/
      4 && c(
        d,
        "y",
        /*y*/
        f[2]
      ), h & /*w*/
      8 && c(
        d,
        "width",
        /*w*/
        f[3]
      ), h & /*h*/
      16 && c(
        d,
        "height",
        /*h*/
        f[4]
      );
    },
    d(f) {
      f && (D(t), D(u), D(d));
    }
  };
}
function Ps(e) {
  let t, n = (
    /*origin*/
    e[0] && kn(e)
  );
  return {
    c() {
      t = L("g"), n && n.c(), c(t, "class", "a9s-annotation a9s-rubberband");
    },
    m(o, i) {
      B(o, t, i), n && n.m(t, null);
    },
    p(o, [i]) {
      /*origin*/
      o[0] ? n ? n.p(o, i) : (n = kn(o), n.c(), n.m(t, null)) : n && (n.d(1), n = null);
    },
    i: ee,
    o: ee,
    d(o) {
      o && D(t), n && n.d();
    }
  };
}
function Ls(e, t, n) {
  let o;
  const i = Be();
  let { addEventListener: s } = t, { drawingMode: r } = t, { transform: l } = t, { viewportScale: a = 1 } = t, u, d, f, h, g, m, p;
  const k = (T) => {
    const C = T;
    u = performance.now(), r === "drag" && (n(0, d = l.elementToImage(C.offsetX, C.offsetY)), f = d, n(1, h = d[0]), n(2, g = d[1]), n(3, m = 1), n(4, p = 1));
  }, E = (T) => {
    const C = T;
    d && (f = l.elementToImage(C.offsetX, C.offsetY), n(1, h = Math.min(f[0], d[0])), n(2, g = Math.min(f[1], d[1])), n(3, m = Math.abs(f[0] - d[0])), n(4, p = Math.abs(f[1] - d[1])));
  }, S = (T) => {
    const C = T, M = performance.now() - u;
    if (r === "click") {
      if (M > 300) return;
      d ? w() : (n(0, d = l.elementToImage(C.offsetX, C.offsetY)), f = d, n(1, h = d[0]), n(2, g = d[1]), n(3, m = 1), n(4, p = 1));
    } else d && (M > 300 || m * p > 100 ? (C.stopPropagation(), w()) : (n(0, d = void 0), f = void 0));
  }, w = () => {
    if (m * p > 15) {
      const T = {
        type: x.RECTANGLE,
        geometry: {
          bounds: {
            minX: h,
            minY: g,
            maxX: h + m,
            maxY: g + p
          },
          x: h,
          y: g,
          w: m,
          h: p
        }
      };
      i("create", T);
    }
    n(0, d = void 0), f = void 0;
  };
  Ue(() => {
    s("pointerdown", k), s("pointermove", E), s("pointerup", S, !0);
  });
  const A = `rect-mask-${Math.random().toString(36).substring(2, 12)}`;
  return e.$$set = (T) => {
    "addEventListener" in T && n(7, s = T.addEventListener), "drawingMode" in T && n(8, r = T.drawingMode), "transform" in T && n(9, l = T.transform), "viewportScale" in T && n(10, a = T.viewportScale);
  }, e.$$.update = () => {
    e.$$.dirty & /*viewportScale*/
    1024 && n(5, o = 2 / a);
  }, [
    d,
    h,
    g,
    m,
    p,
    o,
    A,
    s,
    r,
    l,
    a
  ];
}
class Is extends pe {
  constructor(t) {
    super(), me(this, t, Ls, Ps, se, {
      addEventListener: 7,
      drawingMode: 8,
      transform: 9,
      viewportScale: 10
    });
  }
}
function Nt(e) {
  const t = e.slice(), n = (
    /*coords*/
    t[2].map((o) => o.join(",")).join(" ")
  );
  return t[19] = n, t;
}
function Mn(e) {
  let t, n, o, i, s, r, l, a, u, d, f, h, g, m, p = (
    /*isClosable*/
    e[1] && Tn(e)
  );
  return {
    c() {
      t = L("defs"), n = L("mask"), o = L("rect"), a = L("polygon"), d = L("polygon"), h = L("polygon"), p && p.c(), m = Ae(), c(o, "x", i = /*mask*/
      e[3].x), c(o, "y", s = /*mask*/
      e[3].y), c(o, "width", r = /*mask*/
      e[3].w), c(o, "height", l = /*mask*/
      e[3].h), c(o, "class", "svelte-18wrg3t"), c(a, "points", u = /*str*/
      e[19]), c(a, "class", "svelte-18wrg3t"), c(
        n,
        "id",
        /*maskId*/
        e[5]
      ), c(n, "class", "a9s-rubberband-polygon-mask svelte-18wrg3t"), c(d, "class", "a9s-outer"), c(d, "mask", `url(#${/*maskId*/
      e[5]})`), c(d, "points", f = /*str*/
      e[19]), c(h, "class", "a9s-inner"), c(h, "points", g = /*str*/
      e[19]);
    },
    m(k, E) {
      B(k, t, E), j(t, n), j(n, o), j(n, a), B(k, d, E), B(k, h, E), p && p.m(k, E), B(k, m, E);
    },
    p(k, E) {
      E & /*mask*/
      8 && i !== (i = /*mask*/
      k[3].x) && c(o, "x", i), E & /*mask*/
      8 && s !== (s = /*mask*/
      k[3].y) && c(o, "y", s), E & /*mask*/
      8 && r !== (r = /*mask*/
      k[3].w) && c(o, "width", r), E & /*mask*/
      8 && l !== (l = /*mask*/
      k[3].h) && c(o, "height", l), E & /*coords*/
      4 && u !== (u = /*str*/
      k[19]) && c(a, "points", u), E & /*coords*/
      4 && f !== (f = /*str*/
      k[19]) && c(d, "points", f), E & /*coords*/
      4 && g !== (g = /*str*/
      k[19]) && c(h, "points", g), /*isClosable*/
      k[1] ? p ? p.p(k, E) : (p = Tn(k), p.c(), p.m(m.parentNode, m)) : p && (p.d(1), p = null);
    },
    d(k) {
      k && (D(t), D(d), D(h), D(m)), p && p.d(k);
    }
  };
}
function Tn(e) {
  let t, n, o;
  return {
    c() {
      t = L("circle"), c(t, "class", "a9s-handle svelte-18wrg3t"), c(t, "cx", n = /*points*/
      e[0][0][0]), c(t, "cy", o = /*points*/
      e[0][0][1]), c(
        t,
        "r",
        /*handleRadius*/
        e[4]
      );
    },
    m(i, s) {
      B(i, t, s);
    },
    p(i, s) {
      s & /*points*/
      1 && n !== (n = /*points*/
      i[0][0][0]) && c(t, "cx", n), s & /*points*/
      1 && o !== (o = /*points*/
      i[0][0][1]) && c(t, "cy", o), s & /*handleRadius*/
      16 && c(
        t,
        "r",
        /*handleRadius*/
        i[4]
      );
    },
    d(i) {
      i && D(t);
    }
  };
}
function Cs(e) {
  let t, n = (
    /*mask*/
    e[3] && Mn(Nt(e))
  );
  return {
    c() {
      t = L("g"), n && n.c(), c(t, "class", "a9s-annotation a9s-rubberband");
    },
    m(o, i) {
      B(o, t, i), n && n.m(t, null);
    },
    p(o, [i]) {
      /*mask*/
      o[3] ? n ? n.p(Nt(o), i) : (n = Mn(Nt(o)), n.c(), n.m(t, null)) : n && (n.d(1), n = null);
    },
    i: ee,
    o: ee,
    d(o) {
      o && D(t), n && n.d();
    }
  };
}
const Os = 20, Ds = 1500;
function Bs(e, t, n) {
  let o, i, s;
  const r = Be();
  let { addEventListener: l } = t, { drawingMode: a } = t, { transform: u } = t, { viewportScale: d = 1 } = t, f, h = [], g, m, p = !1;
  const k = (C) => {
    const M = C, { timeStamp: R, offsetX: N, offsetY: q } = M;
    if (f = { timeStamp: R, offsetX: N, offsetY: q }, a === "drag" && h.length === 0) {
      const F = u.elementToImage(M.offsetX, M.offsetY);
      h.push(F), n(10, g = F);
    }
  }, E = (C) => {
    const M = C;
    if (m && clearTimeout(m), h.length > 0) {
      if (n(10, g = u.elementToImage(M.offsetX, M.offsetY)), h.length > 2) {
        const R = ft(g, h[0]) * d;
        n(1, p = R < Os);
      }
      M.pointerType === "touch" && (m = setTimeout(
        () => {
          w();
        },
        Ds
      ));
    }
  }, S = (C) => {
    const M = C;
    if (m && clearTimeout(m), a === "click") {
      const R = M.timeStamp - f.timeStamp, N = ft([f.offsetX, f.offsetY], [M.offsetX, M.offsetY]);
      if (R > 300 || N > 15) return;
      if (p)
        A();
      else if (h.length === 0) {
        const q = u.elementToImage(M.offsetX, M.offsetY);
        h.push(q), n(10, g = q);
      } else
        g && h.push(g);
    } else {
      if (!g) return;
      if (h.length === 1 && ft(h[0], g) <= 4) {
        n(0, h = []), n(10, g = void 0);
        return;
      }
      M.stopImmediatePropagation(), p ? A() : h.push(g);
    }
  }, w = () => {
    if (!g) return;
    const C = h.slice(0, -1);
    if (C.length < 3) return;
    const M = {
      type: x.POLYGON,
      geometry: {
        bounds: ge(h),
        points: C
      }
    };
    Gt(M) > 4 && (n(0, h = []), n(10, g = void 0), r("create", M));
  }, A = () => {
    const C = {
      type: x.POLYGON,
      geometry: {
        bounds: ge(h),
        points: [...h]
      }
    };
    n(0, h = []), n(10, g = void 0), r("create", C);
  };
  Ue(() => {
    l("pointerdown", k, !0), l("pointermove", E), l("pointerup", S, !0), l("dblclick", w, !0);
  });
  const T = `polygon-mask-${Math.random().toString(36).substring(2, 12)}`;
  return e.$$set = (C) => {
    "addEventListener" in C && n(6, l = C.addEventListener), "drawingMode" in C && n(7, a = C.drawingMode), "transform" in C && n(8, u = C.transform), "viewportScale" in C && n(9, d = C.viewportScale);
  }, e.$$.update = () => {
    e.$$.dirty & /*viewportScale*/
    512 && n(4, o = 4 / d), e.$$.dirty & /*cursor, isClosable, points*/
    1027 && n(2, i = g ? p ? h : [...h, g] : []), e.$$.dirty & /*coords, viewportScale*/
    516 && n(3, s = i.length > 0 ? wt(ge(i), 2 / d) : void 0);
  }, [
    h,
    p,
    i,
    s,
    o,
    T,
    l,
    a,
    u,
    d,
    g
  ];
}
class Ns extends pe {
  constructor(t) {
    super(), me(this, t, Bs, Cs, se, {
      addEventListener: 6,
      drawingMode: 7,
      transform: 8,
      viewportScale: 9
    });
  }
}
const Wt = /* @__PURE__ */ new Map([
  ["rectangle", { tool: Is }],
  ["polygon", { tool: Ns }]
]), uo = () => [...Wt.keys()], fo = (e) => Wt.get(e), Ys = (e, t, n = {}) => Wt.set(e, { tool: t, opts: n });
function Us(e) {
  let t, n, o, i, s;
  return {
    c() {
      t = L("g"), n = L("ellipse"), i = L("ellipse"), c(n, "class", "a9s-outer"), c(n, "style", o = /*computedStyle*/
      e[1] ? "display:none;" : void 0), c(
        n,
        "cx",
        /*cx*/
        e[2]
      ), c(
        n,
        "cy",
        /*cy*/
        e[3]
      ), c(
        n,
        "rx",
        /*rx*/
        e[4]
      ), c(
        n,
        "ry",
        /*ry*/
        e[5]
      ), c(i, "class", "a9s-inner"), c(
        i,
        "style",
        /*computedStyle*/
        e[1]
      ), c(
        i,
        "cx",
        /*cx*/
        e[2]
      ), c(
        i,
        "cy",
        /*cy*/
        e[3]
      ), c(
        i,
        "rx",
        /*rx*/
        e[4]
      ), c(
        i,
        "ry",
        /*ry*/
        e[5]
      ), c(t, "class", "a9s-annotation"), c(t, "data-id", s = /*annotation*/
      e[0].id);
    },
    m(r, l) {
      B(r, t, l), j(t, n), j(t, i);
    },
    p(r, [l]) {
      l & /*computedStyle*/
      2 && o !== (o = /*computedStyle*/
      r[1] ? "display:none;" : void 0) && c(n, "style", o), l & /*computedStyle*/
      2 && c(
        i,
        "style",
        /*computedStyle*/
        r[1]
      ), l & /*annotation*/
      1 && s !== (s = /*annotation*/
      r[0].id) && c(t, "data-id", s);
    },
    i: ee,
    o: ee,
    d(r) {
      r && D(t);
    }
  };
}
function Rs(e, t, n) {
  let o, { annotation: i } = t, { geom: s } = t, { style: r } = t;
  const { cx: l, cy: a, rx: u, ry: d } = s;
  return e.$$set = (f) => {
    "annotation" in f && n(0, i = f.annotation), "geom" in f && n(6, s = f.geom), "style" in f && n(7, r = f.style);
  }, e.$$.update = () => {
    e.$$.dirty & /*annotation, style*/
    129 && n(1, o = Re(i, r));
  }, [i, o, l, a, u, d, s, r];
}
class Vs extends pe {
  constructor(t) {
    super(), me(this, t, Rs, Us, se, { annotation: 0, geom: 6, style: 7 });
  }
}
function Xs(e) {
  let t, n, o, i, s;
  return {
    c() {
      t = L("g"), n = L("line"), i = L("line"), c(n, "class", "a9s-outer"), c(n, "style", o = /*computedStyle*/
      e[1] ? "display:none;" : void 0), c(
        n,
        "x1",
        /*x1*/
        e[2]
      ), c(
        n,
        "y1",
        /*y1*/
        e[3]
      ), c(
        n,
        "x2",
        /*x2*/
        e[4]
      ), c(
        n,
        "y2",
        /*y2*/
        e[5]
      ), c(i, "class", "a9s-inner"), c(
        i,
        "style",
        /*computedStyle*/
        e[1]
      ), c(
        i,
        "x1",
        /*x1*/
        e[2]
      ), c(
        i,
        "y1",
        /*y1*/
        e[3]
      ), c(
        i,
        "x2",
        /*x2*/
        e[4]
      ), c(
        i,
        "y2",
        /*y2*/
        e[5]
      ), c(t, "class", "a9s-annotation"), c(t, "data-id", s = /*annotation*/
      e[0].id);
    },
    m(r, l) {
      B(r, t, l), j(t, n), j(t, i);
    },
    p(r, [l]) {
      l & /*computedStyle*/
      2 && o !== (o = /*computedStyle*/
      r[1] ? "display:none;" : void 0) && c(n, "style", o), l & /*computedStyle*/
      2 && c(
        i,
        "style",
        /*computedStyle*/
        r[1]
      ), l & /*annotation*/
      1 && s !== (s = /*annotation*/
      r[0].id) && c(t, "data-id", s);
    },
    i: ee,
    o: ee,
    d(r) {
      r && D(t);
    }
  };
}
function Hs(e, t, n) {
  let o, { annotation: i } = t, { geom: s } = t, { style: r } = t;
  const { points: l } = s, [[a, u], [d, f]] = l;
  return e.$$set = (h) => {
    "annotation" in h && n(0, i = h.annotation), "geom" in h && n(6, s = h.geom), "style" in h && n(7, r = h.style);
  }, e.$$.update = () => {
    e.$$.dirty & /*annotation, style*/
    129 && n(1, o = Re(i, r));
  }, [i, o, a, u, d, f, s, r];
}
class Gs extends pe {
  constructor(t) {
    super(), me(this, t, Hs, Xs, se, { annotation: 0, geom: 6, style: 7 });
  }
}
function Pn(e, t, n) {
  const o = e.slice();
  return o[5] = t[n], o;
}
function Ln(e) {
  let t, n, o;
  return {
    c() {
      t = L("path"), o = L("path"), c(t, "class", "a9s-outer"), c(t, "style", n = /*computedStyle*/
      e[1] ? "display:none;" : void 0), c(t, "fill-rule", "evenodd"), c(t, "d", Pe(
        /*polygonElement*/
        e[5]
      )), c(o, "class", "a9s-inner"), c(
        o,
        "style",
        /*computedStyle*/
        e[1]
      ), c(o, "fill-rule", "evenodd"), c(o, "d", Pe(
        /*polygonElement*/
        e[5]
      ));
    },
    m(i, s) {
      B(i, t, s), B(i, o, s);
    },
    p(i, s) {
      s & /*computedStyle*/
      2 && n !== (n = /*computedStyle*/
      i[1] ? "display:none;" : void 0) && c(t, "style", n), s & /*computedStyle*/
      2 && c(
        o,
        "style",
        /*computedStyle*/
        i[1]
      );
    },
    d(i) {
      i && (D(t), D(o));
    }
  };
}
function js(e) {
  let t, n, o = ve(
    /*polygons*/
    e[2]
  ), i = [];
  for (let s = 0; s < o.length; s += 1)
    i[s] = Ln(Pn(e, o, s));
  return {
    c() {
      t = L("g");
      for (let s = 0; s < i.length; s += 1)
        i[s].c();
      c(t, "class", "a9s-annotation"), c(t, "data-id", n = /*annotation*/
      e[0].id);
    },
    m(s, r) {
      B(s, t, r);
      for (let l = 0; l < i.length; l += 1)
        i[l] && i[l].m(t, null);
    },
    p(s, [r]) {
      if (r & /*computedStyle, polygons, undefined*/
      6) {
        o = ve(
          /*polygons*/
          s[2]
        );
        let l;
        for (l = 0; l < o.length; l += 1) {
          const a = Pn(s, o, l);
          i[l] ? i[l].p(a, r) : (i[l] = Ln(a), i[l].c(), i[l].m(t, null));
        }
        for (; l < i.length; l += 1)
          i[l].d(1);
        i.length = o.length;
      }
      r & /*annotation*/
      1 && n !== (n = /*annotation*/
      s[0].id) && c(t, "data-id", n);
    },
    i: ee,
    o: ee,
    d(s) {
      s && D(t), Ye(i, s);
    }
  };
}
function Fs(e, t, n) {
  let o, { annotation: i } = t, { geom: s } = t, { style: r } = t;
  const { polygons: l } = s;
  return e.$$set = (a) => {
    "annotation" in a && n(0, i = a.annotation), "geom" in a && n(3, s = a.geom), "style" in a && n(4, r = a.style);
  }, e.$$.update = () => {
    e.$$.dirty & /*annotation, style*/
    17 && n(1, o = Re(i, r));
  }, [i, o, l, s, r];
}
class zs extends pe {
  constructor(t) {
    super(), me(this, t, Fs, js, se, { annotation: 0, geom: 3, style: 4 });
  }
}
function qs(e) {
  let t, n, o, i, s;
  return {
    c() {
      t = L("g"), n = L("polygon"), i = L("polygon"), c(n, "class", "a9s-outer"), c(n, "style", o = /*computedStyle*/
      e[1] ? "display:none;" : void 0), c(
        n,
        "points",
        /*points*/
        e[2].map(Ks).join(" ")
      ), c(i, "class", "a9s-inner"), c(
        i,
        "style",
        /*computedStyle*/
        e[1]
      ), c(
        i,
        "points",
        /*points*/
        e[2].map(Ws).join(" ")
      ), c(t, "class", "a9s-annotation"), c(t, "data-id", s = /*annotation*/
      e[0].id);
    },
    m(r, l) {
      B(r, t, l), j(t, n), j(t, i);
    },
    p(r, [l]) {
      l & /*computedStyle*/
      2 && o !== (o = /*computedStyle*/
      r[1] ? "display:none;" : void 0) && c(n, "style", o), l & /*computedStyle*/
      2 && c(
        i,
        "style",
        /*computedStyle*/
        r[1]
      ), l & /*annotation*/
      1 && s !== (s = /*annotation*/
      r[0].id) && c(t, "data-id", s);
    },
    i: ee,
    o: ee,
    d(r) {
      r && D(t);
    }
  };
}
const Ks = (e) => e.join(","), Ws = (e) => e.join(",");
function Zs(e, t, n) {
  let o, { annotation: i } = t, { geom: s } = t, { style: r } = t;
  const { points: l } = s;
  return e.$$set = (a) => {
    "annotation" in a && n(0, i = a.annotation), "geom" in a && n(3, s = a.geom), "style" in a && n(4, r = a.style);
  }, e.$$.update = () => {
    e.$$.dirty & /*annotation, style*/
    17 && n(1, o = Re(i, r));
  }, [i, o, l, s, r];
}
class Js extends pe {
  constructor(t) {
    super(), me(this, t, Zs, qs, se, { annotation: 0, geom: 3, style: 4 });
  }
}
function Qs(e) {
  let t, n, o, i, s, r, l;
  return {
    c() {
      t = L("g"), n = L("path"), s = L("path"), c(n, "class", o = ze(`a9s-outer ${/*cssClass*/
      e[1]}`) + " svelte-1w0132l"), c(n, "style", i = /*computedStyle*/
      e[3] ? "display:none;" : void 0), c(
        n,
        "d",
        /*d*/
        e[2]
      ), c(s, "class", r = ze(`a9s-inner ${/*cssClass*/
      e[1]}`) + " svelte-1w0132l"), c(
        s,
        "style",
        /*computedStyle*/
        e[3]
      ), c(
        s,
        "d",
        /*d*/
        e[2]
      ), c(t, "class", "a9s-annotation"), c(t, "data-id", l = /*annotation*/
      e[0].id);
    },
    m(a, u) {
      B(a, t, u), j(t, n), j(t, s);
    },
    p(a, [u]) {
      u & /*cssClass*/
      2 && o !== (o = ze(`a9s-outer ${/*cssClass*/
      a[1]}`) + " svelte-1w0132l") && c(n, "class", o), u & /*computedStyle*/
      8 && i !== (i = /*computedStyle*/
      a[3] ? "display:none;" : void 0) && c(n, "style", i), u & /*d*/
      4 && c(
        n,
        "d",
        /*d*/
        a[2]
      ), u & /*cssClass*/
      2 && r !== (r = ze(`a9s-inner ${/*cssClass*/
      a[1]}`) + " svelte-1w0132l") && c(s, "class", r), u & /*computedStyle*/
      8 && c(
        s,
        "style",
        /*computedStyle*/
        a[3]
      ), u & /*d*/
      4 && c(
        s,
        "d",
        /*d*/
        a[2]
      ), u & /*annotation*/
      1 && l !== (l = /*annotation*/
      a[0].id) && c(t, "data-id", l);
    },
    i: ee,
    o: ee,
    d(a) {
      a && D(t);
    }
  };
}
function xs(e, t, n) {
  let o, i, s, { annotation: r } = t, { geom: l } = t, { style: a } = t;
  return e.$$set = (u) => {
    "annotation" in u && n(0, r = u.annotation), "geom" in u && n(4, l = u.geom), "style" in u && n(5, a = u.style);
  }, e.$$.update = () => {
    e.$$.dirty & /*annotation, style*/
    33 && n(3, o = Re(r, a)), e.$$.dirty & /*geom*/
    16 && n(2, i = eo(l)), e.$$.dirty & /*geom*/
    16 && n(1, s = l.closed ? "closed" : "open");
  }, [r, s, i, o, l, a];
}
class $s extends pe {
  constructor(t) {
    super(), me(this, t, xs, Qs, se, { annotation: 0, geom: 4, style: 5 });
  }
}
function er(e) {
  let t, n, o, i, s;
  return {
    c() {
      t = L("g"), n = L("rect"), i = L("rect"), c(n, "class", "a9s-outer"), c(n, "style", o = /*computedStyle*/
      e[5] ? "display:none;" : void 0), c(
        n,
        "x",
        /*x*/
        e[4]
      ), c(
        n,
        "y",
        /*y*/
        e[3]
      ), c(
        n,
        "width",
        /*w*/
        e[2]
      ), c(
        n,
        "height",
        /*h*/
        e[1]
      ), c(i, "class", "a9s-inner"), c(
        i,
        "style",
        /*computedStyle*/
        e[5]
      ), c(
        i,
        "x",
        /*x*/
        e[4]
      ), c(
        i,
        "y",
        /*y*/
        e[3]
      ), c(
        i,
        "width",
        /*w*/
        e[2]
      ), c(
        i,
        "height",
        /*h*/
        e[1]
      ), c(t, "class", "a9s-annotation"), c(t, "data-id", s = /*annotation*/
      e[0].id);
    },
    m(r, l) {
      B(r, t, l), j(t, n), j(t, i);
    },
    p(r, [l]) {
      l & /*computedStyle*/
      32 && o !== (o = /*computedStyle*/
      r[5] ? "display:none;" : void 0) && c(n, "style", o), l & /*x*/
      16 && c(
        n,
        "x",
        /*x*/
        r[4]
      ), l & /*y*/
      8 && c(
        n,
        "y",
        /*y*/
        r[3]
      ), l & /*w*/
      4 && c(
        n,
        "width",
        /*w*/
        r[2]
      ), l & /*h*/
      2 && c(
        n,
        "height",
        /*h*/
        r[1]
      ), l & /*computedStyle*/
      32 && c(
        i,
        "style",
        /*computedStyle*/
        r[5]
      ), l & /*x*/
      16 && c(
        i,
        "x",
        /*x*/
        r[4]
      ), l & /*y*/
      8 && c(
        i,
        "y",
        /*y*/
        r[3]
      ), l & /*w*/
      4 && c(
        i,
        "width",
        /*w*/
        r[2]
      ), l & /*h*/
      2 && c(
        i,
        "height",
        /*h*/
        r[1]
      ), l & /*annotation*/
      1 && s !== (s = /*annotation*/
      r[0].id) && c(t, "data-id", s);
    },
    i: ee,
    o: ee,
    d(r) {
      r && D(t);
    }
  };
}
function tr(e, t, n) {
  let o, i, s, r, l, { annotation: a } = t, { geom: u } = t, { style: d } = t;
  return e.$$set = (f) => {
    "annotation" in f && n(0, a = f.annotation), "geom" in f && n(6, u = f.geom), "style" in f && n(7, d = f.style);
  }, e.$$.update = () => {
    e.$$.dirty & /*annotation, style*/
    129 && n(5, o = Re(a, d)), e.$$.dirty & /*geom*/
    64 && n(4, { x: i, y: s, w: r, h: l } = u, i, (n(3, s), n(6, u)), (n(2, r), n(6, u)), (n(1, l), n(6, u)));
  }, [a, l, r, s, i, o, u, d];
}
class nr extends pe {
  constructor(t) {
    super(), me(this, t, tr, er, se, { annotation: 0, geom: 6, style: 7 });
  }
}
const Xr = {
  elementToImage: (e, t) => [e, t]
}, or = (e) => ({
  elementToImage: (t, n) => {
    const o = e.getBoundingClientRect(), i = e.createSVGPoint();
    i.x = t + o.x, i.y = n + o.y;
    const { x: s, y: r } = i.matrixTransform(e.getScreenCTM().inverse());
    return [s, r];
  }
}), ir = 250, sr = (e, t) => {
  const n = Be();
  let o;
  return { onPointerDown: () => o = performance.now(), onPointerUp: (r) => {
    if (performance.now() - o < ir) {
      const { x: a, y: u } = ho(r, e), d = Le ? 10 : 2, f = t.getAt(a, u, void 0, d);
      f ? n("click", { originalEvent: r, annotation: f }) : n("click", { originalEvent: r });
    }
  } };
}, ho = (e, t) => {
  const n = t.createSVGPoint(), o = t.getBoundingClientRect(), i = e.clientX - o.x, s = e.clientY - o.y, { left: r, top: l } = t.getBoundingClientRect();
  return n.x = i + r, n.y = s + l, n.matrixTransform(t.getScreenCTM().inverse());
};
function In(e, t, n) {
  const o = e.slice();
  return o[39] = t[n], o;
}
function Cn(e, t, n) {
  const o = e.slice();
  return o[42] = t[n], o;
}
function Yt(e) {
  const t = e.slice(), n = (
    /*annotation*/
    t[42].target.selector
  );
  return t[45] = n, t;
}
function On(e) {
  let t = (
    /*annotation*/
    e[42]
  ), n, o, i = Dn(e);
  return {
    c() {
      i.c(), n = Ae();
    },
    m(s, r) {
      i.m(s, r), B(s, n, r), o = !0;
    },
    p(s, r) {
      r[0] & /*$store*/
      131072 && se(t, t = /*annotation*/
      s[42]) ? (we(), H(i, 1, 1, ee), be(), i = Dn(s), i.c(), U(i, 1), i.m(n.parentNode, n)) : i.p(s, r);
    },
    i(s) {
      o || (U(i), o = !0);
    },
    o(s) {
      H(i), o = !1;
    },
    d(s) {
      s && D(n), i.d(s);
    }
  };
}
function rr(e) {
  let t, n;
  return t = new Gs({
    props: {
      annotation: (
        /*annotation*/
        e[42]
      ),
      geom: (
        /*selector*/
        e[45].geometry
      ),
      style: (
        /*style*/
        e[1]
      )
    }
  }), {
    c() {
      ae(t.$$.fragment);
    },
    m(o, i) {
      re(t, o, i), n = !0;
    },
    p(o, i) {
      const s = {};
      i[0] & /*$store*/
      131072 && (s.annotation = /*annotation*/
      o[42]), i[0] & /*$store*/
      131072 && (s.geom = /*selector*/
      o[45].geometry), i[0] & /*style*/
      2 && (s.style = /*style*/
      o[1]), t.$set(s);
    },
    i(o) {
      n || (U(t.$$.fragment, o), n = !0);
    },
    o(o) {
      H(t.$$.fragment, o), n = !1;
    },
    d(o) {
      le(t, o);
    }
  };
}
function lr(e) {
  let t, n;
  return t = new $s({
    props: {
      annotation: (
        /*annotation*/
        e[42]
      ),
      geom: (
        /*selector*/
        e[45].geometry
      ),
      style: (
        /*style*/
        e[1]
      )
    }
  }), {
    c() {
      ae(t.$$.fragment);
    },
    m(o, i) {
      re(t, o, i), n = !0;
    },
    p(o, i) {
      const s = {};
      i[0] & /*$store*/
      131072 && (s.annotation = /*annotation*/
      o[42]), i[0] & /*$store*/
      131072 && (s.geom = /*selector*/
      o[45].geometry), i[0] & /*style*/
      2 && (s.style = /*style*/
      o[1]), t.$set(s);
    },
    i(o) {
      n || (U(t.$$.fragment, o), n = !0);
    },
    o(o) {
      H(t.$$.fragment, o), n = !1;
    },
    d(o) {
      le(t, o);
    }
  };
}
function ar(e) {
  let t, n;
  return t = new zs({
    props: {
      annotation: (
        /*annotation*/
        e[42]
      ),
      geom: (
        /*selector*/
        e[45].geometry
      ),
      style: (
        /*style*/
        e[1]
      )
    }
  }), {
    c() {
      ae(t.$$.fragment);
    },
    m(o, i) {
      re(t, o, i), n = !0;
    },
    p(o, i) {
      const s = {};
      i[0] & /*$store*/
      131072 && (s.annotation = /*annotation*/
      o[42]), i[0] & /*$store*/
      131072 && (s.geom = /*selector*/
      o[45].geometry), i[0] & /*style*/
      2 && (s.style = /*style*/
      o[1]), t.$set(s);
    },
    i(o) {
      n || (U(t.$$.fragment, o), n = !0);
    },
    o(o) {
      H(t.$$.fragment, o), n = !1;
    },
    d(o) {
      le(t, o);
    }
  };
}
function cr(e) {
  let t, n;
  return t = new Js({
    props: {
      annotation: (
        /*annotation*/
        e[42]
      ),
      geom: (
        /*selector*/
        e[45].geometry
      ),
      style: (
        /*style*/
        e[1]
      )
    }
  }), {
    c() {
      ae(t.$$.fragment);
    },
    m(o, i) {
      re(t, o, i), n = !0;
    },
    p(o, i) {
      const s = {};
      i[0] & /*$store*/
      131072 && (s.annotation = /*annotation*/
      o[42]), i[0] & /*$store*/
      131072 && (s.geom = /*selector*/
      o[45].geometry), i[0] & /*style*/
      2 && (s.style = /*style*/
      o[1]), t.$set(s);
    },
    i(o) {
      n || (U(t.$$.fragment, o), n = !0);
    },
    o(o) {
      H(t.$$.fragment, o), n = !1;
    },
    d(o) {
      le(t, o);
    }
  };
}
function ur(e) {
  let t, n;
  return t = new nr({
    props: {
      annotation: (
        /*annotation*/
        e[42]
      ),
      geom: (
        /*selector*/
        e[45].geometry
      ),
      style: (
        /*style*/
        e[1]
      )
    }
  }), {
    c() {
      ae(t.$$.fragment);
    },
    m(o, i) {
      re(t, o, i), n = !0;
    },
    p(o, i) {
      const s = {};
      i[0] & /*$store*/
      131072 && (s.annotation = /*annotation*/
      o[42]), i[0] & /*$store*/
      131072 && (s.geom = /*selector*/
      o[45].geometry), i[0] & /*style*/
      2 && (s.style = /*style*/
      o[1]), t.$set(s);
    },
    i(o) {
      n || (U(t.$$.fragment, o), n = !0);
    },
    o(o) {
      H(t.$$.fragment, o), n = !1;
    },
    d(o) {
      le(t, o);
    }
  };
}
function fr(e) {
  var o;
  let t, n;
  return t = new Vs({
    props: {
      annotation: (
        /*annotation*/
        e[42]
      ),
      geom: (
        /*selector*/
        (o = e[45]) == null ? void 0 : o.geometry
      ),
      style: (
        /*style*/
        e[1]
      )
    }
  }), {
    c() {
      ae(t.$$.fragment);
    },
    m(i, s) {
      re(t, i, s), n = !0;
    },
    p(i, s) {
      var l;
      const r = {};
      s[0] & /*$store*/
      131072 && (r.annotation = /*annotation*/
      i[42]), s[0] & /*$store*/
      131072 && (r.geom = /*selector*/
      (l = i[45]) == null ? void 0 : l.geometry), s[0] & /*style*/
      2 && (r.style = /*style*/
      i[1]), t.$set(r);
    },
    i(i) {
      n || (U(t.$$.fragment, i), n = !0);
    },
    o(i) {
      H(t.$$.fragment, i), n = !1;
    },
    d(i) {
      le(t, i);
    }
  };
}
function Dn(e) {
  let t, n, o, i;
  const s = [
    fr,
    ur,
    cr,
    ar,
    lr,
    rr
  ], r = [];
  function l(a, u) {
    var d, f, h, g, m, p;
    return (
      /*selector*/
      ((d = a[45]) == null ? void 0 : d.type) === x.ELLIPSE ? 0 : (
        /*selector*/
        ((f = a[45]) == null ? void 0 : f.type) === x.RECTANGLE ? 1 : (
          /*selector*/
          ((h = a[45]) == null ? void 0 : h.type) === x.POLYGON ? 2 : (
            /*selector*/
            ((g = a[45]) == null ? void 0 : g.type) === x.MULTIPOLYGON ? 3 : (
              /*selector*/
              ((m = a[45]) == null ? void 0 : m.type) === x.POLYLINE ? 4 : (
                /*selector*/
                ((p = a[45]) == null ? void 0 : p.type) === x.LINE ? 5 : -1
              )
            )
          )
        )
      )
    );
  }
  return ~(t = l(e)) && (n = r[t] = s[t](e)), {
    c() {
      n && n.c(), o = Ae();
    },
    m(a, u) {
      ~t && r[t].m(a, u), B(a, o, u), i = !0;
    },
    p(a, u) {
      let d = t;
      t = l(a), t === d ? ~t && r[t].p(a, u) : (n && (we(), H(r[d], 1, 1, () => {
        r[d] = null;
      }), be()), ~t ? (n = r[t], n ? n.p(a, u) : (n = r[t] = s[t](a), n.c()), U(n, 1), n.m(o.parentNode, o)) : n = null);
    },
    i(a) {
      i || (U(n), i = !0);
    },
    o(a) {
      H(n), i = !1;
    },
    d(a) {
      a && D(o), ~t && r[t].d(a);
    }
  };
}
function Bn(e) {
  let t = yt(
    /*annotation*/
    e[42]
  ) && !/*isEditable*/
  e[10](
    /*annotation*/
    e[42]
  ), n, o, i = t && On(Yt(e));
  return {
    c() {
      i && i.c(), n = Ae();
    },
    m(s, r) {
      i && i.m(s, r), B(s, n, r), o = !0;
    },
    p(s, r) {
      r[0] & /*$store, isEditable*/
      132096 && (t = yt(
        /*annotation*/
        s[42]
      ) && !/*isEditable*/
      s[10](
        /*annotation*/
        s[42]
      )), t ? i ? (i.p(Yt(s), r), r[0] & /*$store, isEditable*/
      132096 && U(i, 1)) : (i = On(Yt(s)), i.c(), U(i, 1), i.m(n.parentNode, n)) : i && (we(), H(i, 1, 1, () => {
        i = null;
      }), be());
    },
    i(s) {
      o || (U(i), o = !0);
    },
    o(s) {
      H(i), o = !1;
    },
    d(s) {
      s && D(n), i && i.d(s);
    }
  };
}
function Nn(e) {
  let t, n, o, i;
  const s = [hr, dr], r = [];
  function l(a, u) {
    return (
      /*editors*/
      a[6] ? 0 : (
        /*tool*/
        a[15] && /*drawingEnabled*/
        a[0] ? 1 : -1
      )
    );
  }
  return ~(t = l(e)) && (n = r[t] = s[t](e)), {
    c() {
      n && n.c(), o = Ae();
    },
    m(a, u) {
      ~t && r[t].m(a, u), B(a, o, u), i = !0;
    },
    p(a, u) {
      let d = t;
      t = l(a), t === d ? ~t && r[t].p(a, u) : (n && (we(), H(r[d], 1, 1, () => {
        r[d] = null;
      }), be()), ~t ? (n = r[t], n ? n.p(a, u) : (n = r[t] = s[t](a), n.c()), U(n, 1), n.m(o.parentNode, o)) : n = null);
    },
    i(a) {
      i || (U(n), i = !0);
    },
    o(a) {
      H(n), i = !1;
    },
    d(a) {
      a && D(o), ~t && r[t].d(a);
    }
  };
}
function dr(e) {
  let t = `${/*toolName*/
  e[2]}-${/*toolMountKey*/
  e[7]}`, n, o, i = Yn(e);
  return {
    c() {
      i.c(), n = Ae();
    },
    m(s, r) {
      i.m(s, r), B(s, n, r), o = !0;
    },
    p(s, r) {
      r[0] & /*toolName, toolMountKey*/
      132 && se(t, t = `${/*toolName*/
      s[2]}-${/*toolMountKey*/
      s[7]}`) ? (we(), H(i, 1, 1, ee), be(), i = Yn(s), i.c(), U(i, 1), i.m(n.parentNode, n)) : i.p(s, r);
    },
    i(s) {
      o || (U(i), o = !0);
    },
    o(s) {
      H(i), o = !1;
    },
    d(s) {
      s && D(n), i.d(s);
    }
  };
}
function hr(e) {
  let t, n, o = ve(
    /*editors*/
    e[6]
  ), i = [];
  for (let r = 0; r < o.length; r += 1)
    i[r] = Rn(In(e, o, r));
  const s = (r) => H(i[r], 1, 1, () => {
    i[r] = null;
  });
  return {
    c() {
      for (let r = 0; r < i.length; r += 1)
        i[r].c();
      t = Ae();
    },
    m(r, l) {
      for (let a = 0; a < i.length; a += 1)
        i[a] && i[a].m(r, l);
      B(r, t, l), n = !0;
    },
    p(r, l) {
      if (l[0] & /*editors, drawingEl, style, transform, $scale, onChangeSelected*/
      8659266) {
        o = ve(
          /*editors*/
          r[6]
        );
        let a;
        for (a = 0; a < o.length; a += 1) {
          const u = In(r, o, a);
          i[a] ? (i[a].p(u, l), U(i[a], 1)) : (i[a] = Rn(u), i[a].c(), U(i[a], 1), i[a].m(t.parentNode, t));
        }
        for (we(), a = o.length; a < i.length; a += 1)
          s(a);
        be();
      }
    },
    i(r) {
      if (!n) {
        for (let l = 0; l < o.length; l += 1)
          U(i[l]);
        n = !0;
      }
    },
    o(r) {
      i = i.filter(Boolean);
      for (let l = 0; l < i.length; l += 1)
        H(i[l]);
      n = !1;
    },
    d(r) {
      r && D(t), Ye(i, r);
    }
  };
}
function Yn(e) {
  let t, n;
  return t = new Ts({
    props: {
      target: (
        /*drawingEl*/
        e[8]
      ),
      tool: (
        /*tool*/
        e[15]
      ),
      drawingMode: (
        /*drawingMode*/
        e[14]
      ),
      transform: (
        /*transform*/
        e[13]
      ),
      viewportScale: (
        /*$scale*/
        e[18]
      )
    }
  }), t.$on(
    "create",
    /*onSelectionCreated*/
    e[22]
  ), {
    c() {
      ae(t.$$.fragment);
    },
    m(o, i) {
      re(t, o, i), n = !0;
    },
    p(o, i) {
      const s = {};
      i[0] & /*drawingEl*/
      256 && (s.target = /*drawingEl*/
      o[8]), i[0] & /*tool*/
      32768 && (s.tool = /*tool*/
      o[15]), i[0] & /*drawingMode*/
      16384 && (s.drawingMode = /*drawingMode*/
      o[14]), i[0] & /*transform*/
      8192 && (s.transform = /*transform*/
      o[13]), i[0] & /*$scale*/
      262144 && (s.viewportScale = /*$scale*/
      o[18]), t.$set(s);
    },
    i(o) {
      n || (U(t.$$.fragment, o), n = !0);
    },
    o(o) {
      H(t.$$.fragment, o), n = !1;
    },
    d(o) {
      le(t, o);
    }
  };
}
function Un(e) {
  let t, n;
  return t = new ks({
    props: {
      target: (
        /*drawingEl*/
        e[8]
      ),
      editor: (
        /*editable*/
        e[39].editor
      ),
      annotation: (
        /*editable*/
        e[39].annotation
      ),
      style: (
        /*style*/
        e[1]
      ),
      transform: (
        /*transform*/
        e[13]
      ),
      viewportScale: (
        /*$scale*/
        e[18]
      )
    }
  }), t.$on("change", function() {
    ie(
      /*onChangeSelected*/
      e[23](
        /*editable*/
        e[39].annotation
      )
    ) && e[23](
      /*editable*/
      e[39].annotation
    ).apply(this, arguments);
  }), {
    c() {
      ae(t.$$.fragment);
    },
    m(o, i) {
      re(t, o, i), n = !0;
    },
    p(o, i) {
      e = o;
      const s = {};
      i[0] & /*drawingEl*/
      256 && (s.target = /*drawingEl*/
      e[8]), i[0] & /*editors*/
      64 && (s.editor = /*editable*/
      e[39].editor), i[0] & /*editors*/
      64 && (s.annotation = /*editable*/
      e[39].annotation), i[0] & /*style*/
      2 && (s.style = /*style*/
      e[1]), i[0] & /*transform*/
      8192 && (s.transform = /*transform*/
      e[13]), i[0] & /*$scale*/
      262144 && (s.viewportScale = /*$scale*/
      e[18]), t.$set(s);
    },
    i(o) {
      n || (U(t.$$.fragment, o), n = !0);
    },
    o(o) {
      H(t.$$.fragment, o), n = !1;
    },
    d(o) {
      le(t, o);
    }
  };
}
function Rn(e) {
  let t = (
    /*editable*/
    e[39].annotation.id
  ), n, o, i = Un(e);
  return {
    c() {
      i.c(), n = Ae();
    },
    m(s, r) {
      i.m(s, r), B(s, n, r), o = !0;
    },
    p(s, r) {
      r[0] & /*editors*/
      64 && se(t, t = /*editable*/
      s[39].annotation.id) ? (we(), H(i, 1, 1, ee), be(), i = Un(s), i.c(), U(i, 1), i.m(n.parentNode, n)) : i.p(s, r);
    },
    i(s) {
      o || (U(i), o = !0);
    },
    o(s) {
      H(i), o = !1;
    },
    d(s) {
      s && D(n), i.d(s);
    }
  };
}
function gr(e) {
  let t, n, o, i, s, r, l = ve(
    /*$store*/
    e[17].filter(
      /*func*/
      e[34]
    )
  ), a = [];
  for (let f = 0; f < l.length; f += 1)
    a[f] = Bn(Cn(e, l, f));
  const u = (f) => H(a[f], 1, 1, () => {
    a[f] = null;
  });
  let d = (
    /*drawingEl*/
    e[8] && Nn(e)
  );
  return {
    c() {
      t = L("svg"), n = L("g");
      for (let f = 0; f < a.length; f += 1)
        a[f].c();
      o = L("g"), d && d.c(), c(o, "class", "drawing"), c(t, "role", "application"), c(t, "tabindex", 0), c(t, "class", "a9s-annotationlayer"), Te(
        t,
        "drawing",
        /*tool*/
        e[15]
      ), Te(
        t,
        "editing",
        /*editableAnnotations*/
        e[5]
      ), Te(t, "hidden", !/*visible*/
      e[3]), Te(
        t,
        "hover",
        /*$hover*/
        e[16]
      );
    },
    m(f, h) {
      B(f, t, h), j(t, n);
      for (let g = 0; g < a.length; g += 1)
        a[g] && a[g].m(n, null);
      j(t, o), d && d.m(o, null), e[35](o), e[36](t), i = !0, s || (r = [
        W(t, "pointerup", function() {
          ie(
            /*onPointerUp*/
            e[11]
          ) && e[11].apply(this, arguments);
        }),
        W(t, "pointerdown", function() {
          ie(
            /*onPointerDown*/
            e[12]
          ) && e[12].apply(this, arguments);
        }),
        W(
          t,
          "pointermove",
          /*onPointerMove*/
          e[24]
        )
      ], s = !0);
    },
    p(f, h) {
      if (e = f, h[0] & /*$store, style, isEditable*/
      132098) {
        l = ve(
          /*$store*/
          e[17].filter(
            /*func*/
            e[34]
          )
        );
        let g;
        for (g = 0; g < l.length; g += 1) {
          const m = Cn(e, l, g);
          a[g] ? (a[g].p(m, h), U(a[g], 1)) : (a[g] = Bn(m), a[g].c(), U(a[g], 1), a[g].m(n, null));
        }
        for (we(), g = l.length; g < a.length; g += 1)
          u(g);
        be();
      }
      /*drawingEl*/
      e[8] ? d ? (d.p(e, h), h[0] & /*drawingEl*/
      256 && U(d, 1)) : (d = Nn(e), d.c(), U(d, 1), d.m(o, null)) : d && (we(), H(d, 1, 1, () => {
        d = null;
      }), be()), (!i || h[0] & /*tool*/
      32768) && Te(
        t,
        "drawing",
        /*tool*/
        e[15]
      ), (!i || h[0] & /*editableAnnotations*/
      32) && Te(
        t,
        "editing",
        /*editableAnnotations*/
        e[5]
      ), (!i || h[0] & /*visible*/
      8) && Te(t, "hidden", !/*visible*/
      e[3]), (!i || h[0] & /*$hover*/
      65536) && Te(
        t,
        "hover",
        /*$hover*/
        e[16]
      );
    },
    i(f) {
      if (!i) {
        for (let h = 0; h < l.length; h += 1)
          U(a[h]);
        U(d), i = !0;
      }
    },
    o(f) {
      a = a.filter(Boolean);
      for (let h = 0; h < a.length; h += 1)
        H(a[h]);
      H(d), i = !1;
    },
    d(f) {
      f && D(t), Ye(a, f), d && d.d(), e[35](null), e[36](null), s = !1, Se(r);
    }
  };
}
function mr(e, t, n) {
  let o, i, s, r, l, a, u, d, f, h, g, m, p = ee, k = () => (p(), p = jn(_, (V) => n(18, m = V)), _);
  e.$$.on_destroy.push(() => p());
  let { drawingEnabled: E } = t, { image: S } = t, { preferredDrawingMode: w } = t, { state: A } = t, { style: T = void 0 } = t, { toolName: C = uo()[0] } = t, { user: M } = t, { visible: R = !0 } = t, N = 0;
  const q = () => n(7, N += 1), F = () => C, v = () => E;
  let b, y, _;
  Ue(() => k(n(9, _ = zi(S, y))));
  const { hover: I, selection: P, store: O } = A;
  St(e, I, (V) => n(16, f = V)), St(e, P, (V) => n(33, h = V)), St(e, O, (V) => n(17, g = V));
  let G, X;
  const Z = (V) => {
    G && O.unobserve(G);
    const ce = V.filter(({ editable: $ }) => $).map(({ id: $ }) => $);
    ce.length > 0 ? (n(5, X = ce.map(($) => O.getAnnotation($)).filter(($) => $ && yt($))), G = ($) => {
      const { updated: fe } = $.changes;
      n(5, X = fe == null ? void 0 : fe.map((ye) => ye.newValue));
    }, O.observe(G, { annotations: ce })) : n(5, X = void 0);
  }, K = (V) => {
    const ce = oo(), $ = {
      id: ce,
      bodies: [],
      target: {
        annotation: ce,
        selector: V.detail,
        creator: M,
        created: /* @__PURE__ */ new Date()
      }
    };
    O.addAnnotation($), P.setSelected($.id);
  }, J = (V) => (ce) => {
    var Ve;
    const { target: $ } = V, fe = 10 * 60 * 1e3, ye = ((Ve = $.creator) == null ? void 0 : Ve.id) !== M.id || !$.created || (/* @__PURE__ */ new Date()).getTime() - $.created.getTime() > fe;
    O.updateTarget({
      ...$,
      selector: ce.detail,
      created: ye ? $.created : /* @__PURE__ */ new Date(),
      updated: ye ? /* @__PURE__ */ new Date() : void 0,
      updatedBy: ye ? M : void 0
    });
  }, te = (V) => {
    const { x: ce, y: $ } = ho(V, y), fe = O.getAt(ce, $, void 0, 2);
    fe ? f !== fe.id && I.set(fe.id) : I.set(void 0);
  }, oe = (V) => yt(V);
  function Ee(V) {
    gt[V ? "unshift" : "push"](() => {
      b = V, n(8, b);
    });
  }
  function ke(V) {
    gt[V ? "unshift" : "push"](() => {
      y = V, n(4, y);
    });
  }
  return e.$$set = (V) => {
    "drawingEnabled" in V && n(0, E = V.drawingEnabled), "image" in V && n(25, S = V.image), "preferredDrawingMode" in V && n(26, w = V.preferredDrawingMode), "state" in V && n(27, A = V.state), "style" in V && n(1, T = V.style), "toolName" in V && n(2, C = V.toolName), "user" in V && n(28, M = V.user), "visible" in V && n(3, R = V.visible);
  }, e.$$.update = () => {
    e.$$.dirty[0] & /*toolName*/
    4 && n(15, { tool: o, opts: i } = fo(C) || { tool: void 0, opts: void 0 }, o, (n(32, i), n(2, C))), e.$$.dirty[0] & /*preferredDrawingMode*/
    67108864 | e.$$.dirty[1] & /*opts*/
    2 && n(14, s = (i == null ? void 0 : i.drawingMode) || w), e.$$.dirty[0] & /*svgEl*/
    16 && n(13, r = or(y)), e.$$.dirty[0] & /*svgEl*/
    16 && n(12, { onPointerDown: l, onPointerUp: a } = sr(y, O), l, (n(11, a), n(4, y))), e.$$.dirty[1] & /*$selection*/
    4 && Z(h.selected), e.$$.dirty[0] & /*editableAnnotations*/
    32 && n(6, u = X ? X.map((V) => ({
      annotation: V,
      editor: vs(V.target.selector)
    })).filter((V) => V.editor) : void 0), e.$$.dirty[0] & /*editors*/
    64 && n(10, d = (V) => u && u.some((ce) => ce.annotation.id === V.id));
  }, [
    E,
    T,
    C,
    R,
    y,
    X,
    u,
    N,
    b,
    _,
    d,
    a,
    l,
    r,
    s,
    o,
    f,
    g,
    m,
    I,
    P,
    O,
    K,
    J,
    te,
    S,
    w,
    A,
    M,
    q,
    F,
    v,
    i,
    h,
    oe,
    Ee,
    ke
  ];
}
class pr extends pe {
  constructor(t) {
    super(), me(
      this,
      t,
      mr,
      gr,
      se,
      {
        drawingEnabled: 0,
        image: 25,
        preferredDrawingMode: 26,
        state: 27,
        style: 1,
        toolName: 2,
        user: 28,
        visible: 3,
        cancelDrawing: 29,
        getDrawingTool: 30,
        isDrawingEnabled: 31
      },
      null,
      [-1, -1]
    );
  }
  get cancelDrawing() {
    return this.$$.ctx[29];
  }
  get getDrawingTool() {
    return this.$$.ctx[30];
  }
  get isDrawingEnabled() {
    return this.$$.ctx[31];
  }
}
function go(e, t, n = 0, o = e.length - 1, i = yr) {
  for (; o > n; ) {
    if (o - n > 600) {
      const a = o - n + 1, u = t - n + 1, d = Math.log(a), f = 0.5 * Math.exp(2 * d / 3), h = 0.5 * Math.sqrt(d * f * (a - f) / a) * (u - a / 2 < 0 ? -1 : 1), g = Math.max(n, Math.floor(t - u * f / a + h)), m = Math.min(o, Math.floor(t + (a - u) * f / a + h));
      go(e, t, g, m, i);
    }
    const s = e[t];
    let r = n, l = o;
    for (Ze(e, n, t), i(e[o], s) > 0 && Ze(e, n, o); r < l; ) {
      for (Ze(e, r, l), r++, l--; i(e[r], s) < 0; ) r++;
      for (; i(e[l], s) > 0; ) l--;
    }
    i(e[n], s) === 0 ? Ze(e, n, l) : (l++, Ze(e, l, o)), l <= t && (n = l + 1), t <= l && (o = l - 1);
  }
}
function Ze(e, t, n) {
  const o = e[t];
  e[t] = e[n], e[n] = o;
}
function yr(e, t) {
  return e < t ? -1 : e > t ? 1 : 0;
}
class _r {
  constructor(t = 9) {
    this._maxEntries = Math.max(4, t), this._minEntries = Math.max(2, Math.ceil(this._maxEntries * 0.4)), this.clear();
  }
  all() {
    return this._all(this.data, []);
  }
  search(t) {
    let n = this.data;
    const o = [];
    if (!ct(t, n)) return o;
    const i = this.toBBox, s = [];
    for (; n; ) {
      for (let r = 0; r < n.children.length; r++) {
        const l = n.children[r], a = n.leaf ? i(l) : l;
        ct(t, a) && (n.leaf ? o.push(l) : Rt(t, a) ? this._all(l, o) : s.push(l));
      }
      n = s.pop();
    }
    return o;
  }
  collides(t) {
    let n = this.data;
    if (!ct(t, n)) return !1;
    const o = [];
    for (; n; ) {
      for (let i = 0; i < n.children.length; i++) {
        const s = n.children[i], r = n.leaf ? this.toBBox(s) : s;
        if (ct(t, r)) {
          if (n.leaf || Rt(t, r)) return !0;
          o.push(s);
        }
      }
      n = o.pop();
    }
    return !1;
  }
  load(t) {
    if (!(t && t.length)) return this;
    if (t.length < this._minEntries) {
      for (let o = 0; o < t.length; o++)
        this.insert(t[o]);
      return this;
    }
    let n = this._build(t.slice(), 0, t.length - 1, 0);
    if (!this.data.children.length)
      this.data = n;
    else if (this.data.height === n.height)
      this._splitRoot(this.data, n);
    else {
      if (this.data.height < n.height) {
        const o = this.data;
        this.data = n, n = o;
      }
      this._insert(n, this.data.height - n.height - 1, !0);
    }
    return this;
  }
  insert(t) {
    return t && this._insert(t, this.data.height - 1), this;
  }
  clear() {
    return this.data = Fe([]), this;
  }
  remove(t, n) {
    if (!t) return this;
    let o = this.data;
    const i = this.toBBox(t), s = [], r = [];
    let l, a, u;
    for (; o || s.length; ) {
      if (o || (o = s.pop(), a = s[s.length - 1], l = r.pop(), u = !0), o.leaf) {
        const d = wr(t, o.children, n);
        if (d !== -1)
          return o.children.splice(d, 1), s.push(o), this._condense(s), this;
      }
      !u && !o.leaf && Rt(o, i) ? (s.push(o), r.push(l), l = 0, a = o, o = o.children[0]) : a ? (l++, o = a.children[l], u = !1) : o = null;
    }
    return this;
  }
  toBBox(t) {
    return t;
  }
  compareMinX(t, n) {
    return t.minX - n.minX;
  }
  compareMinY(t, n) {
    return t.minY - n.minY;
  }
  toJSON() {
    return this.data;
  }
  fromJSON(t) {
    return this.data = t, this;
  }
  _all(t, n) {
    const o = [];
    for (; t; )
      t.leaf ? n.push(...t.children) : o.push(...t.children), t = o.pop();
    return n;
  }
  _build(t, n, o, i) {
    const s = o - n + 1;
    let r = this._maxEntries, l;
    if (s <= r)
      return l = Fe(t.slice(n, o + 1)), Ge(l, this.toBBox), l;
    i || (i = Math.ceil(Math.log(s) / Math.log(r)), r = Math.ceil(s / Math.pow(r, i - 1))), l = Fe([]), l.leaf = !1, l.height = i;
    const a = Math.ceil(s / r), u = a * Math.ceil(Math.sqrt(r));
    Vn(t, n, o, u, this.compareMinX);
    for (let d = n; d <= o; d += u) {
      const f = Math.min(d + u - 1, o);
      Vn(t, d, f, a, this.compareMinY);
      for (let h = d; h <= f; h += a) {
        const g = Math.min(h + a - 1, f);
        l.children.push(this._build(t, h, g, i - 1));
      }
    }
    return Ge(l, this.toBBox), l;
  }
  _chooseSubtree(t, n, o, i) {
    for (; i.push(n), !(n.leaf || i.length - 1 === o); ) {
      let s = 1 / 0, r = 1 / 0, l;
      for (let a = 0; a < n.children.length; a++) {
        const u = n.children[a], d = Ut(u), f = vr(t, u) - d;
        f < r ? (r = f, s = d < s ? d : s, l = u) : f === r && d < s && (s = d, l = u);
      }
      n = l || n.children[0];
    }
    return n;
  }
  _insert(t, n, o) {
    const i = o ? t : this.toBBox(t), s = [], r = this._chooseSubtree(i, this.data, n, s);
    for (r.children.push(t), Qe(r, i); n >= 0 && s[n].children.length > this._maxEntries; )
      this._split(s, n), n--;
    this._adjustParentBBoxes(i, s, n);
  }
  // split overflowed node into two
  _split(t, n) {
    const o = t[n], i = o.children.length, s = this._minEntries;
    this._chooseSplitAxis(o, s, i);
    const r = this._chooseSplitIndex(o, s, i), l = Fe(o.children.splice(r, o.children.length - r));
    l.height = o.height, l.leaf = o.leaf, Ge(o, this.toBBox), Ge(l, this.toBBox), n ? t[n - 1].children.push(l) : this._splitRoot(o, l);
  }
  _splitRoot(t, n) {
    this.data = Fe([t, n]), this.data.height = t.height + 1, this.data.leaf = !1, Ge(this.data, this.toBBox);
  }
  _chooseSplitIndex(t, n, o) {
    let i, s = 1 / 0, r = 1 / 0;
    for (let l = n; l <= o - n; l++) {
      const a = Je(t, 0, l, this.toBBox), u = Je(t, l, o, this.toBBox), d = Sr(a, u), f = Ut(a) + Ut(u);
      d < s ? (s = d, i = l, r = f < r ? f : r) : d === s && f < r && (r = f, i = l);
    }
    return i || o - n;
  }
  // sorts node children by the best axis for split
  _chooseSplitAxis(t, n, o) {
    const i = t.leaf ? this.compareMinX : br, s = t.leaf ? this.compareMinY : Er, r = this._allDistMargin(t, n, o, i), l = this._allDistMargin(t, n, o, s);
    r < l && t.children.sort(i);
  }
  // total margin of all possible split distributions where each node is at least m full
  _allDistMargin(t, n, o, i) {
    t.children.sort(i);
    const s = this.toBBox, r = Je(t, 0, n, s), l = Je(t, o - n, o, s);
    let a = at(r) + at(l);
    for (let u = n; u < o - n; u++) {
      const d = t.children[u];
      Qe(r, t.leaf ? s(d) : d), a += at(r);
    }
    for (let u = o - n - 1; u >= n; u--) {
      const d = t.children[u];
      Qe(l, t.leaf ? s(d) : d), a += at(l);
    }
    return a;
  }
  _adjustParentBBoxes(t, n, o) {
    for (let i = o; i >= 0; i--)
      Qe(n[i], t);
  }
  _condense(t) {
    for (let n = t.length - 1, o; n >= 0; n--)
      t[n].children.length === 0 ? n > 0 ? (o = t[n - 1].children, o.splice(o.indexOf(t[n]), 1)) : this.clear() : Ge(t[n], this.toBBox);
  }
}
function wr(e, t, n) {
  if (!n) return t.indexOf(e);
  for (let o = 0; o < t.length; o++)
    if (n(e, t[o])) return o;
  return -1;
}
function Ge(e, t) {
  Je(e, 0, e.children.length, t, e);
}
function Je(e, t, n, o, i) {
  i || (i = Fe(null)), i.minX = 1 / 0, i.minY = 1 / 0, i.maxX = -1 / 0, i.maxY = -1 / 0;
  for (let s = t; s < n; s++) {
    const r = e.children[s];
    Qe(i, e.leaf ? o(r) : r);
  }
  return i;
}
function Qe(e, t) {
  return e.minX = Math.min(e.minX, t.minX), e.minY = Math.min(e.minY, t.minY), e.maxX = Math.max(e.maxX, t.maxX), e.maxY = Math.max(e.maxY, t.maxY), e;
}
function br(e, t) {
  return e.minX - t.minX;
}
function Er(e, t) {
  return e.minY - t.minY;
}
function Ut(e) {
  return (e.maxX - e.minX) * (e.maxY - e.minY);
}
function at(e) {
  return e.maxX - e.minX + (e.maxY - e.minY);
}
function vr(e, t) {
  return (Math.max(t.maxX, e.maxX) - Math.min(t.minX, e.minX)) * (Math.max(t.maxY, e.maxY) - Math.min(t.minY, e.minY));
}
function Sr(e, t) {
  const n = Math.max(e.minX, t.minX), o = Math.max(e.minY, t.minY), i = Math.min(e.maxX, t.maxX), s = Math.min(e.maxY, t.maxY);
  return Math.max(0, i - n) * Math.max(0, s - o);
}
function Rt(e, t) {
  return e.minX <= t.minX && e.minY <= t.minY && t.maxX <= e.maxX && t.maxY <= e.maxY;
}
function ct(e, t) {
  return t.minX <= e.maxX && t.minY <= e.maxY && t.maxX >= e.minX && t.maxY >= e.minY;
}
function Fe(e) {
  return {
    children: e,
    height: 1,
    leaf: !0,
    minX: 1 / 0,
    minY: 1 / 0,
    maxX: -1 / 0,
    maxY: -1 / 0
  };
}
function Vn(e, t, n, o, i) {
  const s = [t, n];
  for (; s.length; ) {
    if (n = s.pop(), t = s.pop(), n - t <= o) continue;
    const r = t + Math.ceil((n - t) / o / 2) * o;
    go(e, r, t, n, i), s.push(t, r, r, n);
  }
}
const Ar = () => {
  const e = new _r(), t = /* @__PURE__ */ new Map(), n = () => [...t.values()], o = () => {
    e.clear(), t.clear();
  }, i = (f) => {
    if (!ht(f)) return;
    const { minX: h, minY: g, maxX: m, maxY: p } = f.selector.geometry.bounds, k = { minX: h, minY: g, maxX: m, maxY: p, target: f };
    e.insert(k), t.set(f.annotation, k);
  }, s = (f) => {
    if (!ht(f)) return;
    const h = t.get(f.annotation);
    h && e.remove(h), t.delete(f.annotation);
  };
  return {
    all: n,
    clear: o,
    getAt: (f, h, g = 0) => {
      const p = e.search({
        minX: f - g,
        minY: h - g,
        maxX: f + g,
        maxY: h + g
      }).map((k) => k.target).filter((k) => k.selector.type === x.RECTANGLE || Co(k.selector, f, h, g));
      return p.length > 0 ? (p.sort((k, E) => Gt(k.selector) - Gt(E.selector)), p) : [];
    },
    getIntersecting: (f, h, g, m) => e.search({
      minX: f,
      minY: h,
      maxX: f + g,
      maxY: h + m
    }).map((p) => p.target),
    insert: i,
    remove: s,
    set: (f, h = !0) => {
      h && o();
      const g = f.reduce((m, p) => {
        if (ht(p)) {
          const { minX: k, minY: E, maxX: S, maxY: w } = p.selector.geometry.bounds;
          return [...m, { minX: k, minY: E, maxX: S, maxY: w, target: p }];
        } else
          return m;
      }, []);
      g.forEach((m) => t.set(m.target.annotation, m)), e.load(g);
    },
    size: () => e.all().length,
    update: (f, h) => {
      s(f), i(h);
    }
  };
}, kr = (e) => ({
  ...e,
  subscribe: (n) => {
    const o = (i) => n(i.state);
    return e.observe(o), n(e.all()), () => e.unobserve(o);
  }
}), Mr = (e) => {
  const t = Si(), n = Ar(), o = ci(t, e.userSelectAction, e.adapter), i = ai(t), s = Ti();
  return t.observe(({ changes: a }) => {
    n.set((a.created || []).map((u) => u.target), !1), (a.deleted || []).forEach((u) => n.remove(u.target)), (a.updated || []).forEach(({ oldValue: u, newValue: d }) => n.update(u.target, d.target));
  }), {
    store: {
      ...t,
      getAt: (a, u, d, f) => {
        const h = n.getAt(a, u, f);
        if (d)
          return h.map((m) => t.getAnnotation(m.annotation)).filter(Boolean).filter(d)[0];
        {
          const g = h[0];
          return g ? t.getAnnotation(g.annotation) : void 0;
        }
      },
      getIntersecting: (a, u, d, f) => n.getIntersecting(a, u, d, f).map((h) => t.getAnnotation(h.annotation)).filter(Boolean)
    },
    selection: o,
    hover: i,
    viewport: s
  };
}, Tr = (e) => {
  const t = Mr(e);
  return {
    ...t,
    store: kr(t.store)
  };
}, Pr = (e) => {
  let t, n;
  if (e.nodeName === "CANVAS")
    t = e, n = t.getContext("2d", { willReadFrequently: !0 });
  else {
    const i = e;
    t = document.createElement("canvas"), t.width = i.width, t.height = i.height, n = t.getContext("2d", { willReadFrequently: !0 }), n.drawImage(i, 0, 0, i.width, i.height);
  }
  let o = 0;
  for (let i = 1; i < 10; i++)
    for (let s = 1; s < 10; s++) {
      const r = Math.round(s * t.width / 10), l = Math.round(i * t.height / 10), a = n.getImageData(r, l, 1, 1).data, u = (0.299 * a[0] + 0.587 * a[1] + 0.114 * a[2]) / 255;
      o += u;
    }
  return o / 81;
}, Lr = (e) => {
  const t = Pr(e), n = t > 0.6 ? "dark" : "light";
  return console.log(`[Annotorious] Image brightness: ${t.toFixed(1)}. Setting ${n} theme.`), n;
}, Xn = (e, t, n) => t.setAttribute("data-theme", n === "auto" ? Lr(e) : n), Ir = (e, t) => ({
  ...e,
  drawingEnabled: e.drawingEnabled === void 0 ? t.drawingEnabled : e.drawingEnabled,
  drawingMode: e.drawingMode || t.drawingMode,
  userSelectAction: e.userSelectAction || t.userSelectAction,
  theme: e.theme || t.theme
}), Hn = typeof navigator > "u" ? !1 : navigator.userAgent.indexOf("Mac OS X") !== -1, Cr = (e, t) => {
  const n = t || document, o = (r) => {
    const l = r;
    l.key === "z" && l.ctrlKey ? e.undo() : l.key === "y" && l.ctrlKey && e.redo();
  }, i = (r) => {
    const l = r;
    l.key === "z" && l.metaKey && (l.shiftKey ? e.redo() : e.undo());
  }, s = () => {
    Hn ? n.removeEventListener("keydown", i) : n.removeEventListener("keydown", o);
  };
  return Hn ? n.addEventListener("keydown", i) : n.addEventListener("keydown", o), {
    destroy: s
  };
}, Hr = (e, t = {}) => {
  if (!e)
    throw "Missing argument: image";
  const n = typeof e == "string" ? document.getElementById(e) : e, o = Ir(t, {
    drawingEnabled: !0,
    drawingMode: "drag",
    userSelectAction: io.EDIT,
    theme: "light"
  }), i = Tr(o), { selection: s, store: r } = i, l = Mi(r, o.initialHistory), a = Pi(
    i,
    l,
    o.adapter,
    o.autoSave
  ), u = document.createElement("DIV");
  u.style.position = "relative", u.style.display = "inline-block", n.style.display = "block", n.parentNode.insertBefore(u, n), u.appendChild(n);
  const d = Cr(l);
  let f = Yi();
  Xn(n, u, o.theme);
  const h = new pr({
    target: u,
    props: {
      drawingEnabled: !!o.drawingEnabled,
      image: n,
      preferredDrawingMode: o.drawingMode,
      state: i,
      style: o.style,
      user: f
    }
  });
  h.$on("click", (b) => {
    const { originalEvent: y, annotation: _ } = b.detail;
    _ ? s.userSelect(_.id, y) : s.isEmpty() || s.clear();
  });
  const g = Ii(i, l, o.adapter), m = () => h.cancelDrawing(), p = () => {
    h.$destroy(), u.parentNode.insertBefore(n, u), u.parentNode.removeChild(u), d.destroy(), l.destroy();
  }, k = () => h.getDrawingTool(), E = () => f, S = () => h.isDrawingEnabled(), w = (b, y, _) => Ys(b, y, _), A = (b, y) => Ss(b, y), T = (b) => {
    if (!fo(b))
      throw `No drawing tool named ${b}`;
    h.$set({ toolName: b });
  }, C = (b) => h.$set({ drawingEnabled: b }), M = (b) => h.$set({ preferredDrawingMode: b }), R = (b) => {
    console.warn("Filter not implemented yet");
  }, N = (b) => h.$set({ style: b }), q = (b) => Xn(n, u, b), F = (b) => {
    f = b, h.$set({ user: b });
  }, v = (b) => (
    // @ts-ignore
    h.$set({ visible: b })
  );
  return {
    ...g,
    cancelDrawing: m,
    destroy: p,
    getDrawingTool: k,
    getUser: E,
    isDrawingEnabled: S,
    listDrawingTools: uo,
    on: a.on,
    off: a.off,
    registerDrawingTool: w,
    registerShapeEditor: A,
    setDrawingEnabled: C,
    setDrawingMode: M,
    setDrawingTool: T,
    setFilter: R,
    setStyle: N,
    setTheme: q,
    setUser: F,
    setVisible: v,
    element: u,
    state: i
  };
};
export {
  Kt as Editor,
  ks as EditorMount,
  qe as Handle,
  Xr as IdentityTransform,
  ao as MidpointHandle,
  cs as PolygonEditor,
  hs as RectangleEditor,
  Xo as RectangleUtil,
  Is as RubberbandRectangle,
  pr as SVGAnnotationLayer,
  x as ShapeType,
  Ts as ToolMount,
  io as UserSelectAction,
  Vr as W3CImageFormat,
  sr as addEventListeners,
  jt as approximateAsPolygon,
  dt as boundsFromMultiPolygonElements,
  ge as boundsFromPoints,
  Ur as chainStyles,
  Gt as computeArea,
  mt as computePolygonArea,
  eo as computeSVGPath,
  Yr as computeStyle,
  Nr as createBody,
  Hr as createImageAnnotator,
  Mr as createImageAnnotatorState,
  or as createSVGTransform,
  Tr as createSvelteImageAnnotatorState,
  Rr as defaultColorProvider,
  Lr as detectTheme,
  ft as distance,
  zi as enableResponsive,
  Ir as fillDefaults,
  Yo as getAllCorners,
  vs as getEditor,
  wt as getMaskDimensions,
  ho as getSVGPoint,
  fo as getTool,
  Cr as initKeyboardCommands,
  Co as intersects,
  Ho as isFragmentSelector,
  yt as isImageAnnotation,
  ht as isImageAnnotationTarget,
  Hn as isMac,
  pt as isPointInPolygon,
  Le as isTouch,
  uo as listDrawingTools,
  Pe as multipolygonElementToPath,
  Go as parseFragmentSelector,
  $o as parseSVGSelector,
  Hi as parseW3CImageAnnotation,
  Oo as pointsToPath,
  Ss as registerEditor,
  We as registerShapeUtil,
  Ys as registerTool,
  Pr as sampleBrightness,
  jo as serializeFragmentSelector,
  ti as serializeSVGSelector,
  Gi as serializeW3CImageAnnotation,
  Xn as setTheme,
  Dr as simplifyMultiPolygon,
  xn as simplifyPoints,
  Br as simplifyPolygon,
  kr as toSvelteStore
};
//# sourceMappingURL=annotorious.es.js.map
